import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useLanguageStore } from '@/stores/language'

export const useTranslaterStore = defineStore('translater', () => {
    const languageStorage = useLanguageStore()

    const lang = computed(() => languageStorage.lang)
    const getTranslate = computed(() => translates[lang.value])

    const translates = {
        RU: {
            APP_NAME: 'Sky web',

            SEARCH: 'Поиск',

            PAGINATOR_PAGE: 'Страница',

            LOAD_FILE: 'Загрузите файл',

            YES: 'Да',
            NO: 'Нет',

            PHONE: 'Телефон',
            EMAIL: 'E-mail',

            START: 'Старт',
            STOP: 'Стоп',
            FINISH: 'Финиш',

            NO_FAILURE: 'Нет ошибок',

            // Единицы измерений
            UNIT_KM: 'км',
            UNIT_KMH: 'км/ч',
            UNIT_METRE: 'м',
            UNIT_DAY: 'д.',
            UNIT_HOUR: 'ч.',
            UNIT_MINUTE: 'мин.',
            UNIT_SECOND: 'с',
            UNIT_SECOND_LONG: 'сек.',
            UNIT_LITER: 'л',
            UNIT_LITER_100_KM: 'л/100км',
            UNIT_KVH_100_KM: 'кВт/100км',
            UNIT_ML: 'мл',
            UNIT_ATM: 'атм',
            UNIT_BAR: 'Бар',
            UNIT_RPM: 'об/мин',
            UNIT_VOLT: 'В',
            UNIT_WATT: 'Ватт',
            UNIT_WATT_HOUR: 'Вт/ч',
            UNIT_KWATT: 'кВт',
            UNIT_KWATT_HOUR: 'кВт/ч',
            UNIT_A: 'А',
            UNIT_MA: 'мА',

            USER_ATTRS_NAVI: 'Навигационная информация',
            USER_ATTRS_REMOTE: 'Удалённое управление',

            // Текст форм
            FORM_REQUIRED: 'Поля обязательные для заполнения',
            FORM_ENTER: 'Введите значение',
            FORM_SELECT_COLOR: 'Выберите цвет из списка',
            FORM_SELECT: 'Выберите из списка',
            FORM_SEARCH: 'Поиск',

            // Текст кнопок
            BTN_ADD: 'Добавить',
            BTN_CREATE: 'Создать',
            BTN_NEW: 'Новый',
            BTN_EDIT: 'Редактировать',
            BTN_SAVE: 'Сохранить',
            BTN_READMORE: 'Перейти',
            BTN_CANCEL: 'Отмена',
            BTN_DELETE: 'Удалить',
            BTN_CTRL: 'Управление',
            BTN_REQUEST: 'Запросить',
            BTN_SHOW: 'Показать',
            BTN_UPLOAD: 'Загрузить',
            BTN_DOWNLOAD: 'Скачать',
            BTN_CLOSE: 'Закрыть',
            BTN_SELECT: 'Выбрать',
            BTN_EXPORT: 'Экспорт',
            BTN_FAVORITES: 'Избранное',
            BTN_RESET: 'Сбросить',
            BTN_SEND: 'Послать',
            BTN_MORE: 'Подробнее',
            BTN_UPDATE: 'Обновить',
            BTN_UNLINK: 'Отвязать',
            BTN_CHANGE: 'Изменить',
            BTN_REISSUE: 'Перевыпустить',
            BTN_MAP: 'Карта',
            BTN_SUBSCRIBE: 'Подписаться',

            // Дни недели и "быстрые даты"
            MONDAY: 'Понедельник',
            TUESDAY: 'Вторник',
            WEDNESDAY: 'Среда',
            THIRSDAY: 'Четверг',
            FRIDAY: 'Пятница',
            SATURDAY: 'Суббота',
            SUNDAY: 'Воскресенье',
            TODAY: 'Сегодня',
            YESTERDAY: 'Вчера',
            DAY_BEFORE_YESTERDAY: 'Позавчера',
            IN_A_WEEK: 'За неделю',

            BREADCRUMBS: 'Навигатор',

            // Уровни жидкостей
            LEVEL_CRITICAL_LOW: 'Критически низкий уровень',
            LEVEL_LOW: 'Низкий уровень',
            LEVEL_NORMAL: 'Нормальный уровень',
            LEVEL_HIGH: 'Высокий уровень',

            // Главное меню
            MENU_AUTH: 'Авторизация',
            MENU_REGISTRATION: 'Регистрация',
            MENU_FORGOT: 'Одноразовый вход',
            MENU_MAIN: 'Главная',
            MENU_CARS: 'Автомобили',
            MENU_AREAS: 'Геозоны',
            MENU_FIRMWARES: 'Прошивки',
            MENU_FIRMWARE: 'Прошивкa',
            MENU_GUIDE: 'Справочник',
            MENU_USERS: 'Пользователи',
            MENU_USER: 'Пользователь',
            MENU_GROUPS: 'Группы',
            MENU_USER_CHANGE_PASSWORD: 'Сменить пароль',

            // Меню автомобиля
            CARMENU_INFO: 'Информация',
            CARMENU_MAP: 'Карта',
            CARMENU_AREAS: 'Геозоны',
            CARMENU_TRIPS: 'Поездки',
            CARMENU_STATE: 'Состояние',
            CARMENU_ECUS: 'ЭБУ',
            CARMENU_ECU: 'ЭБУ',
            CARMENU_SDM: 'SDM',
            CARMENU_LOGS: 'Логи',
            CARMENU_RIGHTS: 'Права и доступ',
            CARMENU_CHARGING: 'Зарядки',
            CARMENU_EVENTS: 'События',
            CARMENU_HISTORY: 'История показаний',

            // Меню группы пользователей
            MENU_USERS_GROUP: 'Группа пользователей',
            MENU_USERS_GROUP_INFO: 'Информация',
            MENU_USERS_GROUP_USERS: 'Пользователи',
            MENU_USERS_GROUP_CARS: 'Автомобили',
            MENU_USERS_GROUP_CARS_GROUPS: 'Группы автомобилей',

            // Меню группы автомобилей
            MENU_CARS_GROUP_INFO: 'Информация',
            MENU_CARS_GROUP_CARS: 'Автомобили',
            MENU_CARS_GROUP_USERS_GROUPS: 'Группы пользователей',

            // Группа автомобилей
            CARS_GROUP_UPDATE_SUCCESS: 'Группа автомобилей успешно обновлена',

            // Заголовки страниц
            PAGE_MAIN: 'Главная',
            PAGE_CARS: 'Автомобили',
            PAGE_USERS: 'Пользователи',
            PAGE_USER_CREARE: 'Новый пользователь',
            PAGE_PROFILE: 'Профиль',
            PAGE_LOGS: 'Логи',
            PAGE_GUIDE: 'Справочник',
            PAGE_CAR: 'Автомобиль',
            PAGE_CAR_INFO: 'Информация',
            PAGE_CAR_ECU: 'Электронные блоки',
            PAGE_CAR_MAP: 'Карта',
            PAGE_CAR_STATE: 'Состояние',
            PAGE_CAR_USERS: 'Пользователи',
            PAGE_CAR_LOGS: 'Логи',
            PAGE_CAR_EVENTS: 'События',
            PAGE_CAR_AREAS: 'Геозоны',
            PAGE_CAR_HISTORY: 'История показаний приборов и датчиков',
            PAGE_FIRMWARES: 'Прошивки',
            PAGE_CAR_RIGHTS: 'Права и доступ',
            PAGE_GROUPS: 'Группы',
            PAGE_GROUP_INFO: 'Информация о группе',
            PAGE_GROUP_CARS: 'Автомобили группы',
            PAGE_GROUP_USERS: 'Пользователи группы',
            PAGE_USER_CARS: 'Автомоблили пользователя',
            PAGE_TEST: 'Тестовая форма',

            // Авторизация и одноразовый вход
            AUTHORIZATION: 'Авторизация',
            LOGIN: 'Логин',
            LOGIN_SHORT: 'Логин должен быть длиннее 6 знаков',
            PASSWORD: 'Пароль',
            PASSWORD_SHORT: 'Пароль должен быть длиннее 6 знаков',
            SMART_CAPTCHA_VALUE: 'Докажите, что вы не робот',
            SMART_CAPTCHA_POLICY: 'Мы используем',
            SMART_CAPTCHA_ERROR_LOAD: 'Ошибка загрузки скрипта',
            SMART_CAPTCHA_ERROR_JS: 'Ошибка при попытке проверки сaptcha',
            SMART_CAPTCHA_ERROR_NETWORK: 'Ошибка загрузки captcha',
            SMART_CAPTCHA_ERROR_METHOD: 'Метод window.smartCaptcha не найден',
            AUTHORIZATE: 'Войти в систему',
            SINGLE_AUTH: 'Одноразовый вход',
            EMAIL: 'E-mail',
            EMAIL_CODE: 'Код из письма/смс',
            EMAIL_SHORT: 'E-mail должен быть длиннее 6 символов',
            REQUEST_PASSWORD: 'Запросить пароль',

            // Регистрация пользователя
            REGISTRATION: 'Регистрация',
            REGISTRATION_FIRLSNAME: 'Имя',
            REGISTRATION_LASTNAME: 'Фамилия',
            REGISTRATION_SURNAME: 'Отчество',
            REGISTRATION_EMAIL: 'Электронная почта',
            REGISTRATION_PHONE: 'Телефон',
            REGISTRATION_PASS: 'Пароль',
            REGISTRATION_PASS_REPEAT: 'Повторите пароль',
            REGISTRATION_SUCCESS:
                'Ваша заявка на регистрацию принята. Для активациии Вашей учётной записи перейдите по ссылки из письма, отправленного на указанный вами адрес электронной почты.',
            REGISTRATION_VERIFY_SUCCESS: 'Ваш e-mail успешно подтверждён',
            REGISTRATION_VERIFIED: 'Ваша учётная запись успешно активирована',

            GROUP_NAME: 'Имя',
            GROUP_DESCR: 'Описание',
            GROUP_TYPES: 'Права группы',
            GROUP_INFO: 'Информация',

            // Права пользователей
            RIGHTS: 'Права',
            READ: 'Чтение',
            READ_WRITE: 'Чтение и запись',
            READ_WRITE_DELETE: 'Чтение, запись и удаление',
            NO_ACCESS: 'Нет прав',
            NO_RIGHT: 'Нет прав',
            RIGHT_BLOCKED: 'Заблокирован',
            NONE: 'Нет прав',
            USER_RIGHTS_READ: 'Чтение',
            USER_RIGHTS_APPEND: 'Добавление',
            USER_RIGHTS_WRITE: 'Редактирование',
            USER_RIGHTS_DELETE: 'Удаление',
            USER_RIGHTS_PRIVATE: 'Приватные данные',
            USER_RIGHTS_POINT: 'Точки',
            USER_RIGHTS_STATE: 'Состояния',
            USER_RIGHTS_COORDS: 'Координаты',
            USER_RIGHTS_CMD: 'Отправка команд',

            // Типы пользователей
            USER_TYPE_USER: 'Пользователь',
            USER_TYPE_EXPERT: 'Эксперт',
            USER_TYPE_SUPER: 'Администратор',
            USER_TYPE_SUPER_DESCR: 'ВНИМАНИЕ! Этот пользователь получит полный контроль над приложением.',

            // Группы пользователей
            USERS_GROUPS_EMPTY: 'Группы не найдены',
            USERS_GROUPS_INFO: 'Информация о группе',
            USERS_GROUPS: 'Группы пользователей',
            USERS_GROUPS_NAME: 'Название группы',
            USERS_GROUPS_DESCR: 'Описание',
            USERS_GROUPS_CREATE: 'Создать группу пользователей',
            USERS_GROUPS_CREATE_SUCCESS: 'Группа пользователей успешно создана',
            USERS_GROUPS_CREATE_NAME: 'Название',
            USERS_GROUPS_CREATE_DESCR: 'Описание',
            USERS_GROUPS_DELETE: 'Удаление группы',
            USERS_GROUPS_DELETE_DESCR:
                'Эта группа будет удалена без возможности восстановления. Вы уверены, что хотите удалить её?',
            USERS_GROUPS_DELETE_SUCCESS: 'Группа успешно удалена',

            USERS_GROUPS_USERS: 'Пользователи группы',
            USERS_GROUPS_USERS_CREATE: 'Добавить пользователя',
            USERS_GROUPS_USERS_CREATE_SUCCESS: 'Пользователь добавлен в группу',
            USERS_GROUPS_USERS_DELETE: 'Удаление пользователя группы',
            USERS_GROUPS_USERS_DELETE_DESCR:
                'Пользователь будет безвозвратно удалён из группы. Вы уверены, что хотите удалить его?',
            USERS_GROUPS_USERS_DELETE_SUCCESS: 'Пользователь успешно удалён из группы',
            USERS_GROUPS_USERS_SESSION:
                'При добавлении/удалении пользователей все их сессии будут удалены. Им будет необходимо повторно пройти авторизацию на всех устройствах.',

            USERS_GROUPS_CARS_GROUPS: 'Группы автомобилей',
            USERS_GROUPS_CARS_GROUPS_EMPTY: 'Связей не найдено',
            USERS_GROUPS_CARS_GROUPS_CREATE: 'Привязать группу',
            USERS_GROUPS_CARS_GROUPS_CREATE_SUCCESS: 'Группы привязана',
            USERS_GROUPS_CARS_GROUPS_UPDATE_SUCCESS: 'Группа автомобилей отредактирована',
            USERS_GROUPS_CARS_GROUPS_DELETE: 'Удаление группы автомобилей',
            USERS_GROUPS_CARS_GROUPS_DELETE_DESCR:
                'Эта группа автомобилей будет отвязана от выбранной группы пользователей. Вы уверены, что хотите сделать это?',
            USERS_GROUPS_CARS_GROUPS_DELETE_SUCCESS: 'Группа автомобилей отвязана от выбранной группы пользователей',

            USERS_GROUPS_CARS: 'Автомобили группы пользователей',
            USERS_GROUPS_CARS_CREATE: 'Добавить автомобиль в группу',
            USERS_GROUPS_CARS_CREATE_SUCCESS: 'Автомобиль добавлен в группу',
            USERS_GROUPS_CARS_UPDATE_SUCCESS: 'Автомобиль группы отредактирован',
            USERS_GROUPS_CARS_DELETE: 'Удаление из группы',
            USERS_GROUPS_CARS_DELETE_DESCR:
                'Этот автомобиль будет удалён из группы. Вы уверены, что хотите сделать это?',
            USERS_GROUPS_CARS_DELETE_SUCCESS: 'Автомобиль удалён из группы',

            // Пользователи
            USERS_NAME: 'Имя',
            USERS_MID_NAME: 'Отчество',
            USERS_LAST_NAME: 'Фамилия',
            USERS_APPERAL: 'Обращение',
            USERS_TYPE: 'Тип',
            USERS_GROUP: 'Группа',
            USERS_EMAIL: 'E-mail',
            USERS_PHONE: 'Телефон',

            // Создание пользователя
            USER_CREATE_NAME: 'Имя',
            USER_CREATE_MID_NAME: 'Отчество',
            USER_CREATE_LAST_NAME: 'Фамилия',
            USER_CREATE_ATTR: 'Атрибуты',
            USER_CREATE_TYPE: 'Тип',
            USER_CREATE_GROUP: 'Группа',
            USER_CREATE_GROUP_EMPTY: 'Нет группы',
            USER_CREATE_GROUP_NEW: 'Новая группа',
            USER_CREATE_GROUP_NEW_NAME: 'Название',
            USER_CREATE_GROUP_NEW_DESCR: 'Описание',
            USER_CREATE_EMAIL: 'E-mail',
            USER_CREATE_PHONE: 'Телефон',
            USER_CREATE_PASS: 'Пароль',
            USER_CREATE_PASS_REPEAT: 'Повторите пароль',
            USER_CREATE_PASS_DESCR: 'Минимум 6 символов, 1 строчная и 1 заглавная буква, любые печатные символы.',

            // Пользователи и профиль
            PROFILE: 'Профиль',
            LOGOUT: 'Выйти',
            USER: 'Пользователь',
            USERS: 'Пользователи',
            USER_CREATE: 'Добавить пользователя',
            USER_EMAIL: 'E-mail',
            USER_PASS: 'Пароль',
            USER_PASS_REPEAT: 'Подтвердите пароль',
            USER_SUBSCR: 'Настройка рассылок',
            USER_SUBSCR_TITLE: 'Настройка e-mail рассылок',
            USER_SUBSCR_DESCR:
                'Часовой пояс, выбранный в настройках профиля, будет влиять на время, указанное в письмах о событиях, о которых Вы получаете уведомления по e-mail. По умолчанию время событий записывается в формате UTC ±0:00.',
            USER_SUBSCR_EMAIL: 'E-mail',
            USER_RIGHT: 'Права',
            USER_TYPE: 'Тип пользователя',
            USER_GROUP: 'Группа',
            USER_GROUP_EMPTY: 'Нет группы',
            USER_GROUPS_EMPTY: 'Группы не найдены',
            USER_GROUPS: 'Выбор группы',
            USER_PHONE: 'Телефон',
            USER_CREATED: 'Создан',
            USER_UPDATED: 'Обновлён',
            USER_CREATE_SUCCESS: 'Новый пользователь добавлен',
            USER_UPDATE_SUCCESS: 'Профиль пользователя обновлён',
            USER_GROUP_UPDATE_SUCCESS: 'Группа пользователя успешно обновлена',
            USER_DELETE: 'Удалить пользователя',
            USER_DELETE_TEXT:
                'Этот пользователь будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?',
            USER_DELETE_SUCCESS: 'Пользователь удалён',
            USER_INFO: 'Информация',
            USER_LOG: 'Журнал действий',
            USER_INFO_HEADER: 'Информация о пользователе',
            USER_INFO_SUBSCR_TIMEZONE: 'Часовой пояс',
            USER_INFO_SUBSCR_ENABLED: 'Получать рассылку',
            USER_INFO_LANG: 'Язык интерфейса',
            USER_INFO_LANG_TITLE: 'Локализация',
            USER_ACTIONS: 'Журнал действий пользователя',
            USER_ACTION: 'Действие',
            USER_DATETIME: 'Дата, время',
            USER_EMPTY: 'У пользователя пока нет автомобилей',
            USER_NAME: 'Имя',
            USER_LAST_NAME: 'Фамилия',
            USER_SURNAME: 'Отчество',
            USER_EMAIL_ERROR: 'Введите корректный E-mail',
            USER_TYPE_ERROR: 'Выберите тип пользователя',
            USER_RIGHT_ERROR: 'Выберите тип прав пользователя',
            USER_PASS_ERROR: 'Не менее 6 символов, содержит заглавные буквы и цифры',
            USER_PASSWORD_CHANGE: 'Смена пароля',
            USER_STATUS_ACTIVE: 'Пользователь активен',
            USER_STATUS_LOCKED: 'Пользователь заблокирован',
            USER_STATUS_LOCK: 'Заблокировать пользователя',
            USER_ATTR_WARNING:
                'При изменении атрибутов пользователя все его сессии будут удалены. Ему будет необходимо повторно пройти авторизацию на всех устройствах.',
            RESET_TOKEN: 'Завершить все сеансы',
            RESET_TOKEN_SUCCESS: 'Все сеансы успешно завершены',

            // Часовые пояса
            TIMEZONE_UTC: 'Международная линия перемены дат (UTC-12)',
            TIMEZONE_SAMOA: 'Паго-Паго, Американское Самоа (UTC-11)',
            TIMEZONE_GONOLULU: 'Гонолулу, США (UTC-10)',
            TIMEZONE_ANCHORAGE: 'Анкоридж, США (UTC-09)',
            TIMEZONE_LOS_ANGELES: 'Лос-Анджелес, США (UTC-08)',
            TIMEZONE_DENVER: 'Денвер, США (UTC-07)',
            TIMEZONE_CHIKAGO: 'Чикаго, США (UTC-06)',
            TIMEZONE_NEW_YORK: 'Нью-Йорк, США (UTC-05)',
            TIMEZONE_CANADA: 'Галифакс, Канада (UTC-04)',
            TIMEZONE_ARGENTINA: 'Буэнос-Айрес, Аргентина (UTC-03)',
            TIMEZONE_SOUTH_GEORGIA: 'Южная Георгия (UTC-02)',
            TIMEZONE_CABO_VERDE: 'Прая, Кабо-Верде (UTC-01)',
            TIMEZONE_LONDON: 'Лондон, Великобритания (UTC±00)',
            TIMEZONE_BERLIN: 'Берлин, Германия (UTC+01)',
            TIMEZONE_KYIV: 'Киев, Украина (UTC+02)',
            TIMEZONE_MOSCOW: 'Москва (UTC+03)',
            TIMEZONE_SAMARA: 'Самара (UTC+04)',
            TIMEZONE_EKATERINBURG: 'Екатеринбург (UTC+05)',
            TIMEZONE_OMSK: 'Омск (UTC+06)',
            TIMEZONE_KRASNOYARSK: 'Красноярск (UTC+07)',
            TIMEZONE_IRKUTSK: 'Иркутск (UTC+08)',
            TIMEZONE_YAKUTSK: 'Якутск (UTC+09)',
            TIMEZONE_VLADIK: 'Владивосток (UTC+10)',
            TIMEZONE_MAGADAN_ZNACHIT_OPYAT_DOMOY: 'Магадан (UTC+11)',

            // Атрибуты для раздачи прав и привелегий
            GROUPS_ATTRS: 'Атрибуты',
            GROUPS_ATTRS_BASE: 'Базовые настройки',
            GROUPS_ATTRS_LOGS_CAR: 'Просмотр логов автомобилей',
            GROUPS_ATTRS_EDIT_PRIVATE_CAR: 'Редактирование данных производителя',
            GROUPS_ATTRS_GEODATA: 'Навигационная информация',
            GROUPS_ATTRS_REMOTE_CONTROL: 'Удаленное управление',
            GROUPS_ATTRS_DIAGNOSTIC: 'Отчёты ЭБУ',
            GROUPS_ATTRS_PARAM: 'Установка и удаление параметров SDM',
            GROUPS_ATTRS_FIRMWARE: 'Работа с прошивками',
            GROUPS_ATTRS_COMMAND: 'Отправка комманд SDM',
            GROUPS_ATTRS_GROUP_ADMIN: 'Админ группы пользователей',
            GROUPS_ATTRS_SUPER_ADMIN: 'Администратор приложения',
            GROUPS_ATTRS_DEVELOPER: 'Режим разработчика',
            GROUPS_ATTRS_GROUP_NAVI: 'Навигационная информация',
            GROUPS_ATTRS_GROUP_REMOTE: 'Удаленное управление',
            GROUPS_ATTRS_GROUP_DIAGNOSTIC: 'Диагностика',
            GROUPS_ATTRS_GROUP_DEVELOPER: 'Режим разработчика',
            GROUPS_ATTRS_GROUP_OWNER: 'Владелец',

            // Автомобили пользователя
            USER_CARS: 'Автомобили пользователя',
            USER_CARS_EMPTY: 'У этого пользователя нет автомобилей',
            USER_CARS_CREATE: 'Автомобили пользователя',
            USER_CARS_CREATE_TITLE: 'Управление правами',
            USER_CARS_ACCESS: 'Права',
            USER_CARS_CREATE_SUCCESS: 'Автомобиль добавлен пользователю',
            USER_CARS_UPDATE_SUCCESS: 'Автомобиль пользователя обновлён',
            USER_CARS_DELETE: 'Удалить автомобиль',
            USER_CARS_DELETE_TEXT: 'Автомобиль будет удалён без возможности восстановления',
            USER_CARS_DELETE_SUCCESS: 'Доступ к автомобилю удалён',
            USER_CARS_ADD: 'Добавить автомобиль',

            // Автомобили
            CARS: 'Автомобили',
            CARS_MODEL: 'Марка и модель',
            CARS_NAMI_NUMBER: 'Код производителя',
            CARS_TYPE: 'Тип кузова',
            CARS_VIN: 'VIN',
            CARS_SEARCH_MODE_ALL: 'Все',
            CARS_SEARCH_MODE_VIN: 'VIN',
            CARS_SEARCH_MODE_TID: 'id SDM',
            CARS_SEARCH_MODE_IMEI: 'IMEI',
            CARS_SEARCH_MODE_NUMBER: 'Гос.номер',
            CARS_SEARCH_MODE_NAMI: 'Номер НАМИ',
            CARS_SEARCH_MODE_PHONE: 'Номер телефона',

            // Группы автомобилей
            CARS_GROUPS: 'Группы автомобилей',
            CARS_GROUP: 'Группа автомобилей',
            CARS_GROUPS_EMPTY: 'Группы не найдены',
            CARS_GROUPS_INFO: 'Информация о группе',
            CARS_GROUPS_NAME: 'Название группы',
            CARS_GROUPS_DESCR: 'Описание',
            CARS_GROUPS_CREATE: 'Создать группу автомобилей',
            CARS_GROUPS_CREATE_SUCCESS: 'Группа автомобилей успешно создана',
            CARS_GROUPS_CREATE_NAME: 'Название',
            CARS_GROUPS_CREATE_DESCR: 'Описание',
            CARS_GROUPS_UPDATE_SUCCESS: 'Группа автомобилей успешно обновлена',
            CARS_GROUPS_DELETE: 'Удаление группы автомобилей',
            CARS_GROUPS_DELETE_DESCR:
                'Эта группа будет удалена без возможности восстановления. Вы уверены, что хотите удалить её?',
            CARS_GROUPS_DELETE_SUCCESS: 'Группа успешно удалена',

            CARS_GROUPS_CARS: 'Автомобили группы',
            CARS_GROUPS_CARS_EMPTY: 'Автомобили группы не найдены',
            CARS_GROUPS_CARS_CREATE_SUCCESS: 'Автомобиль добавлен в группу',
            CARS_GROUPS_CARS_DELETE_SUCCESS: 'Автомобиль удалён из группы',

            CARS_GROUPS_USERS_GROUPS: 'Группы пользователей',
            CARS_GROUPS_USERS_GROUPS_CREATE: 'Привязка групп пользователей',
            CARS_GROUPS_USERS_GROUPS_CREATE_SUCCESS: 'Группа пользователей привязана к группе автомобилей',
            CARS_GROUPS_USERS_GROUPS_UPDATE_SUCCESS: 'Группа пользователей обновлена',
            CARS_GROUPS_USERS_GROUPS_DELETE: 'Отвязка группы пользователей',
            CARS_GROUPS_USERS_GROUPS_DELETE_DESCR:
                'Выбранная группа пользователей потеряет доступ к этой группе автомобилей',
            CARS_GROUPS_USERS_GROUPS_DELETE_SUCCESS: 'Группа пользователей отвязана',

            // Группы, привязаные к выбранному автомобилю
            CAR_GROUP_CREATE: 'Добавить автомобиль в группу',
            CAR_GROUP_CREATE_SUCCESS: 'Автомобиль добавлен в группу',
            CAR_GROUP_DELETE: 'Удаление автомобиля из группы',
            CAR_GROUP_DELETE_DESCR:
                'Этот автомобиль будет удалён из выбранной группы. Вы уверены, что хотите сделать это?',
            CAR_GROUP_DELETE_SUCCESS: 'Автомобиль удалён из выбранной группы',

            // Автомобиль
            CAR: 'Автомобиль',
            CAR_UUID: 'UUID',
            CAR_VIN: 'VIN',
            CAR_VIN_UPDATE: 'Обновление VIN',
            CAR_ALWAYS_CONNECTED: 'Всегда подключён',
            CAR_CREATED: 'Добавлен',
            CAR_NAME: 'Название',
            CAR_NUMBER: 'Гос.номер',
            CAR_PHONE: 'Номер телефона SDM',
            CAR_NAMI_NUMBER: 'Код производителя',
            CAR_GARAGE: 'Гаражный номер',
            CAR_STATE: 'Описание',
            CAR_CARTYPE: 'Тип кузова',
            CAR_COLOR: 'Цвет',
            CAR_ENGINE: 'Двигатель',
            CAR_SUSPENSION: 'Подвеска',
            CAR_YEAR: 'Модельный год',
            CAR_MODEL: 'Модель',
            CAR_MODEL_UNKNOWN: 'Неизвестная модель',
            CAR_MANUFACTORY: 'Производство',
            CAR_CREATE_CARTYPE: 'Выбор типа кузова',
            CAR_TID: 'id SDM',
            CAR_SOFT: 'Версия ПО модуля',
            CAR_IMEI: 'IMEI',
            CAR_ICC_ID: 'ICC ID',
            CAR_ERA_ICC_ID: 'ERA ICC ID',
            CAR_TYPE: 'Платформа',
            CAR_TYPE_UNKNOWN: 'Неизвестно / не задано',
            CAR_TYPE_UMP10: 'UMP 1.0',
            CAR_TYPE_UMP15: 'UMP 1.5',
            CAR_TYPE_UMP15BEV: 'UMP 1.5 BEV',
            CAR_TYPE_UMP15PHEV: 'UMP 1.5 PHEV',
            CAR_TYPE_EMP20: 'EMP 2.0',
            CAR_TYPE_UAZ: 'УАЗ',
            CAR_MODULES: 'Модули',
            CAR_CREATE: 'Добавить автомобиль',
            CAR_CREATE_SUCCESS: 'Новый автомобиль добавлен',
            CAR_DELETE: 'Удалить автомобиль',
            CAR_DELETE_TEXT:
                'Этот автомобиль будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?',
            CAR_DELETE_SUCCESS: 'Автомобиль удалён',
            CAR_INFO: 'Информация об автомобиле',
            CAR_INFO_UPDATE_SUCCESS: 'Информация об автомобиле обновлена',
            CAR_VIN_ERROR: 'Длина VIN 17 символов',
            CAR_IMEI_ERROR: 'Длина IMEI 15 символов',
            CAR_TYPE_ERROR: 'Выберите платформу',
            CAR_TID_ERROR: 'Число от 0 до 2147483647',
            CAR_COLOR_CHOOSE: 'Выберите цвет',
            CAR_PHOTO: 'Фото',
            CAR_STATUS: 'Статус',
            CAR_RIGHTS: 'Права и доступ',
            CAR_GROUPS: 'Группы автомобиля',
            CAR_GROUPS_NAME: 'Название',
            CAR_GROUPS_DESCR: 'Описание',
            CAR_GROUPS_CARS_CREATE: 'Добавить автомобиль в группу',
            CAR_GROUPS_CARS_DELETE: 'Удалить автомобиль из группы',
            CAR_GROUPS_CARS_DELETE_DESCR: 'Этот автомобиль будет удалён из группы. Вы уверены, что хотите сделать это?',
            CAR_USERS: 'Пользователи автомобиля',
            CAR_USERS_GROUPS: 'Группы пользователей автомобиля',
            CAR_USERS_GROUPS_CREATE: 'Добавить группы пользователей автомобиля',
            CAR_USERS_GROUPS_CREATE_SUCCESS: 'Группа пользователей привязана к автомобилю',
            CAR_USERS_GROUPS_UPDATE_SUCCESS: 'Группа пользователей обновлена',
            CAR_USERS_GROUPS_DELETE: 'Отвязать группу пользователей',
            CAR_USERS_GROUPS_DELETE_DESCR:
                'Выбранная группа пользователей потеряет доступ к этому автомобилю. Вы уверены, что хотите сделать это?',
            CAR_USERS_GROUPS_DELETE_SUCCESS: 'Группа пользователей успешно отвязана',
            CAR_USERS_GROUP_NAME: 'Название',
            CAR_USERS_GROUP_DESCR: 'Описание',
            CAR_USERS_CREATE: 'Добавить пользователей автомобиля',
            CAR_USERS_CREATE_SUCCESS: 'Пользователь получил доступ к этому автомобилю',
            CAR_USERS_DELETE: 'Удаление доступа к автомобилю',
            CAR_USERS_DELETE_DESCR:
                'Этот пользователь потеряет доступ к выбранному автомобилю. Вы уверены, что хотите сделать это?',
            CAR_USERS_DELETE_SUCCESS: 'Доступ пользователя к автомобилю закрыт',
            CAR_USER_UPDATE_SUCCESS: 'Права пользователя на автомобиль обновлены',
            CAR_USER_DELETE: 'Удаление автомобиля пользователя',
            CAR_USER_DELETE_DESCR:
                'Пользователь потеряет доступ к выбранному автомобилю. Вы уверены, что хотите удалить доступ?',
            CAR_USER_DELETE_SUCCESS: 'Доступ пользователя к автомобилю удалён',
            CAR_TRIPS: 'Поездки',
            CAR_TRIP: 'Поездка',
            CAR_TRIPS_STARTDATE: 'Начало поездки',
            CAR_TRIPS_ENDDATE: 'Конец поездки',
            CAR_TRIPS_WITH_MILEAGE: 'Только с пробегом',
            CAR_TRIPS_MILEAGE: 'Пробег',
            CAR_TRIPS_TIME: 'Длительность',
            CAR_TRIPS_SPEAD: 'Средняя скорость',
            CAR_TRIPS_CONSUMPTION: 'Средний расход',
            CAR_TRIPS_ASSESSMENT: 'Манера вождения',
            CAR_TRIPS_BEGIN: 'Начало',
            CAR_TRIPS_END: 'Конец',
            CAR_TRIPS_MAP: 'Карта',
            CAR_TRIPS_NO_COORDS: 'Нет координат',
            CAR_EVENTS_ERROR_MAX_PERIOD: 'The maximum time period for a request is 32 days.',
            CAR_EVENTS_ERROR_INVALID_LIMITS: 'Дата окончания периода должна быть позже даты начала',
            CAR_EVENTS_ERROR_NO_LIMITS: 'Укажите даты начала и окончания периода',

            CAR_CHARGER: 'Зарядка',
            CAR_START_CHARG: 'Начало зарядки',
            CAR_END_CHARG: 'Конец зарядки',
            CAR_TOTAL_CHARGING_POWER: 'Заряжено',
            CAR_CHARGE_TIME: 'Длительность',

            // Владелец
            CAR_OWNER: 'Владелец',
            CAR_OWNER_CREATE: 'Добавьте владельца автомобиля',
            CAR_OWNER_DELETE: 'Удаление владельца',
            CAR_OWNER_DELETE_DESCR:
                'Вы уверены, что хотите удалить владельца? Этот пользователь потеряет доступ к автомобилю, если администратор не дал ему дополнительные права.',

            // Совладельцы автомобиля
            CAR_CO_OWNERS: 'Совладельцы',
            CAR_CO_OWNERS_NAME: 'Имя',
            CAR_CO_OWNERS_ATTRS: 'Возможности',
            CAR_CO_OWNERS_COUNTER: 'Совладельцев автомобиля',
            CAR_CO_OWNERS_CREATE_TITLE: 'Добавить совладельца',
            CAR_CO_OWNERS_CREATE_INTRO: `
                Вы можете добавить другого пользователя в совладельцы автомобиля в приложениях. <br>
                Для этого:
                <ol>
                    <li>Убедитесь, что у пользователя уже есть учётная запись;</li>
                    <li>Введите его e-mail или номер телефона из профиля.</li>
                </ol>
                Будьте внимательны: это предоставит ему доступ к информации об автомобиле.
            `,
            CAR_CO_OWNERS_CREATE_CONTACTS: 'Контакты совладельца',
            CAR_CO_OWNERS_CREATE_CONTACTS_ERROR: 'Укажите e-mail или телефон совладельца',
            CAR_CO_OWNERS_CREATE_DESCR: 'Описание',
            CAR_CO_OWNERS_CREATE_NAVI: 'Закрыть доступ к геоданным',
            CAR_CO_OWNERS_CREATE_NAVI_DESCR:
                'Информация о местонахождении автомобиля, истории поездок, а также получение уведомлений сервисов геолокации будут недоступны',
            CAR_CO_OWNERS_CREATE_REMOTE: 'Отключить управление',
            CAR_CO_OWNERS_CREATE_REMOTE_DESCR:
                'Дистанционное управление автомобилем будет недоступно. Будет возможен только просмотр информации о состоянии автомобиля',
            CAR_CO_OWNERS_DELETE: 'Удалить совладельца',
            CAR_CO_OWNERS_DELETE_DESCR:
                'Выбранный пользователь потеряет доступ к этому автомобилю, если администратор не добавлял ему дополнительные права.',
            CAR_CO_OWNERS_DELETE_SUCCESS: 'Совладелец успешно удалён',
            CAR_CO_OWNERS_CREATE_SUCCESS: 'Совладелец успешно добавлен',

            // Типы подвесок
            SUSPENSION_UNKNOWN: 'Неизвестный тип подвески',
            SUSPENSION_CONVENTIONAL: 'Обычная',
            SUSPENSION_AIR: 'Пневматическая',
            SUSPENSION_D_AIR: 'Пневматическая (двойной контур)',

            // Прошивки
            FIRMWARE: 'Прошивки SDM',
            FIRMWARE_TITLE: 'Загрузить прошивку',
            FIRMWARE_NAME: 'Имя файла',
            FIRMWARE_TYPE: 'Тип прошивки',
            FIRMWARE_TYPE_NOT_SET: 'Не задано',
            FIRMWARE_TYPE_ALL: 'Для всех',
            FIRMWARE_TYPE_ALL_EGTS: 'EGTS',
            FIRMWARE_TYPE_ALL_RLP: 'RLP',
            FIRMWARE_STATUS: 'Статус',
            FIRMWARE_STATUS_WAIT: 'Ожидает загрузки',
            FIRMWARE_STATUS_OK: 'Успешно загружена',
            FIRMWARE_STATUS_ERROR: 'Ошибка загрузки',
            FIRMWARE_FILE: 'Файл',
            FIRMWARE_CREATE: 'Добавить файл',
            FIRMWARE_CREATE_SUCCESS: 'Файл прошивки успешно загружен, ожидайте запись на устройство',
            FIRMWARE_DELETE: 'Удалить файл',
            FIRMWARE_DELETE_TEXT:
                'Этот файл прошивки будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?',
            FIRMWARE_DELETE_SUCCESS: 'Файл прошивки удалён',
            FIRMWARE_FILE_EMPTY: 'Вы пытаетесь загрузить пустой файл прошивки',
            FIRMWARE_FILE_ERROR: 'Не выбран файл прошивки',
            FIRMWARE_FILE_LARGE: 'Слишком большой файл, максимальный вес файла для загрузки - 16 MB',

            FIRMWARES_TITLE: 'Прошивки',
            FIRMWARES_FORM_METHOD: 'Способ загрузки',
            FIRMWARES_FORM_METHOD_CARS: 'Выбранные автомобили',
            FIRMWARES_FORM_METHOD_GROUPS: 'Группы автомобилей',
            FIRMWARES_FORM_METHOD_ALL: 'Все автомобили',
            FIRMWARES_FORM_METHOD_SELECT: 'Выбрать...',
            FIRMWARES_FORM_SELECT_CARS: 'Добавите автомобили для загрузки прошивки.',
            FIRMWARES_FORM_SELECT_GROUPS: 'Добавите группы автомобилей для загрузки прошивки.',
            FIRMWARES_FORM_SELECT_WARNING:
                'ВНИМАНИЕ! Вы выбрали способ загрузки - Все автомобили. Выбранная прошивка будет загружена во все автомобили!',
            FIRMWARES_FORM_ERROR_UNSELECTED: 'Выберите автомобили или группы для загрузки прошивки',
            FIRMWARES_FORM_DEVICE: 'Версия устройства',
            FIRMWARES_FORM_DEVICE_12: 'SDM v1.2',
			FIRMWARES_FORM_DEVICE_20: 'SDM v2.0', 
            FIRMWARES_FORM_DEVICE_30: 'SDM v3.0',
            FIRMWARES_FORM_DEVICE_IC_217: 'НАМИ-Интелком 2.1.7',
            FIRMWARES_FORM_FILE: 'Файл прошивки',
            FIRMWARES_FORM_MODULE: 'Модуль',
            FIRMWARES_FORM_VERSION: 'Версия прошивки',
            FIRMWARES_FORM_VERSION_DESCR:
                'Убедитеcь, что в поле "Версия прошивки" указано значение в формате "цифры.цифры"',
            FIRMWARES_CREATE_SELECT_ELEMENTS: 'Выберите элемента для загрузки прошивок',
            FIRMWARES_CREATE_SUCCESS: 'Файл прошивки успешно загруженн',
            FIRMWARES_UPDATE: 'Информация о прошивке',
            FIRMWARES_UPDATE_SUCCESS: 'Информация о прошивке успешно обновлена',
            FIRMWARES_DELETE: 'Удаление прошивки',
            FIRMWARES_DELETE_DESCR:
                'Выбранный файл прошивки будет удалён. Устройства, которые ещё не получили этот файл или его загрузка не закончена не получат его. Вы уверены, что хотите сделать это?',
            FIRMWARES_DELETE_SUCCESS: 'Файл прошивки успешно удалён',
            FIRMWARES_SEARCH_MODE_ALL: 'Все',
            FIRMWARES_SEARCH_MODE_DEVICE: 'Тип устройства',
            FIRMWARES_SEARCH_MODE_MODULE: 'Модуль',
            FIRMWARES_SEARCH_MODE_VERSION: 'Версия прошивки',
            FIRMWARES_NAME: 'Имя файла',
            FIRMWARES_DEVICE: 'Устройство',
            FIRMWARES_MODULE: 'Модуль',
            FIRMWARES_SOFTWARE: 'Прошивка',
            FIRMWARES_SELECTOR: 'Выберите получателей',
            FIRMWARES_SELECTOR_LINK: 'Добавить',

            ECUS_EXPORT_DESCR: 'Выберите блоки, отчёты которых будут загружены',
            ECUS_EXPORT_TYPE_DESCR: 'Выберите способ импорта',
            ECUS_EXPORT_SELECT_ALL: 'Выбрать всё',
            ECUS_EXPORT_DESELECT_ALL: 'Отменить всё',
            ECUS_EXPORT_PDF: 'Скачать PDF',
            ECUS_EXPORT_EMAIL: 'Отправить по e-mail',
            ECUS_EXPORT_EMAIL_LABEL: 'E-mail',
            ECUS_EXPORT_EMAIL_SUCCESS: 'Файл с результатами диагностики успешло отправлен на указанный e-mail',
            ECUS_EXPORT_ERROR_ECU: 'Не выбран ни один блок',
            ECUS_EXPORT_ERROR_EMAIL: 'Не указан e-mail для отправки отчёта',

            ECUS_DIAG_DELETE: 'Удалить все ошибки',
            ECUS_DIAG_DELETE_DESCR:
                'Это действие приведёт к удалению ошибок всех ЭБУ автомобиля? Вы действительно хотите сделать это?',
            ECUS_DIAG_REFRESH: 'Обновить отчёт',
            ECUS_DIAG_REFRESH_SUCCESS: 'Диагностика запущена. Файлы отчётов будут обновлены',
            ECUS_DIAG_CLEAR_DTC: 'Очистить ошибки',
            DIAG_BLOCK_DELETE_SUCCESS: 'Выбранный отчёт успешно удалён',
            DIAG_IMPORT_EMAIL_SUCCESS: 'Файл с отчётами диагностики успешно отправлен на указанный e-mail',
            DIAG_IMPORT_FILE_SUCCESS: 'Файл с отчётами диагностики успешно сформирован',

            ECUS_VIEWMODE_SCHEME: 'Схема',
            ECUS_VIEWMODE_GRID: 'Список',
            ECUS_VIEWMODE_INSTALLED: 'Активные',

            SDM_UPDATE_DATA: 'Обновить данные',

            // Пользователи автомобиля
            CARUSERS_EMPTY: 'У этого автомобиля нет пользователей',
            CARUSERS_CREATE: 'Пользователи',
            CARUSERS_CREATE_TITLE: 'Добавить пользователя',
            CARUSERS_CREATE_SUCCESS: 'Права пользователя на автомобиль добавлены',
            CARUSERS_UPDATE_SUCCESS: 'Права пользователя на автомобиль обновлены',
            CARUSERS_DELETE: 'Удалить прав пользователя',
            CARUSERS_DELETE_TEXT:
                'Этот пользователь потеряет доступ к информации об автомобиле. Вы уверены, что хотите удалить права?',
            CARUSERS_DELETE_SUCCESS: 'Доступ пользователя к автомобилю заблокирован',

            // Типы кузовов
            CARTYPES: 'Типы кузовов',
            CARTYPE_NEW: 'Новый тип',
            CARTYPE_BODY: 'Тип',
            CARTYPE_TYPE: 'Модификация',
            CARTYPE_UNDEFINED: 'Неизвестный тип',
            CARTYPE_CREATE_SUCCESS: 'Новый тип кузова создан',
            CARTYPE_UPDATE_SUCCESS: 'Тип кузова обновлён',
            CARTYPE_DELETE: 'Удаление типа кузова',
            CARTYPE_DELETE_TEXT:
                'Этот тип кузова будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?',
            CARTYPE_DELETE_SUCCESS: 'Тип кузова удалён',

            // События
            EVENTS: 'События',
            EVENTS_START: 'Дата начала событий',
            EVENTS_END: 'Дата окончания событий',
            EVENTS_FILTER: 'События',
            EVENTS_ERROR_NO_LIMITS: 'Укажите даты начала и конца событий',
            EVENTS_ERROR_INVALID_LIMITS: 'Дата начала событий должна быть раньше даты конца',
            EVENTS_ERROR_MAX_PERIOD: 'Максимальный интервал для запроса событий - 31 день',
            EVENTS_EVENT_ON_MAP: 'Событие на карте',
            EVENTS_EVENT_NO_COORDS: 'Локация не сохранена',
            EVENTS_EVENT: 'Событие',
            EVENTS_EVENT_DATE: 'Дата события',
            EVENTS_REQUEST: 'Запросить',
            EVENTS_MAP: 'Карта',

            // Файлы
            FILES: 'Файлы',

            // Статусы онлайн
            ONLINE: 'В сети',
            NOSATELLITES: 'В сети',
            OFFLINE: 'Не в сети',

            // Команды автомобиля
            CMD_SEND_HEADER: 'Отправка команд',
            CMD_SEND: 'Послать',
            CMD_SET_SERVER: 'Установить сервер данных',
            CMD_RELOAD: 'Перезагрузить SDM',
            CMD_SEND_SUCCESS: 'Команда отправлена',
            CMD_SUCCESS: 'Успешно',
            CMD_FAILURE: 'Ошибка',
            CMD_RESULT_NOT_SET: 'Статус не установлен',
            CMD_RESULT_SEND_IN_PROCESS: 'Команда отправлена на автомобиль',
            CMD_RESULT_SEND_TIMEOUT: 'Время подтверждения получения команды от автомобиля, превысило время ожидания',
            CMD_RESULT_SEND_CONFIRMED: 'Получено подтверждение получения команды от автомобиля',
            CMD_RESULT_RESULT_OK: 'Автомобиль прислал результат выполнения команды: успешное выполнение',
            CMD_RESULT_RESULT_ERROR: 'Автомобиль прислал результат выполнения команды: ошибка',
            CMD_RESULT_RESULT_ILL:
                'Автомобиль прислал результат выполнения команды: ошибка, отсутствие в списке разрешённых команд',
            CMD_RESULT_RESULT_DEL: 'Автомобиль прислал результат выполнения команды: успешно удалена',
            CMD_RESULT_RESULT_NOT_FOUND:
                'Автомобиль прислал результат выполнения команды: команда для удаления не найдена',
            CMD_RESULT_RESULT_NOT_CONFIG:
                'Автомобиль прислал результат выполнения команды: успешное выполнение, отрицательный ответ',
            CMD_RESULT_RESULT_IN_PROCESS:
                'Автомобиль прислал результат выполнения команды: команда передана на обработку',

            // Запрос треков
            CARTRACK: 'Просмотр треков поездок',
            CARTRACK_START: 'Начало периода',
            CARTRACK_END: 'Конец периода',
            CARTRACK_EMPTY: 'В этот период автомобиль не был в движении',
            CARTRACK_LIMIT: 'Максимальный временной период для запроса - 32 дня',
            CARTRACK_ERROR_MAX_PERIOD: 'Максимальный временной период для запроса - 32 дня',
            CARTRACK_ERROR_INVALID_LIMITS: 'Дата начала маршрута должна быть раньше даты конца',
            CARTRACK_ERROR_NO_LIMITS: 'Укажите даты начала и конца маршрута',

            // ADTCarTrackEvents
            EVENTS_TRIP_TRACKS: 'Трек поездок',

            // Тип связи с автомобилем
            CONNECTION_OFF: 'Нет связи',
            CONNECTION_ON: 'На связи',
            CONNECTION_LTE: 'LTE',
            CONNECTION_UMTS: 'UMTS',
            CONNECTION_GSM: 'GSM',

            // Управление картой
            MAP_SIZE_FULL: 'Развернуть',
            MAP_SIZE_SMALL: 'Свернуть',
            MAP_LAYERS_SHOW: 'Показать специальные карты',
            MAP_LAYERS_HIDE: 'Скрыть специальные карты',
            MAP_CMD: 'Отправить команду',
            MAP_CAR_TRACK: 'История маршрутов',
            MAP_CAR_TRACK_RESET: 'Сбросить маршрут',
            MAP_CAR_TRACK_MILEAGE: 'Пробег маршрута',
            MAP_MILEAGE: 'Пробег',

            MAPY_SPEED: 'Скорость',
            MAPY_UPDATED: 'Обновлено',
            MAPY_LAT: 'Широта',
            MAPY_LNG: 'Долгота',
            MAPY_AREAS: 'Геозоны',
            MAPY_CRASH:
                'Не удалось загрузить карты. Попробуйте обновить страницу (Ctrl+F5) или зайти позже. Если ошибка будет повторяться - свяжитесь с администратором!',

            // Модули EGTS
            EGTS_MODULES_MODULE_MAIN: 'Основной модуль',
            EGTS_MODULES_MODULE_INPUT: 'Модуль ввода/вывода',
            EGTS_MODULES_MODULE_NAVI: 'Навигационный модуль',
            EGTS_MODULES_MODULE_LINK: 'Модуль связи',
            EGTS_MODULES_VENDOR: 'Код производителя',
            EGTS_MODULES_FIRMWARE: 'Аппаратная версия',
            EGTS_MODULES_SOFTWARE: 'Версия ПО',
            EGTS_MODULES_MODIFICATION: 'Модификация',
            EGTS_MODULES_STATE: 'Состояние',
            EGTS_MODULES_STATE_1: 'Включен',
            EGTS_MODULES_STATE_0: 'Выключен',
            EGTS_MODULES_STATE_127: 'Неисправность',
            EGTS_MODULES_SERIAL: 'Серийный №',
            EGTS_MODULES_DESCR: 'Описание',
            EGTS_MODULES_DATE: 'Дата выпуска',

            // Статусы ошибок EGTS
            EGTS_PC_OK: 'Успешно обработано',
            EGTS_PC_IN_PROGRESS: 'В процессе обработки',
            EGTS_PC_UNS_PROTOCOL: 'Неподдерживаемый протокол',
            EGTS_PC_DECRYPT_ERROR: 'Ошибка декодирования',
            EGTS_PC_PROC_DENIED: 'Обработка запрещена',
            EGTS_PC_INC_HEADERFORM: 'Неверный формат заголовка',
            EGTS_PC_INC_DATAFORM: 'Неверный формат данных',
            EGTS_PC_UNS_TYPE: 'Неподдерживаемый тип',
            EGTS_PC_NOTEN_PARAMS: 'Неверное количество параметров',
            EGTS_PC_DBL_PROC: 'Попытка повторной обработки',
            EGTS_PC_PROC_SRC_DENIED: 'Обработка данных от источника запрещена ',
            EGTS_PC_HEADERCRC_ERROR: 'Ошибка контрольной суммы заголовка',
            EGTS_PC_DATACRC_ERROR: 'Ошибка контрольной суммы данных',
            EGTS_PC_INVDATALEN: 'Не корректная длина данных',
            EGTS_PC_ROUTE_NFOUND: 'Маршрут не найден',
            EGTS_PC_ROUTE_CLOSED: 'Маршрут закрыт',
            EGTS_PC_ROUTE_DENIED: 'Маршрутизация запрещена',
            EGTS_PC_INVADDR: 'Неверный адрес',
            EGTS_PC_TTLEXPIRED: 'Превышено количество ретрансляции данных',
            EGTS_PC_NO_ACK: 'Нет подтверждения',
            EGTS_PC_OBJ_NFOUND: 'Объект не найден',
            EGTS_PC_EVNT_NFOUND: 'Событие не найдено',
            EGTS_PC_SRVC_NFOUND: 'Сервис не найден',
            EGTS_PC_SRVC_DENIED: 'Сервис запрещен',
            EGTS_PC_SRVC_UNKN: 'Неизвестный тип сервиса',
            EGTS_PC_AUTH_DENIED: 'Авторизация запрещена',
            EGTS_PC_ALREADY_EXISTS: 'Объект уже существует',
            EGTS_PC_ID_NFOUND: 'Идентификатор не найден',
            EGTS_PC_INC_DATETIME: 'Неправильная дата и время',
            EGTS_PC_IO_ERROR: 'Ошибка ввода/вывода',
            EGTS_PC_NO_RES_AVAIL: 'Недостаточно ресурсов',
            EGTS_PC_MODULE_FAULT: 'Внутренний сбой модуля',
            EGTS_PC_MODULE_PWR_FLT: 'Сбой в работе цепи питания модуля',
            EGTS_PC_MODULE_PROC_FLT: 'Сбой в работе микроконтроллера модуля',
            EGTS_PC_MODULE_SW_FLT: 'Сбой в работе программы модуля',
            EGTS_PC_MODULE_FW_FLT: 'Сбой в работе внутреннего ПО модуля',
            EGTS_PC_MODULE_IO_FLT: 'Сбой в работе блока ввода/вывода модуля',
            EGTS_PC_MODULE_MEM_FLT: 'Сбой в работе внутренней памяти модуля',
            EGTS_PC_TEST_FAILED: 'Тест не пройден',

            /**
             * Состояние автомобиля
             *
             * "STATE_" + имя состояния в верхнем регистре
             */

            STATE_TABS_LAST_TRIP: 'Путевая статистика',
            STATE_TABS_WHEELS: 'Давление шин',
            STATE_TABS_BRAKES: 'Тормозная система',
            STATE_TABS_INTERIOR: 'Состояние салона',
            STATE_TABS_TRANSMISSION: 'АКПП',
            STATE_TABS_BATTERY: 'АКБ',
            STATE_TABS_LIGHT: 'Освещение',
            STATE_TABS_ENGINE: 'Двигатель',
            STATE_TABS_DOORS: 'Двери/кузов',
            STATE_TABS_ELECTRIC: 'АКБ 12В',
            STATE_TABS_ELECTRIC_HIGH: 'Зарядка ВВ АКБ',
            STATE_TABS_WARNINGS: 'Ошибки',

            STATE_INTERIOR_CHAIR_FL: 'Переднее левое кресло',
            STATE_INTERIOR_CHAIR_FR: 'Переднее правое кресло',
            STATE_INTERIOR_CHAIR_RL: 'Заднее левое кресло',
            STATE_INTERIOR_CHAIR_RR: 'Заднее правое кресло',
            STATE_INTERIOR_CHAIR_DESCR: 'Пассажиры в машине',
            STATE_INTERIOR_CHAIR_LARGE: 'Взрослый',
            STATE_INTERIOR_CHAIR_SMALL: 'Ребёнок',
            STATE_INTERIOR_CHAIR_CHILD: 'Детское кресло',
            STATE_INTERIOR_CHAIR_EMPTY: 'Пусто',
            STATE_INTERIOR_CHAIR_UNKNOWN: 'Неизвестно',
            STATE_INTERIOR_CHAIR_ERROR: 'Ошибка',

            STATE_GROUP_BATTERY_12V: 'Батарея 12В',
            STATE_GROUP_BATTERY_HW: 'Высоковольтная батарея',
            STATE_GROUP_LAST_TRIP: 'Последняя поездка',
            // STATE_GROUP_AFTER_RESET:            'После сброса',
            STATE_GROUP_MONTH: 'Статистика за месяц',
            STATE_GROUP_LAST_EVENTS: 'Последние события',

            STATE_DMFL_WARNING_INDICATOR: 'Состояние блока двери [передняя левая]',
            STATE_DMFR_WARNING_INDICATOR: 'Состояние блока двери [передняя правая]',
            STATE_DMRL_WARNING_INDICATOR: 'Состояние блока двери [задняя левая]',
            STATE_DMRR_WARNING_INDICATOR: 'Состояние блока двери [задняя правая]',

            STATE_DOOR_FRONT_LEFT_CLOSED: 'Замок двери [водитель]',
            STATE_DOOR_FRONT_RIGHT_CLOSED: 'Замок двери [передний пассажир]',
            STATE_DOOR_BACK_LEFT_CLOSED: 'Замок двери [задний левый пассажир]',
            STATE_DOOR_BACK_RIGHT_CLOSED: 'Замок двери [задний правый пассажир]',

            STATE_CORNERING_LIGHT_RIGHT_STATUS: 'Состояние правого блока адаптивного освещения',
            STATE_CORNERING_LIGHT_LEFT_STATUS: 'Состояние левого блока адаптивного освещения',

            STATE_T30I_FAULT_STATUS: 'Состояние линии Т30i',
            STATE_T15_FAULT_STATUS: 'Состояние линии Т15',
            STATE_T30D_FAULT_STATUS: 'Состояние линии Т30d',

            STATE_BRAKE_LIGHT_LEFT_STATUS: 'Состояние левого стоп-сигнала',
            STATE_BRAKE_LIGHT_RIGHT_STATUS: 'Состояние правого стоп-сигнала',
            STATE_BRAKE_LIGHT_HM_STATUS: 'Состояние дополнительного стоп-сигнала',

            STATE_WHEEL_BACK_RIGHT_STATUS: 'Датчик давления шин [передний задний]',
            STATE_WHEEL_BACK_LEFT_STATUS: 'Датчик давления шин [задний левый]',
            STATE_WHEEL_FRONT_LEFT_STATUS: 'Датчик давления шин [передний левый]',
            STATE_WHEEL_FRONT_RIGHT_STATUS: 'Датчик давления шин [передний правый]',

            STATE_WHEEL_FRONT_LEFT_PRESSURE: 'Давление шин [передняя левая]',
            STATE_WHEEL_FRONT_RIGHT_PRESSURE: 'Давление шин [передняя правая]',
            STATE_WHEEL_BACK_LEFT_PRESSURE: 'Давление шин [задняя левая]',
            STATE_WHEEL_BACK_RIGHT_PRESSURE: 'Давление шин [задняя правая]',

            STATE_TURN_INDICATOR_ML_STATUS: 'Состояние левого поворотника на зеркале',
            STATE_TURN_INDICATOR_MR_STATUS: 'Состояние правого поворотника на зеркале',

            STATE_WINDOW_FULLY_CLOSED_FL: 'Окно [переднее левое]',
            STATE_WINDOW_FULLY_CLOSED_FR: 'Окно [переднее правое]',
            STATE_WINDOW_FULLY_CLOSED_RL: 'Окно [заднее левое окно]',
            STATE_WINDOW_FULLY_CLOSED_RR: 'Окно [заднее правое]',
            STATE_WINDOW_OPEN: 'Окно открыто',

            STATE_TPMS_BATTERY_STATUS: 'Состояние батареи датчика давления шины',
            STATE_TPMS_BATTERY_STATUS_RR: 'Состояние батареи датчика давления шины ЗП',
            STATE_TPMS_BATTERY_STATUS_RL: 'Состояние батареи датчика давления шины ЗЛ',
            STATE_TPMS_BATTERY_STATUS_FR: 'Состояние батареи датчика давления шины ПП',
            STATE_TPMS_BATTERY_STATUS_FL: 'Состояние батареи датчика давления шины ПЛ',
            STATE_TPMS_BATTERY_NORMAL: 'Норма',
            STATE_TPMS_BATTERY_LOW: 'Низкий уровень',

            STATE_WHEEL_PRESSURE_STATUS_HIGH: 'Высокое давление',
            STATE_WHEEL_PRESSURE_STATUS_NORMAL: 'Нормальное давление',
            STATE_WHEEL_PRESSURE_STATUS_LOW: 'Низкое давление',
            STATE_WHEEL_PRESSURE_STATUS_CRITICAL: 'Критически низкое давление!',
            STATE_WHEEL_PRESSURE_STATUS_ERROR: 'Ошибка!',

            STATE_TRIP_ENERGY_CONSUMED_W: 'Затраченная энергия за поездку',
            STATE_COMM_STATUS: 'Статус связи',
            STATE_HV_BATTERY_SOC_PERCENT: 'Заряд ходовой ВВ батареи',
            STATE_ICE_STATUS: 'Статус ДВС',

            // Удалено в задаче https://git.shatl-t.ru/Frontend/aurus-disp-tool-4/issues/422
            // STATE_ENGINE_TIME: 'Моточасы',

            STATE_RIDE_AVERAGE_SPEED: 'Ср. скорость за поездку',
            STATE_TEMPERATURE_OUTSIDE: 'Внешняя температура',
            STATE_BACK_LEFT_TEMPERATURE: 'Температура [климат-контроль; задний левый пассажир]',
            STATE_OIL_PRESSURE_WARNING: 'Индикатор давления масла в двигателе',
            STATE_IS_LOCKED: 'Статус замков дверей',
            STATE_DOOR_FRONT_RIGHT: 'Дверь переднего пассажира',
            STATE_FRONT_INSIDE_TEMPERATURE: 'Температура [внутри салона; передняя]',
            STATE_FRONT_RIGHT_TEMPERATURE: 'Температура [климат-контроль; передний пассажир]',
            STATE_STATUS: 'Статус автомобиля',
            STATE_OIL_LEVEL: 'Уровень масла двигателя',
            STATE_MIL_ONRQ: 'Индикатор ошибки двигателя',
            STATE_POSITION_LIGHT_FR_STATUS: 'Состояние переднего правого габаритного огня',
            STATE_HEAD_LIGHT_LEVELING_CTRL_FAILURE: 'Состояние системы автокоррекции фар',
            STATE_LTC_COOLANT_LVL: 'Уровень охлаждающей жидкости высоковольтной системы',
            STATE_BACK_INSIDE_TEMPERATURE: 'Температура [внутри салона; задняя]',
            STATE_RECEIVED_SIGNAL_STRENGTH_INDICATOR: 'Показатель уровня принимаемого сигнала',
            STATE_DOOR_BACK_LEFT: 'Дверь заднего левого пассажира',
            STATE_REVERSE_LIGHT_RIGHT_STATUS: 'Состояние правого сигнала заднего хода',
            STATE_FRONT_LEFT_TEMPERATURE: 'Температура [климат-контроль; водитель]',
            STATE_START_MOVING: 'Время начала движения',
            STATE_STOP_MOVING: 'Время остановки автомобиля',
            // STATE_VEHICLE_SECURE_LOCK_STATE: 'Статус блокировки замков', // Стейт удалён на стороне бекенда
            STATE_REAR_FOG_LIGHT_STATUS: 'Состояние задней ПТФ',
            STATE_ABS_LAMP: 'Состояние АБС',
            STATE_FRONT_RIGHT_FOG_LIGHT_STATUS: 'Состояние передней правой ПТФ',
            STATE_POSITION_LIGHT_RR_STATUS: 'Состояние заднего правого габаритного огня',
            STATE_TURN_INDICATOR_RR_STATUS: 'Состояние правого заднего поворотника',
            STATE_LOW_BEAM_RIGHT_STATUS: 'Состояние правой фары ближнего света',
            STATE_EPB_STATUS: 'Ручник',
            STATE_ESP_LAMP: 'Состояние ESP',
            STATE_TPMS_SENSOR_FAULT_FR: 'Ошибка датчика давления шины ПП',
            STATE_TPMS_SENSOR_FAULT_RL: 'Ошибка датчика давления шины ЗЛ',
            STATE_RIDE_MILEAGE: 'Пробег за поездку',
            STATE_LAST_NAVIGATION_TIME: 'Последнее обновление навигации',
            STATE_SYSTEM_FAILURE: 'Высоковольтная система',
            STATE_FUEL: 'Уровень топлива',
            STATE_FUEL_LEVEL: 'Уровень топлива',
            STATE_FRONT_LEFT_FOG_LIGHT_STATUS: 'Состояние передней левой ПТФ',
            STATE_TURN_INDICATOR_FR_STATUS: 'Состояние правого переднего поворотника',
            STATE_POSITION_LIGHT_RL_STATUS: 'Состояние заднего левого габаритного огня',
            STATE_BCM_WARNING_INDICATOR: 'Состояние модуля кузовной электроники',
            STATE_ONLINE: 'Online',
            STATE_OFFLINE: 'Не в сети',
            STATE_ENGINE_ON: 'Время запуска двигателя',
            STATE_DAYTIME_LIGHT_RIGHT_STATUS: 'Состояние правого дневного ходового огня',
            STATE_DOOR_TRUNK: 'Багажник',
            STATE_MOBILE_NETWORK_TYPE_INDICATOR: 'Тип связи',
            STATE_NETWORK_TYPE_BB: 'Тип связи',
            STATE_NETWORK_RSSI_BB: 'Уровень сигнала',
            STATE_POSITION_LIGHT_FL_STATUS: 'Состояние переднего левого габаритного огня',
            STATE_TPMS_SENSOR_FAULT_FL: 'Ошибка датчика давления шины ПЛ',
            STATE_DAYTIME_LIGHT_LEFT_STATUS: 'Состояние левого дневного ходового огня',
            STATE_DOOR_FRONT_LEFT: 'Дверь водителя',
            STATE_DOOR_HOOD: 'Капот',
            STATE_TPMS_SENSOR_FAULT_RR: 'Ошибка датчика давления шины ЗП',
            STATE_ENGINE_OIL_TEMP: 'Температура [масло в двигателе]',
            STATE_ENGINE_REV: 'Обороты двигателя',
            STATE_TCS_LAMP: 'Состояние TCS',
            STATE_EBD_LAMP: 'Состояние EBD',
            STATE_TURN_INDICATOR_RL_STATUS: 'Состояние левого заднего поворотника',
            // STATE_MILEAGE_ON_FUEL_RESIDUES: 'Пробег на остатке топлива', // Старый параметр
            STATE_HIGH_BEAM_LEFT_STATUS: 'Состояние левой фары дальнего света',
            STATE_ENGINE_TEMPERATURE: 'Температура [охлаждающая жидкость]',
            STATE_RIDE_TIME: 'Время в пути за поездку',
            STATE_ENGINE_OFF: 'Время остановки двигателя',
            STATE_WASHER_FLUID: 'Уровень омывающей жидкости',
            STATE_WASHER_FLUID_WARNING: 'Низкий уровень омывающей жидкости',
            STATE_TOTAL_MILEAGE: 'Общий пробег',
            STATE_BACK_RIGHT_TEMPERATURE: 'Температура [климат-контроль; задний правый пассажир]',
            STATE_MIL_IND_BLINK: 'Индикатор критической ошибки двигателя',
            STATE_COOLANT_FLUID: 'Уровень охлаждающей жидкости',
            STATE_COOLANT_FLUID_NORMAL: 'Норма',
            STATE_COOLANT_FLUID_LOW: 'Низкий уровень',
            STATE_LOW_BEAM_LEFT_STATUS: 'Состояние левой фары ближнего света',
            STATE_RIDE_FUEL_CONSUMPTION: 'Расход топлива за поездку',
            STATE_ENGINE_OIL_LVIND: 'Индикатор уровня масла в двигателе',
            STATE_TURN_INDICATOR_FL_STATUS: 'Состояние левого переднего поворотника',
            STATE_DOOR_TRUNK_DIRECTION: 'Door trunk direction',
            STATE_HIGH_BEAM_RIGHT_STATUS: 'Состояние правой фары дальнего света',
            STATE_ESP_SPEED: 'Скорость',
            STATE_LAST_CAN_PARAM_TIME: 'Последнее обновление параметров автомобиля', // Обновление Body-CAN
            STATE_TM_WARNING_INDICATOR: 'Состояние багажника',
            STATE_REVERSE_LIGHT_LEFT_STATUS: 'Состояние левого сигнала заднего хода',
            STATE_DOOR_BACK_RIGHT: 'Дверь заднего правого пассажира',
            STATE_SERVICE_DATE: 'Следующее ТО',
            STATE_GEAR_POSITION: 'Положение рычага АКПП',
            STATE_LAST_DIAGNOSTICS_TIME: 'Последнее обновление диагностики', // Обновление Diag-CAN
            STATE_LAST_ONLINE: 'Последний выход на связь',
            STATE_SERVICE_MILEAGE: 'Пробег до ТО',
            STATE_ST_TRANSMISSION_WARNING: 'Состояние АКПП',
            STATE_SCU_CALIBRATION_STATUS: 'Состояние калибровки подвески',
            STATE_CCU_FAILURE: 'Состояние климатической системы',
            STATE_CCU_AC: 'A/C',
            STATE_SCU_FAULT_STATUS: 'Состояние подвески',
            STATE_ERAG_FAILURE_STATUS: 'Состояние системы экстренного вызова',
            STATE_OPEN: 'Открыто',
            STATE_HALF_OPEN: 'Открыт наполовину',
            STATE_CLOSED: 'Закрыто',
            STATE_NOT_CLOSED: 'Не закрыто',
            STATE_RESERV: '(резерв)',
            STATE_MILEAGE_WARNING:
                'ВНИМАНИЕ! Пробег, записанный в этом электронном блоке существенно отличается от пробега, хранящегося в электронном блоке ESP',
            STATE_SDM_UPTIME: 'Последнее включение/перезапуск',
            STATE_VAS_ACTIVATION: 'Состояние охранной сигнализации',
            STATE_LOCK_SECURE: 'На охране',
            STATE_CRUISING_RANGE: 'Запас хода',

            // ПАРАМЕТРЫ ПОСЛЕ СБРОСА БК
            STATE_TOTAL_MILEAGE_AM: 'Пробег после сброса',
            STATE_TOTAL_AVG_SPEED_AM: 'Ср. скорость после сброса',
            STATE_TOTAL_MINS_AM: 'Время в пути после сброса',
            STATE_FUEL_CONSUMPTION: 'Ср. расход после сброса',

            // АКБ / БАТАРЕЯ 12 В
            STATE_BAT_CAPACITY: 'Емкость',
            STATE_BAT_HEALTH: 'Здоровье',
            STATE_BAT_STATUS: 'Состояние',
            STATE_BAT_VOLTAGE: 'Напряжение',
            STATE_LVB_SOH: 'Здоровье АКБ 12В',
            STATE_LVB_SOC: 'Емкость АКБ 12В',
            STATE_BATTERY_STATUS: 'Состояние АКБ 12В',
            STATE_BATTERY_VOLTAGE: 'Напряжение АКБ 12В',
            STATE_BATTERY_12V_STATUS_FULL: 'Заряжена',
            STATE_BATTERY_12V_STATUS_NORMAL: 'Норма',
            STATE_BATTERY_12V_STATUS_REQUEST_CHARGE: 'Требует подзарядки',
            STATE_BATTERY_12V_STATUS_DISCHARGE: 'Батарея разряжена',
            STATE_BATTERY_12V_STATUS_LOW_SOC: 'Низкий заряд',
            STATE_BATTERY_12V_STATUS_LOW_VOLT: 'Низкое напряжение',
			STATE_SOH_HV_AKB: 'SoH HV АКБ',
			STATE_SOC_HV_AKB: 'SoC HV АКБ',

            // Высоковольтная батарея
            STATE_SOH_AKB: 'Здоровье ВВ АКБ',
            STATE_SOC_AKB: 'Емкость ВВ АКБ',
            STATE_LEVEL_PERCENT: 'Уровень заряда',
            STATE_CHARGING_STATUS: 'Статус зарядки',
            STATE_CHARGER_INPUT_POWER_W: 'Входная мощность зарядки',
            STATE_CHARGER_INPUT_CURRENT_MA: 'Входная сила тока зарядки',
            STATE_CHARGING_SOC_LIMIT_PERCENT: 'Ограничение зарядки батареи по SoC',
            STATE_REDUCE_CHARGING_STATUS: 'Статус пониженной мощности зарядки',
            STATE_REMAINING_CHARGING_TIME_S: 'Время до полного заряда батареи',
            STATE_TOTAL_CHARGING_POWER_WH: 'Накопленная мощность зарядки',
            STATE_CHARGING_DURATION_S: 'Продолжительность зарядки',

            STATE_NO_CHARGING: 'Не подключено',
            STATE_CHARGING_IN_PROGRESS: 'Идёт зарядка',
            STATE_CHARGING_DONE: 'Зарядка окончена',
            STATE_CHARGING_SUSPEND_VEHICLE: 'Приостановлено [ошибка автомобиля]',
            STATE_CHARGING_SUSPEND_CHARGER: 'Приостановлено [ошибка зарядки]',
            STATE_CHARGING_INIT: 'Инициализация',
            STATE_CHARGING_V2L_IDLE: 'V2L idle',
            STATE_CHARGING_V2L_ACTIVE: 'V2L active',

            STATE_NOT_REDUCED: 'Не понижена',
            STATE_REDUCED: 'Понижена',

            STATE_COMMON_RIDE_TIME: 'Время в пути',
            STATE_COMMON_MILEAGE: 'Пробег',
            STATE_COMMON_FUEL_CONSUMPTION: 'Средний расход',
            STATE_COMMON_FUEL_CONSUMPTION_ELECTRO: 'Расход электроэнергии',
            STATE_COMMON_AVERAGE_SPEED: 'Средняя скорость',

            STATE_OCU_FL_STAT: 'Переднее левое сидение',
            STATE_OCU_FR_STAT: 'Переднее правое сидение',
            STATE_OCU_RL_STAT: 'Заднее левое сидение',
            STATE_OCU_RR_STAT: 'Заднее правое сидение',

            STATE_SAT: 'Кол-во видимых спутников',

            STATE_TRIP_ACCELERATION: 'Кол-во ускорений',
            STATE_TRIP_BRAKING: 'Кол-во торможений',
            STATE_TOTAL_ACCELERATION: 'Кол-во ускорений',
            STATE_TOTAL_BRAKING: 'Кол-во торможений',
            STATE_ANS1: 'ANS1',
            STATE_ANS2: 'ANS2',
            STATE_ANS3: 'ANS3',
            STATE_ANS4: 'ANS4',
            STATE_ANS5: 'ANS5',
            STATE_DIG1: 'DIG1',
            STATE_DIG2: 'DIG2',
            STATE_DIG3: 'DIG3',
            STATE_DIG4: 'DIG4',
            STATE_DIG5: 'DIG5',
            STATE_ALARM_SYSTEM: 'Срабатывание штатной сигнализации',
            STATE_SRC: 'Источник данных',
            STATE_CONN_TYPE: 'Тип соединения',
            STATE_MOV: 'Движение',
            STATE_NOT_SET: 'Не выбрано',
            STATE_COOLANT_TEMPERATURE: 'Температура охлаждающей жидкости двигателя',
            STATE_ENGINE_OIL_TEMPERATURE: 'Температура масла двигателя',

            STATE_SPD: 'Скорость автомобиля',
            STATE_ALT: 'Высота',

            CCU_AUTO_MODE_LEVEL_INACTIVE: '',
            CCU_BLOWER_SPEED_LEVEL_OFF: '',
            CCU_FOOT_TEMP_CORRECTION_MINUS_1: '',
            CCU_FOOT_TEMP_CORRECTION_MINUS_2: '',
            CCU_FOOT_TEMP_CORRECTION_MINUS_3: '',
            CCU_DEFLECTOR_LED_LEVEL_NO_LED: '',
            CCU_AROMA_INTENSITY_OFF: '',
            CCU_AROMA_CAPACITY_LEVEL_30_PCT: '',
            CCU_AROMA_FLAVOR_1: '',
            CCU_AROMA_FAULT_NO_FAULT: '',
            CCU_REST_MODE_NOT_REQUESTED: '',
            STATE_VAS_ACTIVE: 'Охранная сигнализация включена',
            STATE_VAS_INACTIVE: 'Охранная сигнализация выключена',

            DRIVING_ASSESSMENT: 'Оценка манеры вождения',

            // Графики архивных показаний датчиков
            // Компонент ADTStatesHistory
            HISTORY: 'Архив показаний',
            HISTORY_DESCR: 'Просмотр истории показаний приборов и датчиков за выбранный промежуток времени',
            HISTORY_REQUEST_TEXT: 'Выберите время начала и окончания показаний',
            HISTORY_START: 'Начало',
            HISTORY_END: 'Конец',
            HISTORY_SEARCH: 'Поиск по названию...',
            HISTORY_PARAMS: 'Параметры',
            HISTORY_TIME: 'Время',
            HISTORY_ERROR_PARAMS: 'Параметры не выбраны!',
            HISTORY_ERROR_RANGE: 'Максимальный интервал для запроса графиков - 31 день',
            HISTORY_ERROR_TIME_INCORRECT: 'Время начала записи графиков должно быть раньше времени окончания',
            HISTORY_ERROR_TIME_EMPTY: 'Укажите даты начала и конца маршрута',
            HISTORY_EMPTY_POINTS: 'Нет записанных точек за указанный интервал времени',
            HISTORY_EMPTY_VALUE: 'Нет записанных состояний за указанный интервал времени',
            HISTORY_SHOW_GRID: 'Показать сетку',
            HISTORY_INSTRUCTION:
                'Кликните на графике левой кл.мыши, затем потяните для увеличения выбранной области. Для перемещения графика зажмите Ctrl',
            HISTORY_INSTRUCTION_PANNING:
                'Для увеличения масштаба растяните область на графике. Для сдвига графика проведите по нему двумя пальцами',

            // События
            // Компонент ADTEvents
            EVENT_VIN: 'VIN',
            EVENT_TYPE: 'Событие',
            EVENT_SEARCH: 'Поиск событий',
            EVENT_DATE: 'Дата',
            EVENT_MAP: 'На карте',
            EVENT_COORDS: 'Координаты',
            EVENT_GOTO_CAR: 'Перейти к автомобилю',
            EVENT_ALL: 'Все',
            EVENT_ENGINE_ON: 'Включение двигателя',
            EVENT_REMOTE_ENGINE_ON: 'Удаленное включение двигателя',
            EVENT_ENGINE_OFF: 'Выключение двигателя',
            EVENT_DECREASE_MILEAGE: 'Уменьшение общего пробега',
            EVENT_PROTECTED_AREA_IN: 'Вход в охранную зону',
            EVENT_PROTECTED_AREA: 'Выход из охранной зоны',
            EVENT_UNLOCKED: 'Снятие автомобиля с охраны',
            EVENT_LOCKED: 'Постановка автомобиля под охрану',
            EVENT_CMD_ENGINE_ON: 'Отправлена команда на запуск двигателя',
            EVENT_CMD_ENGINE_OFF: 'Отправлена команда на остановку двигателя',
            EVENT_CMD_UNLOCK: 'Отправлена команда на снятие с охраны',
            EVENT_CMD_LOCK: 'Отправлена команда на постановку под охрану',
            EVENT_CMD_TRUNK_OPEN: 'Отправлена команда на открытие багажника',
            EVENT_CMD_TRUNK_CLOSE: 'Отправлена команда на закрытие багажника',
            EVENT_CMD_LIGHT: 'Отправлена команда мигнуть фарами',
            EVENT_CMD_BEEP: 'Отправлена команда подать звуковой сигнал',
            EVENT_LOW_BATTERY_VOLTAGE: 'Низкий заряд аккумулятора',
            EVENT_ALARM_SYSTEM_TRIGGERED: 'Срабатывание штатной сигнализации',
            EVENT_VEH_UNLOCKED_ALERT: 'Не закрыты замки дверей',
            EVENT_NOT_SET: 'Не задано',
            EVENTS_SUBS: 'Подписка на события',
            EVENTS_SUBS_DESCR:
                'Вы можете подписаться на события этого автомобиля. Если они будут происходить, вы получите об этом уведомление на адрес электронной почты, указанный в вашем профиле.',
            EVENTS_SUBS_CREATE_SUCCESS: 'Подписка на событие добавлена',
            EVENTS_SUBS_DELETE_SUCCESS: 'Подписка на событие удалена',

            // События на карте
            MAP_EVENTS: 'События',
            MAP_EVENTS_DESCR: 'Выберите группы событий для отображения на карте',
            MAP_EVENTS_SECURE: 'Охрана',
            MAP_EVENTS_SECURE_ADD: 'Постановка/снятие',
            MAP_EVENTS_ENGINE: 'Двигатель',
            MAP_EVENTS_ENGINE_ADD: 'Включение/выключение',
            MAP_EVENTS_TRUNK: 'Багажник',
            MAP_EVENTS_TRUNK_ADD: 'Открытие/закрытие',
            MAP_EVENTS_ZONE: 'Охранная зона',
            MAP_EVENTS_ZONE_ADD: 'Вход/выход',
            MAP_EVENTS_LIGHT: 'Освещение и сигнал',
            MAP_EVENTS_MILEAGE: 'Уменьшение пробега',
            MAP_EVENTS_VOLTAGE: 'Низкий заряд АКБ',
            MAP_EVENTS_ALL: 'Показать все',
            MAP_EVENTS_ALARM_SYSTEM_TRIGGERED: 'Срабатывание штатной сигнализации',

            // Ошибки приложения
            ERROR: 'Ошибка',
            ENotFound: 'Не найдено',
            EUnknown: 'Системная ошибка [#2]. Сообщите оператору!', // Неизвестная (неописанная) ошибка
            ECursor: 'Системная ошибка [#3]. Сообщите оператору!', // Ошибка при передачи курсора листаемого списка
            EQuery: 'Системная ошибка [#4]. Сообщите оператору!', // Ошибка запроса (попытка отправки в запросе недопустимых символов)
            EUuid: 'Системная ошибка [#5]. Сообщите оператору!', // Передан неверный или пустой UUID
            EUpdate: 'Ошибка обновления',
            ECaptchaExpired: 'Обновите проверочный код и повторите ввод',
            ECaptchaCheckError: 'Введён неверный проверочный код',
            ECaptchaError: 'Ошибка получения проверочного кода',
            ECodeExpired: 'Проверочный код устарел, повторите процедуру восстановления пароля ещё раз',
            ECodeCheckError: 'Введён неверный проверочный код',
            ECodeError: 'Ошибка получения проверочного кода',
            ETokenExpired: 'Неверный ключ доступа, авторизуйтесь в приложении',
            ETokenError:
                'Не удалось получить токен для доступа к сервису; попробуйте обновить страницу или авторизуйтесь в приложении заново',
            EUserEmail: 'Введён неверный e-mail',
            EUserPassword: 'Введён неверный пароль',
            EPassword: 'Введённый пароль не соответствует минимальным требованиям безопасности',
            EPasswordOrCode: 'Ошибка получения проверочного кода, повторите ввод',
            EUserEmailAlreadyExist: 'Этот e-mail уже указан для одного из пользователей',
            EUserPhoneAlreadyExist: 'Этот номер телефона уже указан для одного из пользователей',
            EUserNotFound: 'Пользователь не найден',
            EUserEmptyPasswordOrCode: 'Не указан пароль или проверочный код',
            EUserPermissionDenied: 'У Вас нет доступа к этой информации',
            EUserFromContext: 'Системная ошибка [#3]. Сообщите оператору!', // User value not stored in ctx [???]
            EUserSelfDelete: 'Вы не можете удалить собственный аккаунт',
            EUserSelfUGroup: 'Вы не можете изменить группу пользователей для себя',
            EUserSelfLock: 'Пытаетесь забанить самого себя?...',
            EUserSendCode: 'Ошибка проверки проверочного кода',
            EUserAlreadyDeleted: 'Пользователь, которого Вы пытаетесь изменить был удалён',
            EUserCarsNotFound: 'Нет доступных автомобилей',
            EUserCursor: 'Ошибка при получении списка страницы прользователей',
            EConnection: 'Ошибка запроса: потеряно соединение с Интернет или сервер недоступен',
            EWSNotSuport: 'Ваш браузер не поддерживает технологию WebSocket',
            EWSError: 'Неизвестная ошибка, сообщите оператору!',
            EWSDisconnected: 'Сервер данных недоступен',
            EGarageNumber: 'Некорректный гаражный номер',
            EStartAfterStopOrEqual: 'Время начала мониторинга больше или равно времени окончания',
            EInvalidArgument: 'Системная ошибка [#2]. Сообщите оператору!',
            EPermissionDenied: 'Доступ запрещён',
            ERequestUserHeaders: 'Ошибка при попытке отправки запроса с пользовательскими заголовками',
            EIccid: 'Некорректный ICC ID',
            EEiccid: 'Некорректный ERA ICC ID',
            ECertificateAlreadyExist: 'Сертификат уже был выпущен',

            EEgtsFirmwareAlreadyExist: 'Прошивка уже была загружена',
            EEgtsParamNotFound: 'Параметр команды не распознан',
            EEgtsModuleNotFound: 'Модуль EGTS не найден',
            EEgtsFirmwareNotFound: 'Файлы прошивок не найдены',
            EEgtsReportNotFound: 'Записей диагностики не найдено',
            ECommandSendTimeOut: 'Команда не отправлена [время ожидания отправки превышено]',
            ECommandNotFound: 'Команда не найдена',
            ECommandSendError: 'Ошибка при попытке отправки команды',
            ECommandDataOverflow: 'Превышен лимит размера тела команды',
            ECommandResponseUnknown: 'При отправке команды произошла неизвестная ошибка',
            ECommandResponseNotRespond: 'Электронный блок не отвечает',
            ECommandResponseUnknownCommand: 'Команда не распознана',
            ECommandResponseUnknownAddress: 'Неизвестный адрес запрашиваемого электронного блока',
            ECommandResponseIgnitionIsOff: 'Для выполнения этой команды нужно включить зажигание',
            ECommandResponseIgnitionIsOn: 'Для выполнения этой команды нужно выключить зажигание',
            ECommandResponseDoorIsUnlock: 'Для выполнения этой команды нужно заблокировать двери',
            ECommandResponseLowFuelLevel: 'Для выполнения этой команды нехватает топлива в баке',
            ECommandResponseLowSoC: 'Для выполнения этой команды нехватает заряда АКБ',
            ECommandResponseEngineRemoteStartNotSupport: 'Удаленный запуск двигателя не поддерживается',
            ECommandResponseEngineRemoteStartModeNeeded:
                'Для выполнения этой команды переведите автомобиль в режим удаленного запуска',
            ECommandResponseParkingModeOfTCUNeeded:
                'Для выполнения этой команды переведите селектор КПП в режим Parking',

            EEventNotFound: 'Записи событий за указанный период времени не найдены',
            EFileName: 'Файл с указанным именем не найден',
            EPhone: 'Ошибка при вводе номера телефона',
            ECarPermissionGranted: 'Доступ ко всем автомобилям',
            EUnauthRequest: 'Неверный ключ доступа, авторизуйтесь в приложении',
            EFormFields: 'Ошибка заполнения формы',
            EVin: 'Не указан VIN-код',
            EUserAlreadyExist: 'Пользователь с этим именем или телефоном уже существует',
            EEmail: 'Недопустимые символы в поле E-mail',
            EEmailOrPhone: 'Учётная запись не найдена',
            EFavoriteFound:
                'Нет избранных автомобилей. Вы можете назначать избранные автомобили, нажав на иконку в виде звезды в карточке автомобиля из списка.',

            // Автомобили и кузова
            ECarAlreadyDeleted: 'Этот автомобиль был удалён ранее',
            ECarAlreadyExist: 'Такой автомобиль уже существует',
            ECarImeiAlreadyExist: 'Автомобиль с таким IMEI уже существует',
            ECarNumber: 'Некорректный номер автомобиля',
            ECarPointNotFound: 'Записей маршрута за выбранный промежуток времени не найдено',
            ECarUserNotFound: 'Пользователи автомобиля не найдены',
            ECarNotOnLine: 'Устройство не в сети',
            ECarPermissionDenied: 'Вы не имеете доступ к этой информации',
            ECarNotFound: 'Автомобили с указанными данными не найдены',
            ECarTypeNotFound: 'Типы кузовов с указанными параметрами не найдены',
            ECarTypeCursor: 'Ошибка получения типов кузовов',
            ECarTypeAlreadyExist: 'Этот тип кузова уже создан',
            ECarPointAlreadyExist: 'Эта точка уже существует',
            ECarStateNotFound: 'Состояние не определено',
            ELogNotFound: 'Логи не найдены',
            ECarVinAlreadyExist: 'Автомобиль с таким VIN уже существует',
            ECarAlreadyHasAnOwner:
                'Автомобиль уже имеет владельца. Сначала удалите атрибут "Владелец" из настроек текущего пользователя.',

            // Ошибки сертификатов
            ECertificateNotFound: 'Сертификаты не найдены',

            EEventParamAlreadyExist:
                'Вы патаетесь создать параметр, который уже существует. Для изменения параметра воспользуйтесь формой редактирования в списке параметров.',

            EAreaAlreadyExist: 'Геозона с таким названием уже существует',

            // Группы
            EGroupsNotFound: 'Группы не найдены',
            EGroupUsersNotFound: 'В группе нет пользователей',
            EGroupCarsNotFound: 'В группе нет автомобилей',
            EGroupCarAlreadyExist: 'Этот автомобиль уже в группе',
            EUGroupNotFound: 'Группы пользователей не найдены',
            ECGroupNotFound: 'Группы автомобилей не найдены',

            ECarTripsNotFound: 'За указанный промежуток времени поездки не найдены',

            ECarChargingsNotFound: 'За указанный период не найдено статистики по зарядкам',

            ELinkAlreadyExist:
                'Такая связка уже существует. Отредактируйте запись в списке добавленных или удалите её и создайте заново.',
            ELinkNotFound: 'Связи не обнаружены',

            EUserVerifyLink:
                'Похоже, Ваш код подтверждения e-mail недействителен. Пожалуйста, проверьте ссылку или запросите письмо с кодом повторно.',

            ERROR_NEED_REAUTH_TITLE: 'Требуется повторная авторизация',
            ERROR_NEED_REAUTH_TEXT: 'Данные Вашего профиля были изменены. Необходимо повторно пройти авторизацию.',
            ERROR_NEED_REAUTH_BTN: 'Авторизация',

            // Онлайн телеметрия
            CHART_ONLINE_TEST: 'Компонент работает в тестовом режиме. Данные на графиках создаются имитатором',
            CHART_ONLINE_TITLE: 'Телеметрия онлайн',
            CHART_ONLINE_SEARCH: 'Поиск параметра',
            CHART_ONLINE_SEARCH_DESCR: 'Введите имя или часть имени параметра',
            CHART_ONLINE_SHOW_GRID: 'Показать сетку',
            CHART_ONLINE_ERROR_TOKEN: 'Ошибка авторизации на сервере данных',
            CHART_ONLINE_ERROR_1: 'Ошибка разбора полученных данных',
            CHART_ONLINE_TIMEOUT: 'Устройство не отвечает: возможно, оно занято. Попробуйте запросить данные позже',
            CHART_ONLINE_PERIOD: 'Частота обновления [сек.]',

            WS_INDICATOR_TITLE: 'Идёт восстановление связи',
            WS_INDICATOR_TEXT: 'Онлайн-данные временно недоступны.',

            // Логи
            LOGS: 'Логи',
            LOG: 'Лог',
            LOGS_TYPE: 'Тип лога',
            LOGS_TYPE_EGTS: 'Автомобили',
            LOGS_TYPE_GRPC: 'Пользователи',
            LOGS_VIN: 'VIN',
            LOGS_VIN_MODAL: 'Выберите автомобиль',
            LOGS_USER_MODAL: 'Выберите пользователя',
            LOGS_DATE: 'Дата',
            LOGS_USER: 'Пользователь',
            LOGS_USER_ALL: 'Все пользователи',
            LOGS_GEO: 'Место события',
            LOGS_ACTION: 'Действие',
            LOGS_ACTION_LOGIN: 'Авторизация',
            LOGS_ACTION_DELETE: 'Удаление',
            LOGS_ACTION_INSERT: 'Вставка',
            LOGS_ACTION_UPDATE: 'Обновление',
            LOGS_ACTION_WRITE: 'Запись',
            LOGS_ACTION_SEND_CMD: 'Отправка команд',
            LOGS_ACTION_SEND_NOTI: 'Отправка уведомлений',
            LOGS_ACTION_SEND_PARAMS: 'Отправка параметра',
            LOGS_ITEM_DATE: 'Дата',
            LOGS_ITEM_GEO: 'Геоданные',
            LOGS_ERROR_NO_PARAMS: 'Выберите параметры для запроса логов',

            // Цвета кузовов
            CAR_COLOR_BLACK_COPPER: 'Черная медь',
            CAR_COLOR_BLUE_MAGIC: 'Яркий голубой',
            CAR_COLOR_DEEP_FOREST: 'Темно-зеленый',
            CAR_COLOR_DESERT_RED: 'Красная пустыня',
            CAR_COLOR_DESERT_TAUPE: 'Серо-коричневый',
            CAR_COLOR_GALANT_GREY: 'Темно-серый',
            CAR_COLOR_GRAPHITE_TRACE: 'Графитовый',
            CAR_COLOR_LATTE_MACCHIATO: 'Кофейный',
            CAR_COLOR_LUSTRE_WHITE: 'Белый перламутр',
            CAR_COLOR_NOT_SET: 'Не установлен',
            CAR_COLOR_PORCELAIN: 'Светло-серый солид',
            CAR_COLOR_PULSAR_BLUE: 'Темно-синий',
            CAR_COLOR_RUSSIAN_GOLD: 'Русское золото',
            CAR_COLOR_SHADE_OF_NIGHT: 'Тень ночи',
            CAR_COLOR_SILVER_LINING: 'Стальной голубой',
            CAR_COLOR_SUNSET_GOLD: 'Золотистый',
            CAR_COLOR_UNIVERSE_BLACK: 'Чёрный',
            CAR_COLOR_VELVET_RUBY: 'Рубиновый',

            // Электронные блоки
            ECUS_ADDITIONAL: 'Дополнительная информация',
            ECUS_STATUS_DESCR: 'Описание статусов',
            ECUS_DESCR_BADGES: 'Метки',
            ECUS_DESCR_SDM: 'SDM',
            ECUS_DESCR_SDM_ONLINE: 'Блок SDM на связи',
            ECUS_DESCR_SDM_NOSATELLITES: 'Блок SDM на связи, без спутников',
            ECUS_DESCR_SDM_OFFLINE: 'Блок SDM недоступен',
            ECUS_DESCR_ICON_ERROR: 'Количество активных ошибок',
            ECUS_DESCR_ICON_PASSIVE: 'Количество пассивных ошибок',
            ECUS_DESCR_ICON_WARNING: 'Предупреждения',
            ECUS_DESCR_BG: 'Блоки',
            ECUS_DESCR_BG_ONLINE: 'Без ошибок / с пассивными ошибками',
            ECUS_DESCR_BG_OFFLINE: 'Отсутствует диагностика более 30 дней',
            ECUS_DESCR_BG_ERROR: 'С активными ошибками',
            ECUS_DESCR_BG_NO_INFO: 'Нет информации',

            // Электронный блок
            ECU_NAME: 'Блок',
            ECU_DATE: 'Дата',
            ECU_EXPORT: 'Экспорт отчёта',
            ECU_INFO: 'Информация',
            ECU_MODULES: 'Модули',
            ECU_MODULES_INFO_EMPTY: 'Нет информации о модулях',

            ECU_MODULES_MAIN: 'Основной модуль',
            ECU_MODULES_IO: 'Модуль ввода/вывода',
            ECU_MODULES_NAVI: 'Модуль навигации',
            ECU_MODULES_WIRELESS: 'Модуль беспроводной связи',
            ECU_MODULES_INTERFACE: 'Интерфейсный модуль',
            ECU_MODULES_BOOTLOADER: 'Модуль загрузчика',
            ECU_MODULES_CONFIG: 'Конфигурация устройства',
            ECU_MODULES_UNKNOWN: 'Неизвестное устройство',

            ECU_ERRORS: 'Ошибки',
            ECU_ERRORS_ONLY_ACTIVE: 'Только активные',
            ECU_REPORTS: 'Отчёты',
            ECU_REPORTS_DISABLED: 'Графики онлайн / Онлайн-телеметрия: разработка приостановлена',
            ECU_REPORTS_HISTORY: 'История отчетов',
            ECU_REPORTS_DELETE: 'Удалить отчёты',
            ECU_REPORTS_DELETE_DESCR:
                'Это действие удалит все отчёты об астомобиле. Вы учерены, что вы хотите сделать это?',
            ECU_REPORTS_DELETE_SUCCESS:
                'Отчёты блока успешно удалены. Запустите обновление отчёта, если хотите получить информацию об этом блоке.',
            ECU_SERIAL: 'Серийный номер',
            ECU_HARDWARE: 'Аппаратная версия',
            ECU_FIRMWARE: 'Версия ПО',
            ECU_VIN: 'VIN по ЭБУ',
            ECU_CALIBRATION: 'Калибровка',
            ECU_MILEAGE: 'Пробег',
            ECU_SOFTWARE: 'Прошивка',
            ECU_TIMESTAMP: 'Время последней диагностики',
            ECU_ODX_VERSION: 'Версия файла ODX',
            ECU_ERRORS_EMPTY: 'Ошибок не обнаружено',
            ECU_FILE: 'Файлы',
            ECU_REMOVE: 'Удалить',
            ECU_PARAMS: 'Параметры',
            ECU_PARAMS_DESCR:
                'Установите чекбокс в поле Data, чтобы отправить число в шестнадцатеричном формате. При запросе статуса параметров поле "Data" с жёлтым фоном означает, что параметр создан, но не отправлен в блок SDM. Поле "Data" с зелёным контуром и галочкой отначает получение параметра блоком SDM.',
            ECU_PARAMS_NO_INFO: 'Нет информации о параметрах блока',
            ECU_PARAMS_EMPTY: 'Параметры блока не установлены. Создайте их через форму отправки команд.',
            ECU_PARAM_CREATE_SUCCESS: 'Новый параметр успешно добавлен',
            ECU_PARAM_UPDATE: 'Обновление параметра',
            ECU_PARAM_UPDATE_SUCCESS: 'Параметр успешно обновлён',
            ECU_PARAM_DELETE: 'Удаление параметра',
            ECU_PARAM_DELETE_TEXT:
                'Этот параметр будет удалён без возможности восстановления. Вы уверены, что хотите удалить его?',
            ECU_PARAM_DELETE_SUCCESS: 'Параметр успешно удалён из блока',

            ECU_SDM_REBOOT: 'Перезагрузить SDM',
            ECU_SDM_REFRESH: 'Обновить данные',
            ECU_SDM_FIRMWARES: 'Прошивки',
            ECU_SDM_LOGS: 'Журнал',
            ECU_SDM_UPDATE_DIAG: 'Обновление Diag-CAN',
            ECU_SDM_DESCR: 'Описание',
            ECU_SDM_SOFTWARE: 'Версия ПО',
            ECU_SDM_UPDATE_NAVI: 'Обновление навигации',
            ECU_SDM_MANUFACTORER: 'Код производителя',
            ECU_SDM_CREATE_DATE: 'Аппаратная версия',
            ECU_SDM_UPDATE_PARAMS: 'Обновление Body-CAN',
            ECU_SDM_MODIFICATION: 'Модификация',
            ECU_SDM_TID: 'id SDM',
            ECU_SDM_SET_SERVER: 'Установить сервер данных',
            ECU_SDM_SEND_CMD: 'Отправить команду',
            ECU_SDM_ONLINE_DATE: 'Время последнего выхода на связь',
            ECU_SDM_SET_PARAMS_TITLE: 'Параметры [установка / проверка]',
            ECU_SDM_CMD: 'Команды',
            ECU_SDM_CMD_TITLE: 'Отправка команд [параметры]',

            ECU_FIRMWARE_CREATE_SUCCESS: 'Файл прошивки успешно загружен на сервер. Дождитесь загрузки на устройство',
            ECU_FIRMWARE_DELETE_SUCCESS: 'Файл прошивки успешно удален',

            FAVORITE_CARS: 'Избранное',
            FAVORITE_CARS_ADD: 'Добавить в избранное',
            FAVORITE_CARS_EMPTY: 'Нет избранных автомобилей. Нажмите "Добавить" и выберите нужные автомобили из списка',
            FAVORITE_CARS_CREATE_SUCCESS: 'Автомобиль успешно добавлен в избранное',
            FAVORITE_CARS_CREATE_FAILURE:
                'Ошибка при попытке добавления избранного автомобиля. Сообщите админитратору!',
            FAVORITE_CARS_DELETE_HEADER: 'Удалить из избранного',
            FAVORITE_CARS_DELETE_DESCR:
                'Этот автомобиль будет удалён из списка избранных. Вы по-прежнему сможете найти его в общем списке на экране "Автомобили"',
            FAVORITE_CARS_DELETE_FAILURE: 'Ошибка при попытке удаления избранного автомобиля. Сообщите админитратору!',
            FAVORITE_CARS_ERROR_DATA:
                'При попытке получения избранных автомобилей возникла ошибка. Повторите Ваш запрос позже',

            // MANUALS
            MANUAL_CAR: 'Руководство по эксплуатации автомобиля',
            MANUAL_MMS: 'Руководство по эксплуатации мультимедийной системы',

            COPYRIGHT: 'Разработано ФГУП "НАМИ", 2022',

            // 404
            NOTFOUND_SUBTITLE: 'Страница не найдена',
            NOTFOUND_LINK: 'На главную',

            CERTIFICATES: 'Сертификаты',
            CERTIFICATES_ISSUE: 'Выпустить',
            CERTIFICATES_CRT: 'Crt',
            CERTIFICATES_KEY: 'Key',
            CERTIFICATES_CREATE: 'Выпуск сертификата',
            CERTIFICATES_CREATE_SUCCESS: 'Cертификат выпущен',
            CERTIFICATES_UPDATE: 'Перевыпуск сертификата',
            CERTIFICATES_UPDATE_SUCCESS: 'Сертификат перевыпущен',
            CERTIFICATES_DELETE: 'Удаление сертификата',
            CERTIFICATES_DELETE_DESCR:
                'Этот серификат будет удалён без возможности восстановления. Вы уверены, что хотите сделать это?',
            CERTIFICATES_DELETE_SUCCESS: 'Сертификат удалён',
            CERTIFICATES_CHANGE_WARN: 'ВНИМАНИЕ! При создании нового сертификата старый будет удалён!',
            CERTIFICATES_DATE_START: 'Дата начала',
            CERTIFICATES_DATE_STOP: 'Дата окончания',
            CERTIFICATES_IMEI: 'IMEI',
            CERTIFICATES_INFO: 'Описание сертификата',
            CERTIFICATES_DOWNLOAD_CRT: 'Скачать CRT',
            CERTIFICATES_DOWNLOAD_KEY: 'Скачать KEY',

            // Areas
            AREAS_LIST: 'Список зон',
            AREAS_NONE: 'Геозон нет',
            AREAS_NOT_FOUND: 'Геозоны не найдены',
            AREAS_CREATE: 'Создать зону',
            AREAS_DELETE: 'Удалить зону',
            AREAS_EDIT: 'Редактировать зону',
            AREAS_DELETE_TEXT:
                'Эта зона будет удалена без возможности восстановления. Вы уверены, что хотите удалить её?',
            AREAS_SEARCH_PLACEHOLDER: 'Поиск по имени, UUID',
            AREAS_SEARCH_MESSAGE: 'Введите минимум 3 символа',
            AREAS_FIGURE_TYPE: 'Тип фигуры',
            AREAS_FIGURE_STROKE: 'Цвет линии',
            AREAS_FIGURE_FILL: 'Цвет заливки',
            AREAS_FIGURE_THICKNESS: 'Толщина линии',
            AREAS_ENTER_NAME: 'Введите название геозоны',
            // AREAS_ENTER_DESCRIPTION:      'Введите описание геозоны',
            AREAS_ENTER_ZINDEX: 'Укажите Z-Index',
            AREAS_DRAW_MESSAGE: 'Нарисуйте зону на карте',
            AREAS_NAME: 'Название геозоны',
            AREAS_DESCRIPTION: 'Описание геозоны',
            AREAS_RADIUS: 'Радиус',
            AREAS_ZINDEX: 'Z-Index',
            AREAS_ANGLE: 'Угол',
            AREAS_JSON_ERROR: 'Ошибка при парсинге JSON',
            AREA: 'Геозона',
            AREA_CREATE_SUCCESS: 'Геозона добавлена',
            AREA_UPDATE_SUCCESS: 'Геозона обновлена',
            AREA_DELETE_SUCCESS: 'Геозона удалена',
            AREA_ISSTROKE: 'Контур',
            EAreaNotFound: 'Геозоны не найдены',

            // Геозоны автомобиля
            CAR_AREAS_CTRL_TITLE: 'Настроить геозону автомобиля',
            // CAR_AREAS_ADD_TITLE:           'Добавить геозону автомобилю',
            // CAR_AREAS_EDIT_TITLE:          'Редактировать геозону автомобиля',
            CAR_AREAS_DELETE_TITLE: 'Удалить событие геозоны автомобиля',
            CAR_AREAS_DELETE_TEXT:
                'Это событие геозоны автомобиля будет удалено без возможности восстановления. Вы уверены, что хотите удалить его?',

            CAR_AREAS_AREA: 'Геозона',
            CAR_AREAS_EVENT: 'Событие',
            AREA_IN: 'Вход в зону',
            AREA_OUT: 'Выход из зоны',
            // CAR_AREAS_NOT_FOUND:           'Записей нет',
            CAR_AREAS_CREATE_SUCCESS: 'Событие геозоны добавлено',
            CAR_AREAS_DELETE_SUCCESS: 'Событие геозоны удалено',
            EEventParamNotFound: 'События геозон не найдены',

            CAR_ROUTES: 'Поездки',

            EImei: 'Введён некорректный IMEI',

            DOCS_LECENSE: 'Лицензионный договор с конечным пользователем',

            DOCS_PRIVACY: 'Политика конфиденциальности',

            TOKEN_BAD_REQUEST: 'Не удалось получить токен.',
            TOKEN_REPEAT_REQUEST: 'Повтор через',

            CAR_WARNINGS_CODE: 'Код',
            CAR_WARNINGS_CATEGORY: 'Категория',
            CAR_WARNINGS_DESCR: 'Описание',
            CAR_WARNINGS_RECOMMENDATIONS: 'Рекомендации',

            // Расшифровка VIN
            BODY_UNKNOWN: 'Неизвестная модель',
            BODY_AURUS_SEDAN: 'Senat',
            BODY_AURUS_SUV: 'Komendant',
            BODY_AURUS_MPV: 'Arsenal',
            BODY_UAZ_PATRIOT: 'УАЗ Патриот',
            BODY_UAZ_SGR: 'УАЗ СГР',
            BODY_UAZ_PICKUP: 'УАЗ Пикап',
            BODY_UAZ_PROFI: 'УАЗ Профи',
            BODY_UAZ_HUNTER: 'УАЗ Хантер',

            ENGINE_UNKNOWN: 'Неизвестный тип двигателя',
            ENGINE_L4: 'L4',
            ENGINE_V8: 'V8',
            ENGINE_V6: 'V6',
            ENGINE_V12: 'V12',
            ENGINE_D4: 'D4',
            ENGINE_D6: 'D6',
            ENGINE_D8: 'D8',

            MF_UNKNOWN: 'Неизвестный производитель',
            MF_NAMI_PLANT: 'ФГУП «НАМИ», г. Москва',
            MF_UAZ_PLANT: 'ООО «УАЗ», г. Ульяновск',
            MF_AUTODOM_PLANT: 'ООО «АВТОДОМ»',
            MF_EAA_PLANT: 'ООО «Аурус»',

            MOD_UNKNOWN: 'Неизвестный кузов',
            MOD_SEDAN: 'Седан',
            MOD_SEDAN_ARMORED: 'Седан бронированный',
            MOD_LIMO_V12: 'Лимузин бронированный',
            MOD_LIMO_V8: 'Лимузин бронированный',
            MOD_CABRIO: 'Кабриолет',
            MOD_SEDAN_4X2: 'Седан 4x2',
            MOD_SEDAN_LONG: 'Седан удлинённый',
            MOD_SEDAN_LONG_ARMORED: 'Седан удлинённый бронированный',
            MOD_CABRIO_SHOW: 'Кабриолет show',
            MOD_LIMO_V8_CIVIL: 'Лимузин бронированный (гражд.)',
            MOD_SUV: 'SUV',
            MOD_SUV_ARMORED: 'SUV бронированный',
            MOD_MPV_4SEAT: 'MPV 4-х местный',
            MOD_MPV_8SEAT_ARMORED: 'MPV бронированный 8-и местный',
            MOD_MPV_9SEAT: 'MPV 9-и местный',
            MOD_MPV_9SEAT_ARMORED: 'MPV бронированный 9-и местный',
            MOD_MPV_4SEAT_ARMORED: 'MPV бронированный 4-х местный',
            MOD_MPV_ORBITA: 'MPV Орбита',
            MOD_MPV_TABLETKA: 'MPV Таблетка',
            MOD_PATRIOT: 'УАЗ Патриот (легковой)',
            MOD_SGR_330365: 'Бортовой с однорядной кабиной',
            MOD_SGR_374195: 'Грузовой фургон',
            MOD_SGR_390995: 'Комби, фургон, разделенный перегородкой',
            MOD_SGR_390945: 'Бортовой с двухрядной кабиной',
            MOD_SGR_220695: 'Пассажирский',
            MOD_SGR_396221: 'Для перевозки заключенных',
            MOD_SGR_396222: 'Для дежурной части',
            MOD_SGR_396223: 'Скорая помощь',
            MOD_SGR_396295: 'Санитарный',
            MOD_PICKUP_SPECIAL: 'Специальный',
            MOD_PICKUP_REGULAR: 'Обычный, с двухрядной кабиной',
            MOD_PROFI_236021: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236022: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236031: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236323: 'Бортовой или фургон, с двухрядной кабиной',
            MOD_PROFI_236324: 'Бортовой или фургон, с двухрядной кабиной',
            MOD_PROFI_CHILD: 'Пассажирский для детей 6-16 лет',
            MOD_PROFI_PASSENGER: 'Пассажирский',
            MOD_PROFI_AMBULANCE: 'Пассажирский, скорая помощь',
            MOD_HUNTER: 'УАЗ Хантер'
        },

        EN: {
            APP_NAME: 'Sky web',

            SEARCH: 'Search',

            PAGINATOR_PAGE: 'Page',

            LOAD_FILE: 'Load file',

            YES: 'Yes',
            NO: 'No',

            PHONE: 'Phone',
            EMAIL: 'E-mail',

            START: 'Start',
            STOP: 'Stop',
            FINISH: 'Finish',

            NO_FAILURE: 'No failure',

            // Units
            UNIT_KM: 'km',
            UNIT_KMH: 'km/h',
            UNIT_METRE: 'm',
            UNIT_DAY: 'd',
            UNIT_HOUR: 'h',
            UNIT_MINUTE: 'min',
            UNIT_SECOND: 's',
            UNIT_SECOND_LONG: 'sec.',
            UNIT_LITER: 'l',
            UNIT_LITER_100_KM: 'l/100km',
            UNIT_KVH_100_KM: 'kW/100km',
            UNIT_ML: 'ml',
            UNIT_ATM: 'atm',
            UNIT_BAR: 'Bar',
            UNIT_RPM: 'rpm',
            UNIT_VOLT: 'V',
            UNIT_WATT: 'W',
            UNIT_WATT_HOUR: 'Wh',
            UNIT_KWATT: 'kW',
            UNIT_KWATT_HOUR: 'kWh',
            UNIT_A: 'A',
            UNIT_MA: 'mA',

            USER_ATTRS_NAVI: 'Navigation data',
            USER_ATTRS_REMOTE: 'Remote control',

            // Forms text
            FORM_REQUIRED: 'Required fields',
            FORM_ENTER: 'Enter a value',
            FORM_SELECT_COLOR: 'Choose a color from the list',
            FORM_SELECT: 'Choose from the list',
            FORM_SEARCH: 'Search',

            // Buttons text
            BTN_ADD: 'Add',
            BTN_CREATE: 'Create',
            BTN_NEW: 'New',
            BTN_EDIT: 'Edit',
            BTN_SAVE: 'Save',
            BTN_READMORE: 'Show',
            BTN_CANCEL: 'Cancel',
            BTN_DELETE: 'Delete',
            BTN_CTRL: 'Control',
            BTN_REQUEST: 'Request',
            BTN_SHOW: 'Show',
            BTN_UPLOAD: 'Upload',
            BTN_DOWNLOAD: 'Download',
            BTN_CLOSE: 'Close',
            BTN_SELECT: 'Select',
            BTN_EXPORT: 'Export',
            BTN_FAVORITES: 'Favorites',
            BTN_RESET: 'Reset',
            BTN_SEND: 'Send',
            BTN_MORE: 'Read more',
            BTN_UPDATE: 'Update',
            BTN_UNLINK: 'Unlink',
            BTN_CHANGE: 'Change',
            BTN_REISSUE: 'Reissue',
            BTN_MAP: 'Map',
            BTN_SUBSCRIBE: 'Subscribe',

            // Week days & "quick dates"
            MONDAY: 'Monday',
            TUESDAY: 'Tuesday',
            WEDNESDAY: 'Wednesday',
            THIRSDAY: 'Thirsday',
            FRIDAY: 'Friday',
            SATURDAY: 'Saturday',
            SUNDAY: 'Sunday',
            TODAY: 'Today',
            YESTERDAY: 'Yesterday',
            DAY_BEFORE_YESTERDAY: 'Two day ago',
            IN_A_WEEK: 'Last week',

            BREADCRUMBS: 'Navigator',

            // Liquid  levels
            LEVEL_CRITICAL_LOW: 'Critical low level',
            LEVEL_LOW: 'Low level',
            LEVEL_NORMAL: 'Normal level',
            LEVEL_HIGH: 'High level',

            // Main menu
            MENU_AUTH: 'Authorization',
            MENU_REGISTRATION: 'Registration',
            MENU_FORGOT: 'Once log-in',
            MENU_MAIN: 'Home',
            MENU_CARS: 'Cars',
            MENU_AREAS: 'Areas',
            MENU_FIRMWARES: 'Firmwares',
            MENU_FIRMWARE: 'Firmware',
            MENU_GUIDE: 'Guide',
            MENU_USERS: 'Users',
            MENU_USER: 'User',
            MENU_GROUPS: 'Groups',
            MENU_USER_CHANGE_PASSWORD: 'Change password',

            // Car menu
            CARMENU_INFO: 'Information',
            CARMENU_MAP: 'Map',
            CARMENU_AREAS: 'Areas',
            CARMENU_TRIPS: 'Trips',
            CARMENU_STATE: 'States',
            CARMENU_ECUS: 'ECU`s',
            CARMENU_ECU: 'ECU',
            CARMENU_SDM: 'SDM',
            CARMENU_LOGS: 'Logs',
            CARMENU_RIGHTS: 'Rights & access',
            CARMENU_CHARGING: 'Charging',
            CARMENU_EVENTS: 'Events',
            CARMENU_HISTORY: 'History of indications',

            // Users group menu
            MENU_USERS_GROUP: 'User group',
            MENU_USERS_GROUP_INFO: 'Information',
            MENU_USERS_GROUP_USERS: 'Users',
            MENU_USERS_GROUP_CARS: 'Cars',
            MENU_USERS_GROUP_CARS_GROUPS: 'Cars groups',

            // Cars group menu
            MENU_CARS_GROUP_INFO: 'Information',
            MENU_CARS_GROUP_CARS: 'Cars',
            MENU_CARS_GROUP_USERS_GROUPS: 'Users groups',

            // Cars group
            CARS_GROUP_UPDATE_SUCCESS: 'The cars group has been updated successfully',

            // Page headers
            PAGE_MAIN: 'Main',
            PAGE_CARS: 'Cars',
            PAGE_USERS: 'Users',
            PAGE_USER_CREARE: 'New user',
            PAGE_PROFILE: 'Profile',
            PAGE_GUIDE: 'Guide',
            PAGE_CAR: 'Car',
            PAGE_CAR_INFO: 'Information',
            PAGE_CAR_ECU: 'Electronic units',
            PAGE_CAR_MAP: 'Map',
            PAGE_CAR_STATE: 'States',
            PAGE_CAR_USERS: 'Users',
            PAGE_CAR_LOGS: 'Logs',
            PAGE_CAR_EVENTS: 'Events',
            PAGE_CAR_AREAS: 'Areas',
            PAGE_CAR_HISTORY: 'History of readings of instruments and sensors',
            PAGE_FIRMWARES: 'Firmwares',
            PAGE_CAR_RIGHTS: 'Rights & access',
            PAGE_GROUPS: 'Groups',
            PAGE_GROUP_INFO: 'Group information',
            PAGE_GROUP_CARS: 'Group cars',
            PAGE_GROUP_USERS: 'Group users',
            PAGE_USER_CARS: 'User cars',
            PAGE_TEST: 'Test form',

            // Authorization & single auth
            AUTHORIZATION: 'Authorization',
            LOGIN: 'Login',
            LOGIN_SHORT: 'Login must be longer than 6 characters',
            PASSWORD: 'Password',
            PASSWORD_SHORT: 'Password must be longer than 6 characters',
            SMART_CAPTCHA_VALUE: 'Prove that you are not a robot',
            SMART_CAPTCHA_POLICY: 'We using',
            SMART_CAPTCHA_ERROR_LOAD: 'Captcha loading error',
            SMART_CAPTCHA_ERROR_JS: 'Captcha internal error',
            SMART_CAPTCHA_ERROR_NETWORK: 'Captcha network error',
            SMART_CAPTCHA_ERROR_METHOD: 'Method window.smartCaptcha not defined',
            AUTHORIZATE: 'Log in',
            SINGLE_AUTH: 'Single auth',
            EMAIL_CODE: 'Code from e-mail/sms',
            EMAIL_SHORT: 'E-mail must be longer than 6 characters',
            REQUEST_PASSWORD: 'Request password',

            // User registration
            REGISTRATION: 'Registration',
            REGISTRATION_FIRLSNAME: 'First name',
            REGISTRATION_LASTNAME: 'Last name',
            REGISTRATION_SURNAME: 'Surname',
            REGISTRATION_EMAIL: 'E-mail',
            REGISTRATION_PHONE: 'Phone',
            REGISTRATION_PASS: 'Password',
            REGISTRATION_PASS_REPEAT: 'Repeat password',
            REGISTRATION_SUCCESS:
                'Your registration request has been accepted. To activate your account, follow the link in the email sent to the email address you provided.',
            REGISTRATION_VERIFY_SUCCESS: 'Your email has been successfully confirmed.',
            REGISTRATION_VERIFIED: 'Your account has been successfully activated.',

            // Users & cars groups
            GROUP_NAME: 'Name',
            GROUP_DESCR: 'Description',
            GROUP_TYPES: 'Group access',
            GROUP_INFO: 'Information',
            GROUP_CARS: 'Cars',
            GROUP_CARS_VIN: 'VIN',
            GROUP_CARS_NUMBER: 'Number',
            GROUP_CARS_DELETE: 'Delete car',
            GROUP_CARS_DELETE_TEXT: 'This car will be deleted from group. Are you sure you want to delete it?',
            GROUP_CARS_DELETE_SUCCESS: 'Car successfuly deleted from group',
            GROUP_USERS: 'Users',
            GROUP_USERS_CREATE: 'Add user in group',
            GROUP_USERS_CREATE_SUCCESS: 'User successfuly added in group',
            GROUP_USERS_DELETE: 'Delete user from group',
            GROUP_USERS_DELETE_TEXT: 'This user will be deleted from group. Are you sure you want to delete it?',
            GROUP_USERS_DELETE_SUCCESS: 'User successfuly deleted from group',

            // User rights
            RIGHTS: 'Rights',
            READ: 'Read',
            READ_WRITE: 'Read and write',
            READ_WRITE_DELETE: 'Read, write and delete',
            NO_ACCESS: 'No rights',
            NO_RIGHT: 'No rights',
            RIGHT_BLOCKED: 'Blocked',
            NONE: 'No rights',
            USER_RIGHTS_READ: 'Read',
            USER_RIGHTS_APPEND: 'Append',
            USER_RIGHTS_WRITE: 'Edit',
            USER_RIGHTS_DELETE: 'Delete',
            USER_RIGHTS_PRIVATE: 'Private',
            USER_RIGHTS_POINT: 'Point',
            USER_RIGHTS_STATE: 'State',
            USER_RIGHTS_COORDS: 'Coords',
            USER_RIGHTS_CMD: 'Send commands',

            // User types
            USER_TYPE_USER: 'User',
            USER_TYPE_EXPERT: 'Expert',
            USER_TYPE_SUPER: 'Administrator',
            USER_TYPE_SUPER_DESCR: 'WARNING! This user have been full access for application.',

            // Users groups
            USERS_GROUPS: 'Users groups',
            USERS_GROUPS_EMPTY: 'Users groups not found',
            USERS_GROUPS_INFO: 'Group information',
            USERS_GROUPS_NAME: 'Group name',
            USERS_GROUPS_DESCR: 'Description',
            USERS_GROUPS_CREATE: 'Create users group',
            USERS_GROUPS_CREATE_SUCCESS: 'Users group successfuly created',
            USERS_GROUPS_CREATE_NAME: 'Name',
            USERS_GROUPS_CREATE_DESCR: 'Description',
            USERS_GROUPS_DELETE: 'Delete group',
            USERS_GROUPS_DELETE_DESCR: 'This group will be permanently deleted. Are you sure you want to delete it?',
            USERS_GROUPS_DELETE_SUCCESS: 'Group deleted successfully',

            USERS_GROUPS_USERS: 'Group users',
            USERS_GROUPS_USERS_CREATE: 'Add user',
            USERS_GROUPS_USERS_CREATE_SUCCESS: 'User added to group',
            USERS_GROUPS_USERS_DELETE: 'Deleting a group user',
            USERS_GROUPS_USERS_DELETE_DESCR:
                'The user will be permanently removed from the group. Are you sure you want to remove it?',
            USERS_GROUPS_USERS_DELETE_SUCCESS: 'The user was successfully removed from the group',
            USERS_GROUPS_USERS_SESSION:
                'When adding/removing users, all their sessions will be deleted. They will be required to re-authorize on all devices.',

            USERS_GROUPS_CARS_GROUPS: 'Cars groups',
            USERS_GROUPS_CARS_GROUPS_CREATE: 'Link group',
            USERS_GROUPS_CARS_GROUPS_CREATE_SUCCESS: 'Groups are linked',
            USERS_GROUPS_CARS_GROUPS_UPDATE_SUCCESS: 'Cars group updated',
            USERS_GROUPS_CARS_GROUPS_DELETE: 'Deleting a car group',
            USERS_GROUPS_CARS_GROUPS_DELETE_DESCR:
                'This group of cars will be unlinked from the selected user group. Are you sure you want to do this?',
            USERS_GROUPS_CARS_GROUPS_DELETE_SUCCESS: 'The car group is unlinked from the selected user group',

            USERS_GROUPS_CARS: 'Car users groups',
            USERS_GROUPS_CARS_CREATE: 'Add a car to a group',
            USERS_GROUPS_CARS_CREATE_SUCCESS: 'Car added to group',
            USERS_GROUPS_CARS_UPDATE_SUCCESS: 'Group car edited',
            USERS_GROUPS_CARS_DELETE: 'Removing from a group',
            USERS_GROUPS_CARS_DELETE_DESCR:
                'This car will be removed from the group. Are you sure you want to do this?',
            USERS_GROUPS_CARS_DELETE_SUCCESS: 'The car has been removed from the group',

            // Users
            USERS_NAME: 'Name',
            USERS_MID_NAME: 'Surname',
            USERS_LAST_NAME: 'Last name',
            USERS_APPERAL: 'Apperal',
            USERS_TYPE: 'Type',
            USERS_GROUP: 'Group',
            USERS_EMAIL: 'E-mail',
            USERS_PHONE: 'Phone',

            // Create user
            USER_CREATE_NAME: 'Name',
            USER_CREATE_MID_NAME: 'Surname',
            USER_CREATE_LAST_NAME: 'Last name',
            USER_CREATE_ATTR: 'Attributes',
            USER_CREATE_TYPE: 'Type',
            USER_CREATE_GROUP: 'Group',
            USER_CREATE_GROUP_EMPTY: 'No group',
            USER_CREATE_GROUP_NEW: 'New',
            USER_CREATE_GROUP_NEW_NAME: 'Name',
            USER_CREATE_GROUP_NEW_DESCR: 'Description',
            USER_CREATE_EMAIL: 'E-mail',
            USER_CREATE_PHONE: 'Phone',
            USER_CREATE_PASS: 'Password',
            USER_CREATE_PASS_REPEAT: 'Repeat password',
            USER_CREATE_PASS_DESCR:
                'Minimum 6 characters, 1 lowercase and 1 uppercase letter, any printable characters.',

            // Users & profile
            PROFILE: 'Profile',
            LOGOUT: 'Logout',
            USER: 'User',
            USERS: 'Users',
            USER_CREATE: 'Create new user',
            USER_EMAIL: 'E-mail',
            USER_PASS: 'Password',
            USER_PASS_REPEAT: 'Repeat password',
            USER_SUBSCR: 'Subscribtion settings',
            USER_SUBSCR_TITLE: 'Subscribtion settings',
            USER_SUBSCR_DESCR:
                'The time zone selected in the profile settings will affect the time displayed in the event emails you receive via email. By default, event times are recorded in UTC ±0:00 format.',
            USER_SUBSCR_EMAIL: 'E-mail',
            USER_RIGHT: 'Rights',
            USER_TYPE: 'User type',
            USER_GROUP: 'Group',
            USER_GROUP_EMPTY: 'No group',
            USER_GROUPS_EMPTY: 'Groups not found',
            USER_GROUPS: 'Group select',
            USER_PHONE: 'Phone',
            USER_CREATED: 'Created',
            USER_UPDATED: 'Updated',
            USER_CREATE_SUCCESS: 'New user added',
            USER_UPDATE_SUCCESS: 'User profile updated',
            USER_GROUP_UPDATE_SUCCESS: 'User group update successful',
            USER_DELETE: 'Delete user',
            USER_DELETE_TEXT:
                'This user will be deleted without possibility of restoration. Are you sure you want to delete it?',
            USER_DELETE_SUCCESS: 'User deleted',
            USER_INFO: 'Info',
            USER_LOG: 'Activity Log',
            USER_INFO_HEADER: 'User info',
            USER_INFO_SUBSCR_TIMEZONE: 'Time zone',
            USER_INFO_SUBSCR_ENABLED: 'Enable subscribe',
            USER_INFO_LANG: 'Choose app language',
            USER_INFO_LANG_TITLE: 'Language',
            USER_ACTIONS: 'User actions log',
            USER_ACTION: 'Action',
            USER_DATETIME: 'Date, time',
            USER_EMPTY: 'The user has no cars yet',
            USER_NAME: 'Name',
            USER_LAST_NAME: 'Last name',
            USER_SURNAME: 'Surname',
            USER_EMAIL_ERROR: 'Enter the correct E-mail',
            USER_TYPE_ERROR: 'Select the user type',
            USER_RIGHT_ERROR: 'Select the type of user rights',
            USER_PASS_ERROR: 'At least 6 characters, contains capital letters and numbers',
            USER_PASSWORD_CHANGE: 'Change password',
            USER_STATUS_ACTIVE: 'User active',
            USER_STATUS_LOCKED: 'User blocked',
            USER_STATUS_LOCK: 'Block user',
            USER_ATTR_WARNING:
                'If a user`s attributes are changed, all of his sessions will be deleted. He will need to re-authorize on all devices.',
            RESET_TOKEN: 'End all sessions',
            RESET_TOKEN_SUCCESS: 'All sessions completed successfully',

            // Time zones
            TIMEZONE_UTC: 'International Date Line (UTC-12)',
            TIMEZONE_SAMOA: 'Pago Pago, American Samoa (UTC-11)',
            TIMEZONE_GONOLULU: 'Honolulu, USA (UTC-10)',
            TIMEZONE_ANCHORAGE: 'Anchorage, USA (UTC-09)',
            TIMEZONE_LOS_ANGELES: 'Los Angeles, USA (UTC-08)',
            TIMEZONE_DENVER: 'Denver, USA (UTC-07)',
            TIMEZONE_CHIKAGO: 'Chicago, USA (UTC-06)',
            TIMEZONE_NEW_YORK: 'New York, USA (UTC-05)',
            TIMEZONE_CANADA: 'Halifax, Canada (UTC-04)',
            TIMEZONE_ARGENTINA: 'Buenos Aires, Argentina (UTC-03)',
            TIMEZONE_SOUTH_GEORGIA: 'South Georgia (UTC-02)',
            TIMEZONE_CABO_VERDE: 'Praia, Cape Verde (UTC-01)',
            TIMEZONE_LONDON: 'London, United Kingdom (UTC±00)',
            TIMEZONE_BERLIN: 'Berlin, Germany (UTC+01)',
            TIMEZONE_KYIV: 'Kiev, Ukraine (UTC+02)',
            TIMEZONE_MOSCOW: 'Moscow (UTC+03)',
            TIMEZONE_SAMARA: 'Samara (UTC+04)',
            TIMEZONE_EKATERINBURG: 'Yekaterinburg (UTC+05)',
            TIMEZONE_OMSK: 'Omsk (UTC+06)',
            TIMEZONE_KRASNOYARSK: 'Krasnoyarsk (UTC+07)',
            TIMEZONE_IRKUTSK: 'Irkutsk (UTC+08)',
            TIMEZONE_YAKUTSK: 'Yakutsk (UTC+09)',
            TIMEZONE_VLADIK: 'Vladivostok (UTC+10)',
            TIMEZONE_MAGADAN_ZNACHIT_OPYAT_DOMOY: 'Magadan (UTC+11)',

            // Attributes for distributing rights and privileges
            GROUPS_ATTRS: 'Attributes',
            GROUPS_ATTRS_BASE: 'Base settings',
            GROUPS_ATTRS_LOGS_CAR: 'Cars log',
            GROUPS_ATTRS_EDIT_PRIVATE_CAR: 'Edit manufactorer info',
            GROUPS_ATTRS_GEODATA: 'Navigation information',
            GROUPS_ATTRS_REMOTE_CONTROL: 'Remote control',
            GROUPS_ATTRS_DIAGNOSTIC: 'ECU reports',
            GROUPS_ATTRS_PARAM: 'Set and remove SDM params',
            GROUPS_ATTRS_FIRMWARE: 'Firmwares',
            GROUPS_ATTRS_COMMAND: 'Send SDM commands',
            GROUPS_ATTRS_GROUP_ADMIN: 'Users group admin',
            GROUPS_ATTRS_SUPER_ADMIN: 'System administrator',
            GROUPS_ATTRS_DEVELOPER: 'Developer mode',
            GROUPS_ATTRS_GROUP_NAVI: 'Navigation information',
            GROUPS_ATTRS_GROUP_REMOTE: 'Remote control',
            GROUPS_ATTRS_GROUP_DIAGNOSTIC: 'Diagnostics',
            GROUPS_ATTRS_GROUP_DEVELOPER: 'Developer Mode',
            GROUPS_ATTRS_GROUP_OWNER: 'Owner',

            // User cars
            USER_CARS: 'User cars',
            USER_CARS_EMPTY: 'This user doesn`t have any cars',
            USER_CARS_CREATE: 'User cars',
            USER_CARS_CREATE_TITLE: 'Rules control',
            USER_CARS_ACCESS: 'Access',
            USER_CARS_CREATE_SUCCESS: 'The car was added to the user',
            USER_CARS_UPDATE_SUCCESS: 'The user`s car has been updated',
            USER_CARS_DELETE: 'Delete a car',
            USER_CARS_DELETE_TEXT: 'The car will be deleted without the possibility of recovery',
            USER_CARS_DELETE_SUCCESS: 'Access to the car is removed',
            USER_CARS_ADD: 'Add a car',

            // Cars
            CARS: 'Cars',
            CARS_MODEL: 'Model',
            CARS_NAMI_NUMBER: 'Manufactorer code',
            CARS_TYPE: 'Body',
            CARS_VIN: 'VIN',
            CARS_SEARCH_MODE_ALL: 'All',
            CARS_SEARCH_MODE_VIN: 'VIN',
            CARS_SEARCH_MODE_TID: 'id SDM',
            CARS_SEARCH_MODE_IMEI: 'IMEI',
            CARS_SEARCH_MODE_NUMBER: 'Car number',
            CARS_SEARCH_MODE_NAMI: 'NAMI number',
            CARS_SEARCH_MODE_PHONE: 'Phone',

            // Cars groups
            CARS_GROUPS: 'Cars groups',
            CARS_GROUP: 'Cars group',
            CARS_GROUPS_EMPTY: 'Cars groups not found',
            CARS_GROUPS_INFO: 'Group information',
            CARS_GROUPS_NAME: 'Group name',
            CARS_GROUPS_DESCR: 'Description',
            CARS_GROUPS_CREATE: 'Create cars group',
            CARS_GROUPS_CREATE_SUCCESS: 'Cars group successfuly created',
            CARS_GROUPS_CREATE_NAME: 'Name',
            CARS_GROUPS_CREATE_DESCR: 'Description',
            CARS_GROUPS_UPDATE_SUCCESS: 'Cars group successfuly updated',
            CARS_GROUPS_DELETE: 'Delete group',
            CARS_GROUPS_DELETE_DESCR: 'This group will be permanently deleted. Are you sure you want to delete it?',
            CARS_GROUPS_DELETE_SUCCESS: 'Group deleted successfully',

            CARS_GROUPS_CARS: 'Group cars',
            CARS_GROUPS_CARS_EMPTY: 'Group cars not found',
            CARS_GROUPS_CARS_CREATE_SUCCESS: 'The car was added to the group',
            CARS_GROUPS_CARS_DELETE_SUCCESS: 'The car was deleted from the group',

            CARS_GROUPS_USERS_GROUPS: 'Users groups',
            CARS_GROUPS_USERS_GROUPS_CREATE: 'Linking user groups',
            CARS_GROUPS_USERS_GROUPS_CREATE_SUCCESS: 'A user group is linked to a car group',
            CARS_GROUPS_USERS_GROUPS_UPDATE_SUCCESS: 'Users group updated',
            CARS_GROUPS_USERS_GROUPS_DELETE: 'Unlinking a user group',
            CARS_GROUPS_USERS_GROUPS_DELETE_DESCR: 'The selected group of users will lose access to this group of cars',
            CARS_GROUPS_USERS_GROUPS_DELETE_SUCCESS: 'User group unlinked',

            // Groups associated with the selected vehicle
            CAR_GROUP_CREATE: 'Add a car to a group',
            CAR_GROUP_CREATE_SUCCESS: 'Car added to group',
            CAR_GROUP_DELETE: 'Removing a car from a group',
            CAR_GROUP_DELETE_DESCR:
                'This vehicle will be removed from the selected group. Are you sure you want to do this?',
            CAR_GROUP_DELETE_SUCCESS: 'The car has been removed from the selected group',

            // Car
            CAR: 'Car',
            CAR_UUID: 'UUID',
            CAR_VIN: 'VIN',
            CAR_VIN_UPDATE: 'VIN Update',
            CAR_ALWAYS_CONNECTED: 'Always enable',
            CAR_CREATED: 'Car added',
            CAR_NAME: 'Name',
            CAR_NUMBER: 'Car number',
            CAR_PHONE: 'Phone [SDM]',
            CAR_NAMI_NUMBER: 'Manufactorer code',
            CAR_GARAGE: 'Inventory number',
            CAR_STATE: 'Description',
            CAR_CARTYPE: 'Car type',
            CAR_COLOR: 'Color',
            CAR_ENGINE: 'Engine',
            CAR_SUSPENSION: 'Suspension',
            CAR_YEAR: 'Model year',
            CAR_MODEL: 'Model',
            CAR_MODEL_UNKNOWN: 'Unknown model',
            CAR_MANUFACTORY: 'Manufactur',
            CAR_CREATE_CARTYPE: 'Select car type',
            CAR_TID: 'id SDM',
            CAR_SOFT: 'Module software',
            CAR_IMEI: 'IMEI',
            CAR_ICC_ID: 'ICC ID',
            CAR_ERA_ICC_ID: 'ERA ICC ID',
            CAR_TYPE: 'Platform',
            CAR_TYPE_UNKNOWN: 'Unknown / Not set',
            CAR_TYPE_UMP10: 'UMP 1.0',
            CAR_TYPE_UMP15: 'UMP 1.5',
            CAR_TYPE_UMP15BEV: 'UMP 1.5 BEV',
            CAR_TYPE_UMP15PHEV: 'UMP 1.5 PHEV',
            CAR_TYPE_EMP20: 'EMP 2.0',
            CAR_TYPE_UAZ: 'UAZ',
            CAR_MODULES: 'Modules info',
            CAR_CREATE: 'New car',
            CAR_CREATE_SUCCESS: 'New car created',
            CAR_DELETE: 'Delete a car',
            CAR_DELETE_TEXT:
                'This car will be deleted without possibility of restoration. Are you sure you want to delete it?',
            CAR_DELETE_SUCCESS: 'Car deleted',
            CAR_INFO: 'Car info',
            CAR_INFO_UPDATE_SUCCESS: 'Car info updated',
            CAR_VIN_ERROR: 'VIN length is 17 characters',
            CAR_IMEI_ERROR: 'IMEI length is 15 characters',
            CAR_TYPE_ERROR: 'Choose car type',
            CAR_TID_ERROR: 'A number from 0 to 2147483647',
            CAR_COLOR_CHOOSE: 'Choose a color',
            CAR_PHOTO: 'Photo',
            CAR_STATUS: 'Status',
            CAR_RIGHTS: 'Rights & access',
            CAR_GROUPS: 'Car groups',
            CAR_GROUPS_NAME: 'Name',
            CAR_GROUPS_DESCR: 'Description',
            CAR_GROUPS_CARS_CREATE: 'Add car to the group',
            CAR_GROUPS_CARS_DELETE: 'Delete car from the group',
            CAR_GROUPS_CARS_DELETE_DESCR:
                'This car will be deleted from the group. Are you sure you want to delete it?',
            CAR_USERS: 'Car users',
            CAR_USERS_GROUPS: 'Car users groups',
            CAR_USERS_GROUPS_CREATE: 'Add users groups to car',
            CAR_USERS_GROUPS_CREATE_SUCCESS: 'User group added to car',
            CAR_USERS_GROUPS_UPDATE_SUCCESS: 'User group updated',
            CAR_USERS_GROUPS_DELETE: 'Unlink user group',
            CAR_USERS_GROUPS_DELETE_DESCR:
                'The selected group of users will lose access to this vehicle. Are you sure you want to do this?',
            CAR_USERS_GROUPS_DELETE_SUCCESS: 'User group unlinked successfully',
            CAR_USERS_GROUP_NAME: 'Name',
            CAR_USERS_GROUP_DESCR: 'Describtion',
            CAR_USERS_CREATE: 'Add car users',
            CAR_USERS_CREATE_SUCCESS: 'The user has access to this vehicle',
            CAR_USERS_DELETE: 'Removing access to the vehicle',
            CAR_USERS_DELETE_DESCR: 'This user will lose access to the selected car. Are you sure you want to do this?',
            CAR_USERS_DELETE_SUCCESS: 'User access to the vehicle is denied',
            CAR_USER_UPDATE_SUCCESS: 'User rights for the car have been updated',
            CAR_USER_DELETE: 'Deleting a user car',
            CAR_USER_DELETE_DESCR:
                'The user will lose access to the selected vehicle. Are you sure you want to remove access?',
            CAR_USER_DELETE_SUCCESS: 'User access to the vehicle has been removed',
            CAR_TRIPS: 'Trips',
            CAR_TRIPS_MILEAGE: 'Mileage',
            CAR_TRIPS_TIME: 'Time',
            CAR_TRIPS_SPEAD: 'Average speed',
            CAR_TRIPS_CONSUMPTION: 'Average consumption',
            CAR_TRIPS_ASSESSMENT: 'Driving style',
            CAR_TRIPS_BEGIN: 'Begin',
            CAR_TRIPS_END: 'End',
            CAR_TRIPS_MAP: 'Map',
            CAR_TRIPS_NO_COORDS: 'No coordinates',
            CAR_EVENTS_ERROR_MAX_PERIOD: 'The maximum time period for the request has been exceeded.',
            CAR_EVENTS_ERROR_INVALID_LIMITS: 'The end date of the period must be later than the start date.',
            CAR_EVENTS_ERROR_NO_LIMITS: 'Specify the start and end dates of the period',

            CAR_CHARGER: 'Charger',
            CAR_START_CHARG: 'Start charg',
            CAR_END_CHARG: 'End charg',
            CAR_TOTAL_CHARGING_POWER: 'Charged',
            CAR_CHARGE_TIME: 'Time',

            // Владелец
            CAR_OWNER: 'Owner',
            CAR_OWNER_CREATE: 'Create car owner',
            CAR_OWNER_DELETE: 'Car owner delete',
            CAR_OWNER_DELETE_DESCR:
                'Are you sure you want to remove the owner? This user will lose access to the vehicle unless the administrator has granted them additional rights.',

            // Car co-owners
            CAR_CO_OWNERS: 'Co-owners',
            CAR_CO_OWNERS_NAME: 'Name',
            CAR_CO_OWNERS_ATTRS: 'Permissions',
            CAR_CO_OWNERS_COUNTER: 'Car co-ownerts',
            CAR_CO_OWNERS_CREATE_TITLE: 'Add co-owner',
            CAR_CO_OWNERS_CREATE_INTRO: `
                You can add another user as a co-owner of a car in the apps. <br>
                To do this:
                <ol>
                <li>Make sure the user already has an account;</li>
                <li>Enter their email address or phone number from their profile.</li>
                </ol>
                Be careful: this will give them access to vehicle information.
            `,
            CAR_CO_OWNERS_CREATE_CONTACTS: 'Contacts',
            CAR_CO_OWNERS_CREATE_CONTACTS_ERROR: 'Enter co-owner e-mail or phone number',
            CAR_CO_OWNERS_CREATE_DESCR: 'Description',
            CAR_CO_OWNERS_CREATE_NAVI: 'Block access to geodata',
            CAR_CO_OWNERS_CREATE_NAVI_DESCR:
                'Information about the vehicle`s location, trip history, and receiving location service notifications will be unavailable.',
            CAR_CO_OWNERS_CREATE_REMOTE: 'Disable remote control',
            CAR_CO_OWNERS_CREATE_REMOTE_DESCR:
                'Remote control of the vehicle will be unavailable. Vehicle status information will only be viewable.',
            CAR_CO_OWNERS_DELETE: 'Remove co-owner',
            CAR_CO_OWNERS_DELETE_DESCR:
                'The selected user will lose access to this vehicle unless the administrator has added additional rights to them.',
            CAR_CO_OWNERS_DELETE_SUCCESS: 'Co-owner successfuly deleted',
            CAR_CO_OWNERS_CREATE_SUCCESS: 'Co-owner successfuly added',

            // Типы подвесок
            SUSPENSION_UNKNOWN: 'Unknown suspension',
            SUSPENSION_CONVENTIONAL: 'Convensional',
            SUSPENSION_AIR: 'Air',
            SUSPENSION_D_AIR: 'Air (dual)',

            // Software
            FIRMWARE: 'Firmware',
            FIRMWARE_TITLE: 'Upload firmware',
            FIRMWARE_NAME: 'File name',
            FIRMWARE_TYPE: 'Firmware type',
            FIRMWARE_TYPE_NOT_SET: 'Not set',
            FIRMWARE_TYPE_ANY: 'Any',
            FIRMWARE_TYPE_EGTS: 'EGTS',
            FIRMWARE_TYPE_RLP: 'RLP',
            FIRMWARE_STATUS_WAIT: 'Waiting to load',
            FIRMWARE_STATUS_OK: 'Successfully uploaded',
            FIRMWARE_STATUS_ERROR: 'Loading error',
            FIRMWARE_FILE: 'File',
            FIRMWARE_FILE_SELECT: 'Select a file',
            FIRMWARE_CREATE: 'Create software file',
            FIRMWARE_CREATE_SUCCESS: 'The firmware file has been successfully uploaded, wait for the device update',
            FIRMWARE_DELETE: 'Delete a firmware',
            FIRMWARE_DELETE_TEXT:
                'This software file will be deleted without possibility of restoration. Are you sure you want to delete it?',
            FIRMWARE_DELETE_SUCCESS: 'Software file deleted',
            FIRMWARE_FILE_EMPTY: 'You are trying to download an empty firmware file',
            FIRMWARE_FILE_ERROR: 'No firmware file selected',
            FIRMWARE_FILE_LARGE: 'The file is too large, the maximum file weight to upload - 16 MB',

            FIRMWARES_TITLE: 'Firmwares',
            FIRMWARES_FORM_METHOD: 'Upload method',
            FIRMWARES_FORM_METHOD_CARS: 'Selected cars',
            FIRMWARES_FORM_METHOD_GROUPS: 'Car groups',
            FIRMWARES_FORM_METHOD_ALL: 'All cars',
            FIRMWARES_FORM_METHOD_SELECT: 'Select...',
            FIRMWARES_FORM_SELECT_CARS: 'Add cars to download firmware.',
            FIRMWARES_FORM_SELECT_GROUPS: 'Add car groups to download firmware.',
            FIRMWARES_FORM_SELECT_WARNING:
                'WARNING! You have chosen the download method - All cars. The selected firmware will be downloaded to all cars!',
            FIRMWARES_FORM_ERROR_UNSELECTED: 'Select vehicles or groups to download firmware',
            FIRMWARES_FORM_DEVICE: 'Device version',
            FIRMWARES_FORM_DEVICE_12: 'SDM v1.2',
			FIRMWARES_FORM_DEVICE_20: 'SDM v2.0', 
            FIRMWARES_FORM_DEVICE_30: 'SDM v3.0',
            FIRMWARES_FORM_DEVICE_IC_217: 'NAMI-Intelcom 2.1.7',
            FIRMWARES_FORM_FILE: 'Firmware file',
            FIRMWARES_FORM_MODULE: 'Module',
            FIRMWARES_FORM_VERSION: 'Firmware version',
            FIRMWARES_FORM_VERSION_DESCR:
                'Make sure that the "Firmware version" field contains a value in the format "digits.digits"',
            FIRMWARES_CREATE_SELECT_ELEMENTS: 'Select elements for upload firmware',
            FIRMWARES_CREATE_SUCCESS: 'Firmware successfuly uploaded',
            FIRMWARES_UPDATE: 'Firmware info',
            FIRMWARES_UPDATE_SUCCESS: 'Firmware info successfuly updated',
            FIRMWARES_DELETE: 'Delete firmware',
            FIRMWARES_DELETE_DESCR:
                'The selected firmware file will be deleted. Devices that have not yet received this file or its download has not finished will not receive it. Are you sure you want to do this?',
            FIRMWARES_DELETE_SUCCESS: 'Firmware successfuly deleted',
            FIRMWARES_SEARCH_MODE_ALL: 'All',
            FIRMWARES_SEARCH_MODE_DEVICE: 'Device type',
            FIRMWARES_SEARCH_MODE_MODULE: 'Module',
            FIRMWARES_SEARCH_MODE_VERSION: 'FIrmware version',
            FIRMWARES_NAME: 'File name',
            FIRMWARES_DEVICE: 'Device',
            FIRMWARES_MODULE: 'Module',
            FIRMWARES_SOFTWARE: 'Software',
            FIRMWARES_SELECTOR: 'Select destination',
            FIRMWARES_SELECTOR_LINK: 'Add',

            ECUS_EXPORT_DESCR: 'Select the report files to download',
            ECUS_EXPORT_TYPE_DESCR: 'Select the import method',
            ECUS_EXPORT_SELECT_ALL: 'Select all',
            ECUS_EXPORT_DESELECT_ALL: 'Deselect all',
            ECUS_EXPORT_PDF: 'Download PDF',
            ECUS_EXPORT_EMAIL: 'Send e-mail',
            ECUS_EXPORT_EMAIL_LABEL: 'E-mail',
            ECUS_EXPORT_EMAIL_SUCCESS:
                'The file with the diagnostic results was successfully sent to the specified e-mail address',
            ECUS_EXPORT_ERROR_ECU: 'No block is selected',
            ECUS_EXPORT_ERROR_EMAIL: 'The e-mail address for sending the report is not specified',

            ECUS_DIAG_DELETE: 'Delete all errors',
            ECUS_DIAG_DELETE_DESCR:
                'Will this action clear errors from all vehicle ECUs? Are you sure you want to do this?',
            ECUS_DIAG_REFRESH: 'Update report',
            ECUS_DIAG_REFRESH_SUCCESS: 'Diagnostics is running. The report files will be updated',
            ECUS_DIAG_CLEAR_DTC: 'Clear DTC',
            DIAG_BLOCK_DELETE_SUCCESS: 'The selected report has been deleted successfully.',
            DIAG_IMPORT_EMAIL_SUCCESS:
                'The file with diagnostic reports has been successfully sent to the specified e-mail',
            DIAG_IMPORT_FILE_SUCCESS: 'The file with diagnostic reports has been successfully generated',

            ECUS_VIEWMODE_SCHEME: 'Scheme',
            ECUS_VIEWMODE_GRID: 'List',
            ECUS_VIEWMODE_INSTALLED: 'Active',

            SDM_UPDATE_DATA: 'Refresh data',

            // Car users
            CARUSERS_EMPTY: 'There is no users in this car',
            CARUSERS_CREATE: 'Update car users',
            CARUSERS_CREATE_TITLE: 'Add car user',
            CARUSERS_CREATE_SUCCESS: 'Car user rights creater',
            CARUSERS_UPDATE_SUCCESS: 'Car user rights updated',
            CARUSERS_DELETE: 'Delete user rules',
            CARUSERS_DELETE_TEXT:
                'This user will lose access to the vehicle information. Are you sure you want to remove permissions?',
            CARUSERS_DELETE_SUCCESS: 'Car user deleted',

            // Car types
            CARTYPES: 'Car types',
            CARTYPE_NEW: 'New type',
            CARTYPE_BODY: 'Type',
            CARTYPE_TYPE: 'Modify',
            CARTYPE_UNDEFINED: 'Undefined car type',
            CARTYPE_CREATE_SUCCESS: 'New car type added',
            CARTYPE_UPDATE_SUCCESS: 'Car type updated',
            CARTYPE_DELETE: 'Car type deleting',
            CARTYPE_DELETE_TEXT:
                'This user will be deleted without possibility of restoration. Are you sure you want to delete it?',
            CARTYPE_DELETE_SUCCESS: 'Car type deleted',

            // Events
            EVENTS: 'Events',
            EVENTS_START: 'Events start date',
            EVENTS_END: 'Events end date',
            EVENTS_FILTER: 'Events',
            EVENTS_ERROR_NO_LIMITS: 'Specify the start and end dates of the events',
            EVENTS_ERROR_INVALID_LIMITS: 'The start date of the events must be earlier than the end date',
            EVENTS_ERROR_MAX_PERIOD: 'The maximum interval for requesting events is 31 days',
            EVENTS_EVENT_ON_MAP: 'Event on map',
            EVENTS_EVENT_NO_COORDS: 'Location not saved',
            EVENTS_EVENT: 'Event',
            EVENTS_EVENT_DATE: 'Event date',
            EVENTS_REQUEST: 'Request',
            EVENTS_MAP: 'Map',

            // Online status
            ONLINE: 'Online',
            NOSATELLITES: 'Online',
            OFFLINE: 'Offline',

            // Car commands
            CMD_SEND_HEADER: 'Send CMD',
            CMD_SEND: 'Send',
            CMD_SET_SERVER: 'Set data server',
            CMD_RELOAD: 'Reload SDM',
            CMD_SEND_SUCCESS: 'Command sended',
            CMD_SUCCESS: 'Success',
            CMD_FAILURE: 'Failure',
            CMD_RESULT_NOT_SET: 'Status not set',
            CMD_RESULT_SEND_IN_PROCESS: 'Send in progress',
            CMD_RESULT_SEND_TIMEOUT: 'Send timeout',
            CMD_RESULT_SEND_CONFIRMED: 'Send confirmed',
            CMD_RESULT_RESULT_OK: 'The car sent the result of the command execution: successful execution',
            CMD_RESULT_RESULT_ERROR: 'The car sent the result of the command execution: error',
            CMD_RESULT_RESULT_ILL:
                'The car sent the result of the command execution: error, absence from the list of allowed commands',
            CMD_RESULT_RESULT_DEL: 'The car sent the result of the command execution: successfully deleted',
            CMD_RESULT_RESULT_NOT_FOUND:
                'The car sent the result of the command execution: the command to delete was not found',
            CMD_RESULT_RESULT_NOT_CONFIG:
                'The car sent the result of the command execution: successful execution, negative response',
            CMD_RESULT_RESULT_IN_PROCESS:
                'The car sent the result of the command execution: the command has been submitted for processing',

            // Track request
            CARTRACK: 'Viewing trip tracks',
            CARTRACK_START: 'Period start',
            CARTRACK_END: 'Period finish',
            CARTRACK_EMPTY: 'At this time car wasn`t in motion',
            CARTRACK_LIMIT: 'The maximum time period for a request is 32 days',
            CARTRACK_ERROR_MAX_PERIOD: 'The maximum time period for a request is 32 days',
            CARTRACK_ERROR_INVALID_LIMITS: 'The start date of the route must be earlier than the end date',
            CARTRACK_ERROR_NO_LIMITS: 'Specify the start and end dates of the route',

            // ADTCarTrackEvents
            EVENTS_TRIP_TRACKS: 'Trip tracks',

            // Connection type
            CONNECTION_ON: 'Online',
            CONNECTION_OFF: 'No connection',
            CONNECTION_LTE: 'LTE',
            CONNECTION_UMTS: 'UMTS',
            CONNECTION_GSM: 'GSM',

            // Map controls
            MAP_SIZE_FULL: 'Expand',
            MAP_SIZE_SMALL: 'Roll up',
            MAP_LAYERS_SHOW: 'Show special layers',
            MAP_LAYERS_HIDE: 'Hide special layers',
            MAP_CMD: 'Send CMD',
            MAP_CAR_TRACK: 'Car routes history',
            MAP_CAR_TRACK_RESET: 'Reset car route',
            MAP_CAR_TRACK_MILEAGE: 'Mileage per route',
            MAP_MILEAGE: 'Mileage',

            MAPY_SPEED: 'Speed',
            MAPY_UPDATED: 'Updated',
            MAPY_LAT: 'Lat',
            MAPY_LNG: 'Lng',
            MAPY_AREAS: 'Areas',
            MAPY_CRASH:
                'Failed to load maps. Try refreshing the page (Ctrl+F5) or coming back later. If the error persists, contact the administrator!',

            // EGTS modules
            EGTS_MODULES_MODULE_MAIN: 'Main module',
            EGTS_MODULES_MODULE_INPUT: 'Input module',
            EGTS_MODULES_MODULE_NAVI: 'Navigation module',
            EGTS_MODULES_MODULE_LINK: 'Connection link',
            EGTS_MODULES_VENDOR: 'Vendor code',
            EGTS_MODULES_FIRMWARE: 'Hardware',
            EGTS_MODULES_SOFTWARE: 'Software',
            EGTS_MODULES_MODIFICATION: 'Modification',
            EGTS_MODULES_STATE: 'State',
            EGTS_MODULES_SERIAL: 'S/n',
            EGTS_MODULES_DESCR: 'Description',
            EGTS_MODULES_DATE: 'Build date',

            // EGTS errors status
            EGTS_PC_OK: 'Processed successfully',
            EGTS_PC_IN_PROGRESS: 'In the process',
            EGTS_PC_UNS_PROTOCOL: 'Unsupported protocol',
            EGTS_PC_DECRYPT_ERROR: 'Decoding error',
            EGTS_PC_PROC_DENIED: 'Processing is prohibited',
            EGTS_PC_INC_HEADERFORM: 'Invalid header format',
            EGTS_PC_INC_DATAFORM: 'Invalid data format',
            EGTS_PC_UNS_TYPE: 'Unsupported type',
            EGTS_PC_NOTEN_PARAMS: 'Invalid number of parameters',
            EGTS_PC_DBL_PROC: 'Re-processing attempt',
            EGTS_PC_PROC_SRC_DENIED: 'Processing of data from the source is prohibited',
            EGTS_PC_HEADERCRC_ERROR: 'Header сhecksum error',
            EGTS_PC_DATACRC_ERROR: 'Data Checksum error',
            EGTS_PC_INVDATALEN: 'Incorrect data length',
            EGTS_PC_ROUTE_NFOUND: 'Route not found',
            EGTS_PC_ROUTE_CLOSED: 'The route is closed',
            EGTS_PC_ROUTE_DENIED: 'Routing is not allowed',
            EGTS_PC_INVADDR: 'Invalid address',
            EGTS_PC_TTLEXPIRED: 'Exceeded the number of data retransmissions',
            EGTS_PC_NO_ACK: 'No confirmation',
            EGTS_PC_OBJ_NFOUND: 'Object not found',
            EGTS_PC_EVNT_NFOUND: 'Event not found',
            EGTS_PC_SRVC_NFOUND: 'Service not found',
            EGTS_PC_SRVC_DENIED: 'The service is prohibited',
            EGTS_PC_SRVC_UNKN: 'Unknown service type',
            EGTS_PC_AUTH_DENIED: 'Authorization is not allowed',
            EGTS_PC_ALREADY_EXISTS: 'The object already exists',
            EGTS_PC_ID_NFOUND: 'ID not found',
            EGTS_PC_INC_DATETIME: 'Incorrect date and time',
            EGTS_PC_IO_ERROR: 'I/O error',
            EGTS_PC_NO_RES_AVAIL: 'Insufficient resources',
            EGTS_PC_MODULE_FAULT: 'Internal module failure',
            EGTS_PC_MODULE_PWR_FLT: 'Module power supply circuit failure',
            EGTS_PC_MODULE_PROC_FLT: 'Failure of the modules microcontroller',
            EGTS_PC_MODULE_SW_FLT: 'Failure of the module program',
            EGTS_PC_MODULE_FW_FLT: 'Failure in the internal software of the module',
            EGTS_PC_MODULE_IO_FLT: 'Module I/O block failure',
            EGTS_PC_MODULE_MEM_FLT: 'Failure in the internal memory of the module',
            EGTS_PC_TEST_FAILED: 'Test failed',

            /**
             *  Car states
             *
             * "STATE_" + state name in upper case
             */
            STATE_TABS_STATISTICS: 'Last trip',
            STATE_TABS_LAST_TRIP: 'Travel statistics',
            STATE_TABS_WHEELS: 'Wheels pressure',
            STATE_TABS_BRAKES: 'Brakes system',
            STATE_TABS_INTERIOR: 'Interior condition',
            STATE_TABS_TRANSMISSION: 'Transmission',
            STATE_TABS_BATTERY: 'Battery',
            STATE_TABS_LIGHT: 'Light',
            STATE_TABS_ENGINE: 'Engine',
            STATE_TABS_DOORS: 'Doors & body',
            STATE_TABS_ELECTRIC: 'Battery 12V',
            STATE_TABS_ELECTRIC_HIGH: 'HV battery',
            STATE_TABS_WARNINGS: 'Warnings',

            STATE_INTERIOR_CHAIR_FL: 'Front left chair',
            STATE_INTERIOR_CHAIR_FR: 'Front right chair',
            STATE_INTERIOR_CHAIR_RL: 'Rear left chair',
            STATE_INTERIOR_CHAIR_RR: 'Rear right chair',
            STATE_INTERIOR_CHAIR_DESCR: 'Passengers in the car',
            STATE_INTERIOR_CHAIR_LARGE: 'Adult',
            STATE_INTERIOR_CHAIR_SMALL: 'Child',
            STATE_INTERIOR_CHAIR_CHILD: 'Child seat',
            STATE_INTERIOR_CHAIR_EMPTY: 'Empty',
            STATE_INTERIOR_CHAIR_UNKNOWN: 'Unknown',
            STATE_INTERIOR_CHAIR_ERROR: 'Error',

            STATE_GROUP_BATTERY_12V: 'Battery 12V',
            STATE_GROUP_BATTERY_HW: 'Highvoltage battery',
            STATE_GROUP_LAST_TRIP: 'Last trip',
            // STATE_GROUP_AFTER_RESET:            'After reset',
            STATE_GROUP_MONTH: 'Last month',
            STATE_GROUP_LAST_EVENTS: 'Last events',

            STATE_DMRL_WARNING_INDICATOR: 'DMRL warning indicator',
            STATE_CORNERING_LIGHT_RIGHT_STATUS: 'Cornering light right status',
            STATE_WHEEL_BACK_RIGHT_STATUS: 'Wheel back right status',
            STATE_T30I_FAULT_STATUS: 'T30i fault status',
            STATE_BRAKE_LIGHT_LEFT_STATUS: 'Brake light left status',
            STATE_WHEEL_FRONT_RIGHT_PRESSURE: 'Wheel front right pressure',
            STATE_TURN_INDICATOR_MR_STATUS: 'Turn indicator MR status',
            STATE_DOOR_FRONT_LEFT_CLOSED: 'Door front left closed',
            STATE_RIDE_AVERAGE_SPEED: 'Ride average speed',
            STATE_TEMPERATURE_OUTSIDE: 'Outside temperature',
            STATE_BACK_LEFT_TEMPERATURE: 'Back left temperature',
            STATE_OIL_PRESSURE_WARNING: 'Oil pressure warning',
            STATE_IS_LOCKED: 'Is locked',
            STATE_DOOR_FRONT_RIGHT: 'Door front right',
            STATE_FRONT_INSIDE_TEMPERATURE: 'Front inside temperature',
            STATE_FRONT_RIGHT_TEMPERATURE: 'Front right temperature',
            STATE_STATUS: 'Status',
            STATE_DMFR_WARNING_INDICATOR: 'DMFR warning indicator',
            STATE_OIL_LEVEL: 'Oil level',

            STATE_TPMS_BATTERY_STATUS: 'TPMS battery status',
            STATE_TPMS_BATTERY_STATUS_FL: 'TPMS battery status FL',
            STATE_TPMS_BATTERY_STATUS_FR: 'TPMS battery status FR',
            STATE_TPMS_BATTERY_STATUS_RL: 'TPMS battery status RL',
            STATE_TPMS_BATTERY_STATUS_RR: 'TPMS battery status RR',
            STATE_TPMS_BATTERY_NORMAL: 'Normal',
            STATE_TPMS_BATTERY_LOW: 'Low',

            STATE_WHEEL_PRESSURE_STATUS_HIGH: 'High pressure',
            STATE_WHEEL_PRESSURE_STATUS_NORMAL: 'Normal pressure',
            STATE_WHEEL_PRESSURE_STATUS_LOW: 'Low pressure',
            STATE_WHEEL_PRESSURE_STATUS_CRITICAL: 'Critical low pressure!',
            STATE_WHEEL_PRESSURE_STATUS_ERROR: 'Error!',

            STATE_TRIP_ENERGY_CONSUMED_W: 'Energy expended during the trip',
            STATE_COMM_STATUS: 'Connection status',
            STATE_HV_BATTERY_SOC_PERCENT: 'Charging the high-voltage running battery',
            STATE_ICE_STATUS: 'ICE Status',

            // Удалено в задаче https://git.shatl-t.ru/Frontend/aurus-disp-tool-4/issues/422
            // STATE_ENGINE_TIME:                  'Engine hours',

            STATE_WHEEL_BACK_LEFT_STATUS: 'Wheel back left status',
            STATE_MIL_ONRQ: 'Mil onRq',
            STATE_POSITION_LIGHT_FR_STATUS: 'Position light FR status',
            STATE_HEAD_LIGHT_LEVELING_CTRL_FAILURE: 'Head light leveling ctrl failure',
            STATE_LTC_COOLANT_LVL: 'LTC coolant lvl',
            STATE_BACK_INSIDE_TEMPERATURE: 'Back inside temperature',
            STATE_RECEIVED_SIGNAL_STRENGTH_INDICATOR: 'Received signal strength indicator',
            STATE_DOOR_BACK_LEFT: 'Door back left',
            STATE_WHEEL_BACK_RIGHT_PRESSURE: 'Wheel back right pressure',
            STATE_REVERSE_LIGHT_RIGHT_STATUS: 'Reverse light right status',
            STATE_FRONT_LEFT_TEMPERATURE: 'Front left temperature',
            STATE_START_MOVING: 'Car start time',
            STATE_STOP_MOVING: 'Car stop time',
            STATE_DMRR_WARNING_INDICATOR: 'DMRR warning indicator',
            // STATE_VEHICLE_SECURE_LOCK_STATE: 'Vehicle secure lock state', // State was deleted on backend
            STATE_REAR_FOG_LIGHT_STATUS: 'Rear fog light status',
            STATE_DOOR_FRONT_RIGHT_CLOSED: 'Door front right closed',
            STATE_ABS_LAMP: 'ABS lamp',
            STATE_DMFL_WARNING_INDICATOR: 'DMFL warning indicator',
            STATE_FRONT_RIGHT_FOG_LIGHT_STATUS: 'Front right fog light status',
            STATE_POSITION_LIGHT_RR_STATUS: 'Position light RR status',
            STATE_TURN_INDICATOR_RR_STATUS: 'Turn indicator RR status',
            STATE_LOW_BEAM_RIGHT_STATUS: 'Low beam right status',
            STATE_EPB_STATUS: 'Epb status',
            STATE_ESP_LAMP: 'ESP lamp',
            STATE_TPMS_SENSOR_FAULT_FR: 'TPMS sensor fault FR',
            STATE_T15_FAULT_STATUS: 'T15 fault status',
            STATE_WHEEL_FRONT_LEFT_PRESSURE: 'Wheel front left pressure',
            STATE_TPMS_SENSOR_FAULT_RL: 'TPMS sensor fault RL',
            STATE_RIDE_MILEAGE: 'Ride mileage',
            STATE_LAST_NAVIGATION_TIME: 'Last navigation time',
            STATE_T30D_FAULT_STATUS: 'T30d fault status',
            STATE_BRAKE_LIGHT_RIGHT_STATUS: 'Brake light right status',
            STATE_SYSTEM_FAILURE: 'HV system failure',
            STATE_FUEL: 'Fuel',
            STATE_FUEL_LEVEL: 'Fuel level',
            STATE_FRONT_LEFT_FOG_LIGHT_STATUS: 'Front left fog light status',
            STATE_BRAKE_LIGHT_HM_STATUS: 'Brake light HM status',
            STATE_TURN_INDICATOR_FR_STATUS: 'Turn indicator FR status',
            STATE_POSITION_LIGHT_RL_STATUS: 'Position light RL status',
            STATE_BCM_WARNING_INDICATOR: 'BCM warning indicator',
            STATE_ONLINE: 'Online',
            STATE_OFFLINE: 'Offline',
            STATE_ENGINE_ON: 'Engine on',
            STATE_DAYTIME_LIGHT_RIGHT_STATUS: 'Daytime light right status',
            STATE_DOOR_TRUNK: 'Door trunk',
            STATE_DOOR_BACK_LEFT_CLOSED: 'Door back left closed',
            STATE_MOBILE_NETWORK_TYPE_INDICATOR: 'Mobile network type indicator',
            STATE_NETWORK_TYPE_BB: 'Connection type',
            STATE_NETWORK_RSSI_BB: 'Signal level',
            STATE_POSITION_LIGHT_FL_STATUS: 'Position light FL status',
            STATE_TPMS_SENSOR_FAULT_FL: 'TPMS sensor fault FL',
            STATE_DAYTIME_LIGHT_LEFT_STATUS: 'Daytime light left status',
            STATE_DOOR_FRONT_LEFT: 'Door front left',
            STATE_DOOR_HOOD: 'Door hood',
            STATE_TPMS_SENSOR_FAULT_RR: 'TPMS sensor fault RR',
            STATE_ENGINE_OIL_TEMP: 'Engine oil temp',
            STATE_ENGINE_REV: 'Engine rev',

            STATE_WINDOW_FULLY_CLOSED_FL: 'Window [front left]',
            STATE_WINDOW_FULLY_CLOSED_FR: 'Window [front right]',
            STATE_WINDOW_FULLY_CLOSED_RL: 'Window [rear left]',
            STATE_WINDOW_FULLY_CLOSED_RR: 'Window [rear right]',
            STATE_WINDOW_OPEN: 'The window is open',

            STATE_WHEEL_FRONT_RIGHT_STATUS: 'Wheel front right status',
            STATE_TURN_INDICATOR_ML_STATUS: 'Turn indicator ML status',
            STATE_TCS_LAMP: 'TCS lamp',
            STATE_EBD_LAMP: 'EBD lamp',
            STATE_DOOR_BACK_RIGHT_CLOSED: 'Door back right closed',
            STATE_TURN_INDICATOR_RL_STATUS: 'Turn indicator RL status',
            // STATE_MILEAGE_ON_FUEL_RESIDUES: 'Mileage on fuel residues', // Old state
            STATE_WHEEL_FRONT_LEFT_STATUS: 'Wheel front left status',
            STATE_HIGH_BEAM_LEFT_STATUS: 'High beam left status',
            STATE_ENGINE_TEMPERATURE: 'Engine temperature',
            STATE_RIDE_TIME: 'Ride time',
            STATE_ENGINE_OFF: 'Engine off',
            STATE_WASHER_FLUID: 'Washer fluid',
            STATE_WASHER_FLUID_WARNING: 'Low level of washing liquid',
            STATE_TOTAL_MILEAGE: 'Total mileage',
            STATE_BACK_RIGHT_TEMPERATURE: 'Back right temperature',
            STATE_WHEEL_BACK_LEFT_PRESSURE: 'Wheel back left pressure',
            STATE_MIL_IND_BLINK: 'Mil ind blink',
            STATE_COOLANT_FLUID: 'Coolant fluid',
            STATE_COOLANT_FLUID_NORMAL: 'Normal',
            STATE_COOLANT_FLUID_LOW: 'Low',
            STATE_LOW_BEAM_LEFT_STATUS: 'Low beam left status',
            STATE_RIDE_FUEL_CONSUMPTION: 'Fuel consumption per trip',
            STATE_ENGINE_OIL_LVIND: 'Engine oil level indicator',
            STATE_TURN_INDICATOR_FL_STATUS: 'Turn indicator FL status',
            STATE_DOOR_TRUNK_DIRECTION: 'Door trunk direction',
            STATE_CORNERING_LIGHT_LEFT_STATUS: 'Cornering light left status',
            STATE_HIGH_BEAM_RIGHT_STATUS: 'High beam right status',
            STATE_ESP_SPEED: 'Esp speed',
            STATE_LAST_CAN_PARAM_TIME: 'Last can param time',
            STATE_TM_WARNING_INDICATOR: 'TM warning indicator',
            STATE_REVERSE_LIGHT_LEFT_STATUS: 'Reverse light left status',
            STATE_DOOR_BACK_RIGHT: 'Door back right',
            STATE_SERVICE_DATE: 'Next service date',
            STATE_GEAR_POSITION: 'Gear position',
            STATE_LAST_DIAGNOSTICS_TIME: 'Last diagnostic time',
            STATE_LAST_ONLINE: 'Last online',
            STATE_SERVICE_MILEAGE: 'Service millage',
            STATE_ST_TRANSMISSION_WARNING: 'Transmission warning',
            STATE_SCU_CALIBRATION_STATUS: 'SCU calibration status',
            STATE_CCU_FAILURE: 'CCU failure',
            STATE_CCU_AC: 'A/C',
            STATE_SCU_FAULT_STATUS: 'SCU fault status',
            STATE_ERAG_FAILURE_STATUS: 'ERAG failure status',
            STATE_OPEN: 'Open',
            STATE_HALF_OPEN: 'Half open',
            STATE_CLOSED: 'Closed',
            STATE_NOT_CLOSED: 'Not closed',
            STATE_RESERV: '(reserve)',
            STATE_MILEAGE_WARNING:
                'ATTENTION! The mileage recorded in this electronic unit is significantly different from the mileage stored in the ESP electronic unit',
            STATE_SDM_UPTIME: 'Last power on/restart',
            STATE_VAS_ACTIVATION: 'Security alarm status',
            STATE_LOCK_SECURE: 'Set on guard',
            STATE_CRUISING_RANGE: 'Distance to empty',

            // Params after BC reset
            STATE_TOTAL_MILEAGE_AM: 'Total mileage after BC reset',
            STATE_TOTAL_AVG_SPEED_AM: 'Average speed after BC reset',
            STATE_TOTAL_MINS_AM: 'Time after BC reset',
            STATE_FUEL_CONSUMPTION: 'Fuel consumption after BC reset',

            // Battery 12V
            STATE_BAT_CAPACITY: 'Capacity',
            STATE_BAT_HEALTH: 'Health',
            STATE_BAT_STATUS: 'State',
            STATE_BAT_VOLTAGE: 'Voltage',
            STATE_LVB_SOH: 'Battery health',
            STATE_LVB_SOC: 'Battery capacity',
            STATE_BATTERY_STATUS: 'Battery 12V status',
            STATE_BATTERY_VOLTAGE: 'Battery 12V voltage',
            STATE_BATTERY_12V_STATUS_FULL: 'Full',
            STATE_BATTERY_12V_STATUS_NORMAL: 'Normal',
            STATE_BATTERY_12V_STATUS_REQUEST_CHARGE: 'Request charge',
            STATE_BATTERY_12V_STATUS_DISCHARGE: 'Battery discharge',
            STATE_BATTERY_12V_STATUS_LOW_SOC: 'Low power',
            STATE_BATTERY_12V_STATUS_LOW_VOLT: 'Low voltage',
			STATE_SOH_HV_AKB: 'SoH HV BAT',
			STATE_SOC_HV_AKB: 'SoC HV BAT',

            // Battery High voltage
            STATE_SOH_AKB: 'HV Battery health',
            STATE_SOC_AKB: 'HV battery capacity',
            STATE_LEVEL_PERCENT: 'Battery level',
            STATE_CHARGING_STATUS: 'Charging status',
            STATE_CHARGER_INPUT_POWER_W: 'Charging input power',
            STATE_CHARGER_INPUT_CURRENT_MA: 'Charging input current',
            STATE_CHARGING_SOC_LIMIT_PERCENT: 'Battery charging limit by SoC',
            STATE_REDUCE_CHARGING_STATUS: 'Low charging power status',
            STATE_REMAINING_CHARGING_TIME_S: 'Time for full battery charging',
            STATE_TOTAL_CHARGING_POWER_WH: 'Charging accumulated power',
            STATE_CHARGING_DURATION_S: 'Charging duration',

            STATE_NO_CHARGING: 'No charging',
            STATE_CHARGING_IN_PROGRESS: 'Charging in progress',
            STATE_CHARGING_DONE: 'Charging done',
            STATE_CHARGING_SUSPEND_VEHICLE: 'Charging suspend [vehicle error]',
            STATE_CHARGING_SUSPEND_CHARGER: 'Charging suspend [charger error]',
            STATE_CHARGING_INIT: 'Initialization',
            STATE_CHARGING_V2L_IDLE: 'V2L idle',
            STATE_CHARGING_V2L_ACTIVE: 'V2L active',

            STATE_NOT_REDUCED: 'Not reduced',
            STATE_REDUCED: 'Reduced',

            STATE_COMMON_RIDE_TIME: 'Ride time',
            STATE_COMMON_MILEAGE: 'Mileage',
            STATE_COMMON_FUEL_CONSUMPTION: 'Fuel consumptision',
            STATE_COMMON_FUEL_CONSUMPTION_ELECTRO: 'Power consumptision',
            STATE_COMMON_AVERAGE_SPEED: 'Average speed',

            STATE_OCU_FL_STAT: 'Front left seat',
            STATE_OCU_FR_STAT: 'Front right seat',
            STATE_OCU_RL_STAT: 'Rear left seat',
            STATE_OCU_RR_STAT: 'Rear right seat',

            STATE_SAT: 'Number of visible satellites',

            STATE_TRIP_ACCELERATION: 'Number of accelerations',
            STATE_TRIP_BRAKING: 'Number of braking times',
            STATE_TOTAL_ACCELERATION: 'Number of accelerations',
            STATE_TOTAL_BRAKING: 'Number of braking times',
            STATE_ANS1: 'ANS1',
            STATE_ANS2: 'ANS2',
            STATE_ANS3: 'ANS3',
            STATE_ANS4: 'ANS4',
            STATE_ANS5: 'ANS5',
            STATE_DIG1: 'DIG1',
            STATE_DIG2: 'DIG2',
            STATE_DIG3: 'DIG3',
            STATE_DIG4: 'DIG4',
            STATE_DIG5: 'DIG5',
            STATE_ALARM_SYSTEM: 'Alarm System',
            STATE_SRC: 'Source',
            STATE_CONN_TYPE: 'Connection type',
            STATE_MOV: 'Movement',
            STATE_NOT_SET: 'Not set',
            STATE_COOLANT_TEMPERATURE: 'Engine coolant temperature',
            STATE_ENGINE_OIL_TEMPERATURE: 'Engine oil temperature',

            STATE_SPD: 'Car speed',
            STATE_ALT: 'High',

            STATE_VAS_ACTIVE: 'The security alarm is armed',
            STATE_VAS_INACTIVE: 'The security alarm is turned off',

            DRIVING_ASSESSMENT: 'Driving assessment',

            // History params charts
            // Component ADTStatesHistory
            HISTORY: 'Archive of states',
            HISTORY_DESCR: 'View the history of states for a selected period of time',
            HISTORY_REQUEST_TEXT: 'Select the start and end time of the readings',
            HISTORY_START: 'Start',
            HISTORY_END: 'End',
            HISTORY_SEARCH: 'Search by name...',
            HISTORY_PARAMS: 'Params',
            HISTORY_TIME: 'Time',
            HISTORY_ERROR_PARAMS: 'Params not selected!',
            HISTORY_ERROR_RANGE: 'The maximum interval for requesting charts is 31 days',
            HISTORY_ERROR_TIME_INCORRECT: 'The start time for recording graphs should be earlier than the end time',
            HISTORY_ERROR_TIME_EMPTY: 'Specify the start and end dates of the route',
            HISTORY_EMPTY_POINTS: 'No points recorded for the selected time interval',
            HISTORY_EMPTY_VALUE: 'No states recorded for the selected time interval',
            HISTORY_SHOW_GRID: 'Show grid',
            HISTORY_INSTRUCTION:
                'Click on the chart with the left mouse button, then drag to enlarge the selected area. To move the chart, hold down Ctrl key',
            HISTORY_INSTRUCTION_PANNING:
                'To zoom in, stretch the area on the graph. To shift the graph, swipe with two fingers',

            // Events
            EVENT_VIN: 'VIN',
            EVENT_TYPE: 'Event',
            EVENT_MAP: 'Event on map',
            EVENT_SEARCH: 'Search events',
            EVENT_DATE: 'Date',
            EVENT_COORDS: 'Coordinates',
            EVENT_GOTO_CAR: 'Go to car',
            EVENT_ALL: 'All',
            EVENT_ENGINE_ON: 'Turning on the engine',
            EVENT_REMOTE_ENGINE_ON: 'Remote engine start-up',
            EVENT_ENGINE_OFF: 'Turning off the engine',
            EVENT_DECREASE_MILEAGE: 'Decrease in total mileage',
            EVENT_PROTECTED_AREA_IN: 'Entrance to the security zone',
            EVENT_PROTECTED_AREA: 'Exit from the security zone',
            EVENT_UNLOCKED: 'Disarming the vehicle',
            EVENT_LOCKED: 'Putting the car under protection',
            EVENT_CMD_ENGINE_ON: 'The command to start the engine has been sent',
            EVENT_CMD_ENGINE_OFF: 'The command to stop the engine was sent',
            EVENT_CMD_UNLOCK: 'A command to disarm has been sent',
            EVENT_CMD_LOCK: 'A team has been sent to secure it',
            EVENT_CMD_TRUNK_OPEN: 'A command was sent to open the trunk',
            EVENT_CMD_TRUNK_CLOSE: 'Sent a command to close the trunk',
            EVENT_CMD_LIGHT: 'The flash lights command was sent',
            EVENT_CMD_BEEP: 'The beep command has been sent',
            EVENT_LOW_BATTERY_VOLTAGE: 'Low battery charge',
            EVENT_ALARM_SYSTEM_TRIGGERED: 'Triggering of the standard alarm',
            EVENT_VEH_UNLOCKED_ALERT: 'The door locks are not closed',
            EVENT_NOT_SET: 'Not set',
            EVENTS_SUBS: 'Events subscribtion',
            EVENTS_SUBS_DESCR:
                "You can subscribe to events related to this vehicle. If they occur, you'll receive a notification to the email address specified in your profile.",
            EVENTS_SUBS_CREATE_SUCCESS: 'Subscribe successfuly added',
            EVENTS_SUBS_DELETE_SUCCESS: 'Unsubscribed',

            // Events on map
            MAP_EVENTS: 'Events',
            MAP_EVENTS_DESCR: 'Choose the event groups to display on the map',
            MAP_EVENTS_SECURE: 'Secure',
            MAP_EVENTS_SECURE_ADD: 'On/off',
            MAP_EVENTS_ENGINE: 'Engine',
            MAP_EVENTS_ENGINE_ADD: 'Start/stop',
            MAP_EVENTS_TRUNK: 'Trunk',
            MAP_EVENTS_TRUNK_ADD: 'Open/close',
            MAP_EVENTS_ZONE: 'Secure zone',
            MAP_EVENTS_ZONE_ADD: 'Enter/exit',
            MAP_EVENTS_LIGHT: 'Light and signal',
            MAP_EVENTS_MILEAGE: 'Reducing mileage',
            MAP_EVENTS_VOLTAGE: 'Low battery charge',
            MAP_EVENTS_ALL: 'Show all',
            MAP_EVENTS_ALARM_SYSTEM_TRIGGERED: 'Triggering of the standard alarm',

            // Application errors
            ERROR: 'Error',
            ENotFound: 'Not found',
            EUnknown: 'Application error [#2]. Please inform the administrator!',
            ECursor: 'Application error [#3]. Please inform the administrator!',
            EQuery: 'Application error [#4]. Please inform the administrator!',
            EUuid: 'Application error [#5]. Please inform the administrator!',
            EUpdate: 'No rows affected by update',
            ECaptchaExpired: 'Captcha is expired',
            ECaptchaCheckError: 'Captcha check error',
            ECaptchaError: 'Captcha error',
            ECodeExpired: 'Code is expired',
            ECodeCheckError: 'Code check error',
            ECodeError: 'Code error',
            ETokenExpired: 'Token is expired, please authorize',
            ETokenError: 'Token is invalid, please try refresh page or repeat authorization',
            EUserEmail: 'Email not valid or empty',
            EUserPassword: 'Password not valid or empty',
            EPassword: 'The entered password does not meet the minimum security requirements',
            EPasswordOrCode: 'Error receiving verification code, please re-enter',
            EUserEmailAlreadyExist: 'This e-mail address has already been used for one of the users',
            EUserPhoneAlreadyExist: 'This phone number is already listed for one of the users',
            EUserNotFound: 'User not found',
            EUserEmptyPasswordOrCode: 'Password or code empty',
            EUserPermissionDenied: 'Permission denied',
            EUserFromContext: 'User value not stored in ctx',
            EUserSelfDelete: 'User try to self delete',
            EUserSelfUGroup: 'You cannot change the user group for yourself',
            EUserSelfLock: 'Are you trying to ban yourself?...',
            EUserSendCode: 'Send code error',
            EUserAlreadyDeleted: 'User already deleted',
            EUserCarsNotFound: 'No cars available',
            EUserCursor: 'Error getting list of users page',
            EConnection: 'Reqesst error: Internet connection have been lost or server is unavailable',
            EEcuFileAlreadyDeleted: 'This file has been deleted',
            EEcuFileNotFound: 'Files not found',
            EEcuFileCursor: 'Application error, please inform the administrator!',
            EEcuFileName: 'EEcuFileName',
            EEcuFileVersion: 'EEcuFileVersion',
            EEcuFileAuthor: 'EEcuFileAuthor',
            EEcuFileType: 'EEcuFileType',
            EEcuFileUuidOrBlock: 'Application error, please inform the administrator!',
            EUnauthRequest: 'Request failed: please log-in first',
            EFormFields: 'Form fields error',
            EPasswordShort: 'Password must be longer than 6 symbols',
            EEcuNotFound: 'ECU`s with the specified data were not found',
            EEcuAlreadyDeleted: 'This ECU has already been deleted',
            EEcuCarNotFound: 'ECU`s not found',
            EWSNotSuport: 'Your browser does not support websocket technology',
            EWSError: 'Application error, please inform the administrator!',
            EWSDisconnected: 'The data server is unavailable',
            EGarageNumber: 'Incorrect garage number',
            EStartAfterStopOrEqual: 'The start time is greater than or equal to the end time of monitoring',
            EInvalidArgument: 'Application error [#2]. Please inform the administrator!',
            EPermissionDenied: 'Access denied',
            ERequestUserHeaders: 'Error when trying to send a request with custom headers',
            EIccid: 'ICC ID not valid',
            EEiccid: 'ERA ICC ID not valid',
            ECertificateAlreadyExist: 'Certificate Already Exist',

            EEgtsFirmwareAlreadyExist: 'Firmware already exist',
            EEgtsParamNotFound: 'Param not found',
            EEgtsModuleNotFound: 'Egts module not found',
            EEgtsFirmwareNotFound: 'Software files are not found',
            EEgtsReportNotFound: 'No diagnostic records found',
            ECommandSendTimeOut: 'Command not sent [send timeout]',
            ECommandNotFound: 'Command not found',
            ECommandSendError: 'Command send error',
            ECommandDataOverflow: 'Command data to big',
            ECommandResponseUnknown: 'Default, unknown error',
            ECommandResponseNotRespond: 'ECU not respond',
            ECommandResponseUnknownCommand: 'Unknown command',
            ECommandResponseUnknownAddress: 'Unknown address ECU',
            ECommandResponseIgnitionIsOff: 'To execute this command, turn on the ignition',
            ECommandResponseIgnitionIsOn: 'To execute this command, turn off the ignition',
            ECommandResponseDoorIsUnlock: 'To execute this command, lock the doors',
            ECommandResponseLowFuelLevel: 'Insufficion fuel in the tank to execute this command',
            ECommandResponseLowSoC: 'The battery charge is too low to execute this command',
            ECommandResponseEngineRemoteStartNotSupport: 'Remote engine start is not supported',
            ECommandResponseEngineRemoteStartModeNeeded:
                'To execute the command, it is required that the car be in remote start mode',
            ECommandResponseParkingModeOfTCUNeeded: 'To execute this command, switch the transmission to parking mode',

            EEventNotFound: 'Events for the specified time period were not found',
            EFileName: 'The file with the specified name was not found',
            EPhone: 'Error when entering a phone number',
            ECarPermissionGranted: 'Access to all cars',
            ELogNotFound: 'Logs not found',
            EVin: 'No VIN-code selection',
            EUserAlreadyExist: 'User with this email or phone already exist',
            EEmail: 'Invalid characters in the E-mail field',
            EEmailOrPhone: 'Account not found',
            EFavoriteFound:
                'There are no favorite cars. You can assign favorite cars by clicking on the star icon in the car card from the list.',

            // Cars & car types
            ECarAlreadyDeleted: 'This car has already been deleted',
            ECarAlreadyExist: 'This car has already exist',
            ECarImeiAlreadyExist: 'Car with this IMEI already exist',
            ECarNumber: 'Incorrect car number',
            ECarPointNotFound: 'Route entries for the selected time period were not found',
            ECarUserNotFound: 'Car users not found',
            ECarNotOnLine: 'Device is not online',
            ECarPermissionDenied: 'You do not have access to this information',
            ECarNotFound: 'Cars with the specified data were not found',
            ECarTypeAlreadyExist: 'Car type already exits',
            ECarTypeNotFound: 'Car type not found',
            ECarPointAlreadyExist: 'Car point already exist',
            ECarStateNotFound: 'Car state not found',
            ECarTypeCursor: 'Car types request failed',
            ECarVinAlreadyExist: 'This VIN-code has already been used for one of the cars',
            ECarAlreadyHasAnOwner: 'The car already has an owner',

            // Certificates errors
            ECertificateNotFound: 'Certificates not found',

            // Groups
            EGroupsNotFound: 'Groups not found',
            EGroupUsersNotFound: 'There are no users in the group',
            EGroupCarsNotFound: 'There are no cars in the group',
            EGroupCarAlreadyExist: 'This car is already in the group',
            EUGroupNotFound: 'Users groups not found',
            ECGroupNotFound: 'Cars groups not found',

            ECarTripsNotFound: 'No trips found for the specified time period',

            ECarChargingsNotFound: 'No charging statistics for the specified time period',

            ELinkAlreadyExist:
                'This link already exists. Edit the entry in the list of added contacts or delete it and create a new one.',
            ELinkNotFound: 'Links not found',

            EUserVerifyLink:
                'It looks like your email confirmation code is invalid. Please check the link or request an email with the code again.',

            EEventParamAlreadyExist:
                'You are trying to create a parameter that already exists. To change a parameter, use the editing form in the list of parameters.',

            EAreaAlreadyExist: 'Area with this name already exists',

            ERROR_NEED_REAUTH_TITLE: 'Re-authorization required',
            ERROR_NEED_REAUTH_TEXT: 'Your profile information has been changed. You must re-authorize.',
            ERROR_NEED_REAUTH_BTN: 'Authorization',

            // Online graph
            CHART_ONLINE_TEST:
                'The component is working in test mode. The data on the charts is created by the simulator',
            CHART_ONLINE_TITLE: 'Live graph',
            CHART_ONLINE_SEARCH: 'Search params',
            CHART_ONLINE_SEARCH_DESCR: 'Enter the name or part of the parameter name',
            CHART_ONLINE_SHOW_GRID: 'Show grid',
            CHART_ONLINE_ERROR_TOKEN: 'Authorization error on the data server',
            CHART_ONLINE_ERROR_1: 'Error parsing the received data',
            CHART_ONLINE_TIMEOUT: 'The device is not responding: it may be busy. Try requesting the data later',
            CHART_ONLINE_PERIOD: 'Update frequency [sec.]',

            WS_INDICATOR_TITLE: 'Restoring connect...',
            WS_INDICATOR_TEXT: 'Online data is temporarily unavailable.',

            // Logs
            LOGS: 'Logs',
            LOG: 'Log',
            LOGS_TYPE: 'Logs type',
            LOGS_TYPE_EGTS: 'Cars',
            LOGS_TYPE_GRPC: 'Users',
            LOGS_VIN: 'VIN',
            LOGS_VIN_MODAL: 'Select car',
            LOGS_USER_MODAL: 'Select user',
            LOGS_DATE: 'Date',
            LOGS_USER: 'User',
            LOGS_USER_ALL: 'All users',
            LOGS_GEO: 'Event geo',
            LOGS_ACTION: 'Action',
            LOGS_ACTION_LOGIN: 'Login',
            LOGS_ACTION_DELETE: 'Delete',
            LOGS_ACTION_INSERT: 'Insert',
            LOGS_ACTION_UPDATE: 'Update',
            LOGS_ACTION_WRITE: 'Write',
            LOGS_ACTION_SEND_CMD: 'Send CMD',
            LOGS_ACTION_SEND_NOTI: 'Send notification',
            LOGS_ACTION_SEND_PARAMS: 'Send params',
            LOGS_ITEM_DATE: 'Date',
            LOGS_ITEM_GEO: 'Location',
            LOGS_ERROR_NO_PARAMS: 'Select params to request logs',

            // Car colors
            CAR_COLOR_BLACK_COPPER: 'Black copper',
            CAR_COLOR_BLUE_MAGIC: 'Blue magic',
            CAR_COLOR_DEEP_FOREST: 'Deep forest',
            CAR_COLOR_DESERT_RED: 'Desert red',
            CAR_COLOR_DESERT_TAUPE: 'Desert taupe',
            CAR_COLOR_GALANT_GREY: 'Galant grey',
            CAR_COLOR_GRAPHITE_TRACE: 'Graphite trace',
            CAR_COLOR_LATTE_MACCHIATO: 'Latte macchiato',
            CAR_COLOR_LUSTRE_WHITE: 'Lustre white',
            CAR_COLOR_NOT_SET: 'Not set',
            CAR_COLOR_PORCELAIN: 'Porcelain',
            CAR_COLOR_PULSAR_BLUE: 'Pulsar blue',
            CAR_COLOR_RUSSIAN_GOLD: 'Russian gold',
            CAR_COLOR_SHADE_OF_NIGHT: 'Shade of night',
            CAR_COLOR_SILVER_LINING: 'SIlver lining',
            CAR_COLOR_SUNSET_GOLD: 'Sunset gold',
            CAR_COLOR_UNIVERSE_BLACK: 'Universe black',
            CAR_COLOR_VELVET_RUBY: 'Velvet ruby',

            // ECU`s
            ECUS_ADDITIONAL: 'Additional info',
            ECUS_STATUS_DESCR: 'Status description',
            ECUS_DESCR_BADGES: 'Badges',
            ECUS_DESCR_SDM: 'SDM',
            ECUS_DESCR_SDM_ONLINE: 'SDM online',
            ECUS_DESCR_SDM_NOSATELLITES: 'SDM online, no satellites connection',
            ECUS_DESCR_SDM_OFFLINE: 'SDM offline',
            ECUS_DESCR_ICON_ERROR: 'Number of active errors',
            ECUS_DESCR_ICON_PASSIVE: 'Number of passive errors',
            ECUS_DESCR_ICON_WARNING: 'Warnings',
            ECUS_DESCR_BG: 'ECU colors',
            ECUS_DESCR_BG_ONLINE: 'Without errors / with passive errors',
            ECUS_DESCR_BG_OFFLINE: 'No diagnostics for more than 30 days',
            ECUS_DESCR_BG_ERROR: 'With active errors',
            ECUS_DESCR_BG_NO_INFO: 'No Data',

            // ECU
            ECU_NAME: 'Unit',
            ECU_DATE: 'Date',
            ECU_EXPORT: 'Export report',
            ECU_INFO: 'Information',
            ECU_MODULES: 'Modules',
            ECU_MODULES_INFO_EMPTY: 'No information about modules',

            ECU_MODULES_MAIN: 'Main module',
            ECU_MODULES_IO: 'I/O module',
            ECU_MODULES_NAVI: 'Navigation module',
            ECU_MODULES_WIRELESS: 'Wireless module',
            ECU_MODULES_INTERFACE: 'Interface mosule',
            ECU_MODULES_BOOTLOADER: 'Bootloader module',
            ECU_MODULES_CONFIG: 'Device configuration',
            ECU_MODULES_UNKNOWN: 'Unknown device',

            ECU_ERRORS: 'Errors',
            ECU_ERRORS_ONLY_ACTIVE: 'Only active',
            ECU_REPORTS: 'Reports',
            ECU_REPORTS_DISABLED: 'Charts online / Online telemetry: development is on hold',
            ECU_REPORTS_HISTORY: 'Reports history',
            ECU_REPORTS_DELETE: 'Delete reports',
            ECU_REPORTS_DELETE_DESCR:
                'This action will delete all reports about the vehicle. Are you sure you want to do this?',
            ECU_REPORTS_DELETE_SUCCESS:
                'The block`s reports have been successfully deleted. Please refresh the report if you want to get information about this block.',
            ECU_SERIAL: 'Serian no.',
            ECU_HARDWARE: 'Hardware',
            ECU_FIRMWARE: 'Firmware',
            ECU_VIN: 'ECU VIN',
            ECU_CALIBRATION: 'Calibration',
            ECU_MILEAGE: 'Milleage',
            ECU_SOFTWARE: 'Software',
            ECU_TIMESTAMP: 'Last diagnistic time',
            ECU_ODX_VERSION: 'ODX file version',
            ECU_ERRORS_EMPTY: 'No errors detected',
            ECU_FILE: 'Files',
            ECU_REMOVE: 'Delete',
            ECU_PARAMS: 'Params',
            ECU_PARAMS_DESCR:
                'Set the checkbox in the Data field to send the number in hexadecimal format. When requesting the status of parameters, the "Data" field with a yellow background means that the parameter has been created, but not sent to the SDM block. The "Data" field with a green outline and a check mark indicates that the SDM block receives the parameter.',
            ECU_PARAMS_NO_INFO: 'No information about block parameters',
            ECU_PARAMS_EMPTY: 'Block parameters are not set. Create them via the command submission form.',
            ECU_PARAM_CREATE_SUCCESS: 'New parameter successfuly added',
            ECU_PARAM_UPDATE: 'Param update',
            ECU_PARAM_UPDATE_SUCCESS: 'Param successfuly updated',
            ECU_PARAM_DELETE: 'Delete param',
            ECU_PARAM_DELETE_TEXT: 'This setting will be permanently deleted. Are you sure you want to remove it?',
            ECU_PARAM_DELETE_SUCCESS: 'The parameter was successfully removed from the block',

            ECU_SDM_REBOOT: 'Reboot SDM',
            ECU_SDM_REFRESH: 'Refresh data',
            ECU_SDM_FIRMWARES: 'Firmwares',
            ECU_SDM_LOGS: 'Logs',
            ECU_SDM_UPDATE_DIAG: 'Update Diag-CAN',
            ECU_SDM_DESCR: 'Description',
            ECU_SDM_SOFTWARE: 'Software',
            ECU_SDM_UPDATE_NAVI: 'Navigation update',
            ECU_SDM_MANUFACTORER: 'Manufactorer code',
            ECU_SDM_CREATE_DATE: 'Hardware',
            ECU_SDM_UPDATE_PARAMS: 'Update Body-CAN',
            ECU_SDM_MODIFICATION: 'Modification',
            ECU_SDM_TID: 'id SDM',
            ECU_SDM_SET_SERVER: 'Set data server',
            ECU_SDM_SEND_CMD: 'Send CMD',
            ECU_SDM_ONLINE_DATE: 'Last contact time',
            ECU_SDM_SET_PARAMS_TITLE: 'Params [set / check]',
            ECU_SDM_CMD: 'Commands',
            ECU_SDM_CMD_TITLE: 'CMD [params]',

            ECU_FIRMWARE_CREATE_SUCCESS:
                'The firmware file has been successfully uploaded to the server. Wait for the download to the device',
            ECU_FIRMWARE_DELETE_SUCCESS: 'The firmware file has been successfully deleted',

            FAVORITE_CARS: 'Favourites',
            FAVORITE_CARS_ADD: 'Add favorites',
            FAVORITE_CARS_EMPTY: 'There are no favorite cars. Click "Add" and select the desired cars from the list',
            FAVORITE_CARS_CREATE_SUCCESS: 'Car successfully added to favorites',
            FAVORITE_CARS_CREATE_FAILURE:
                'An error occurred while trying to add a favorite vehicle. Notify the administrator!',
            FAVORITE_CARS_DELETE_HEADER:
                'An error occurred while trying to delete a favorite vehicle. Notify the administrator!',
            FAVORITE_CARS_DELETE_DESCR:
                'An error occurred while trying to delete a favorite vehicle. Notify the administrator!',
            FAVORITE_CARS_DELETE_FAILURE:
                'An error occurred while trying to delete a favorite vehicle. Notify the administrator!',
            FAVORITE_CARS_ERROR_DATA:
                'An error occurred while trying to get favorite cars. Please retry your request later',

            // MANUALS
            MANUAL_CAR: 'Vehicle Operation manual',
            MANUAL_MMS: 'Multimedia system operation manual',

            COPYRIGHT: 'Provided by FSUE "NAMI", 2022',

            // 404
            NOTFOUND_SUBTITLE: 'Page not found',
            NOTFOUND_LINK: 'To the main',

            CERTIFICATES: 'Certificates',
            CERTIFICATES_ISSUE: 'Issue',
            CERTIFICATES_CRT: 'Crt',
            CERTIFICATES_KEY: 'Key',
            CERTIFICATES_CREATE: 'Issue certificate',
            CERTIFICATES_CREATE_SUCCESS: 'Certificate successfuly issued',
            CERTIFICATES_UPDATE: 'Re-issue sertificate',
            CERTIFICATES_UPDATE_SUCCESS: 'Certificate successfuly re-issued',
            CERTIFICATES_DELETE: 'Removing a certificate',
            CERTIFICATES_DELETE_DESCR:
                'This certificate will be permanently deleted. Are you sure you want to do this?',
            CERTIFICATES_DELETE_SUCCESS: 'Certificate deleted',
            CERTIFICATES_CHANGE_WARN: 'WARNING! When you create a new certificate, the old one will be deleted!',
            CERTIFICATES_DATE_START: 'Start date',
            CERTIFICATES_DATE_STOP: 'End date',
            CERTIFICATES_IMEI: 'IMEI',
            CERTIFICATES_INFO: 'Certificate description',
            CERTIFICATES_DOWNLOAD_CRT: 'Download CRT',
            CERTIFICATES_DOWNLOAD_KEY: 'Download KEY',

            // Areas
            AREAS_LIST: 'List of areas',
            AREAS_NONE: 'No areas',
            AREAS_NOT_FOUND: 'Areas not found',
            AREAS_CREATE: 'Create area',
            AREAS_DELETE: 'Delete area',
            AREAS_EDIT: 'Edit area',
            AREAS_DELETE_TEXT:
                'This area will be deleted without possibility of restoration. Are you sure you want to delete it?',
            AREAS_SEARCH_PLACEHOLDER: 'Search by name, UUID',
            AREAS_SEARCH_MESSAGE: 'Enter at least 3 symbols',
            AREAS_FIGURE_TYPE: 'Figure type',
            AREAS_FIGURE_STROKE: 'Line color',
            AREAS_FIGURE_FILL: 'Fill color',
            AREAS_FIGURE_THICKNESS: 'Thickness',
            AREAS_ENTER_NAME: 'Enter area name',
            // AREAS_ENTER_DESCRIPTION:      'Enter area description',
            AREAS_ENTER_ZINDEX: 'Enter Z-Index',
            AREAS_DRAW_MESSAGE: 'Draw area on map',
            AREAS_NAME: 'Areas name',
            AREAS_DESCRIPTION: 'Areas description',
            AREAS_RADIUS: 'Radius',
            AREAS_ZINDEX: 'Z-Index',
            AREAS_ANGLE: 'Angle',
            AREAS_JSON_ERROR: 'Error parsing JSON',
            AREA: 'Area',
            AREA_CREATE_SUCCESS: 'New area added',
            AREA_UPDATE_SUCCESS: 'Area updated',
            AREA_DELETE_SUCCESS: 'Area deleted',
            AREA_ISSTROKE: 'Area outline',
            EAreaNotFound: 'Areas not found',

            // Геозоны автомобиля
            CAR_AREAS_CTRL_TITLE: 'Configure area of car',
            // CAR_AREAS_ADD_TITLE:          'Add area to car',
            // CAR_AREAS_EDIT_TITLE:         'Edit cars area',
            CAR_AREAS_DELETE_TITLE: 'Delete event of cars area',
            CAR_AREAS_DELETE_TEXT:
                'This event of cars area will be permanently deleted. Are you sure you want to delete it?',

            CAR_AREAS_AREA: 'Area',
            CAR_AREAS_EVENT: 'Event',
            AREA_IN: 'Entrance to the zone',
            AREA_OUT: 'Leaving the zone',
            // CAR_AREAS_NOT_FOUND:          'Event params not found',
            CAR_AREAS_CREATE_SUCCESS: 'Event of area added',
            CAR_AREAS_DELETE_SUCCESS: 'Event of areas deleted',
            EEventParamNotFound: 'Event of areas not found',

            CAR_ROUTES: 'Routes',

            EImei: 'Incorrect IMEI entered',

            DOCS_LECENSE: 'End User License Agreement',
            DOCS_PRIVACY: 'Privacy Policy',

            TOKEN_BAD_REQUEST: 'Token request failed.',
            TOKEN_REPEAT_REQUEST: 'Repeat after',

            CAR_WARNINGS_CODE: 'Code',
            CAR_WARNINGS_CATEGORY: 'Category',
            CAR_WARNINGS_DESCR: 'Description',
            CAR_WARNINGS_RECOMMENDATIONS: 'Recomendations',

            // Расшифровка VIN
            BODY_UNKNOWN: 'Unknown model',
            BODY_AURUS_SEDAN: 'Senat',
            BODY_AURUS_SUV: 'Komendant',
            BODY_AURUS_MPV: 'Arsenal',
            BODY_UAZ_PATRIOT: 'УАЗ Патриот',
            BODY_UAZ_SGR: 'УАЗ СГР',
            BODY_UAZ_PICKUP: 'УАЗ Пикап',
            BODY_UAZ_PROFI: 'УАЗ Профи',
            BODY_UAZ_HUNTER: 'УАЗ Хантер',

            ENGINE_UNKNOWN: 'Unknown engine type',
            ENGINE_L4: 'L4',
            ENGINE_V8: 'V8',
            ENGINE_V6: 'V6',
            ENGINE_V12: 'V12',
            ENGINE_D4: 'D4',
            ENGINE_D6: 'D6',
            ENGINE_D8: 'D8',

            MF_UNKNOWN: 'Unknown manufacturer',
            MF_NAMI_PLANT: 'FSUE «NAMI», c. Moscow',
            MF_UAZ_PLANT: 'LLC «UAZ», c. Ulyanovsk',
            MF_AUTODOM_PLANT: 'LLC «AVTODOM»',
            MF_EAA_PLANT: 'LLC «Aurus»',

            MOD_UNKNOWN: 'Unknown body',
            MOD_SEDAN: 'Sedan non armored',
            MOD_SEDAN_ARMORED: 'Sedan armored',
            MOD_LIMO_V12: 'Limo armored V12',
            MOD_LIMO_V8: 'Limo armored V8',
            MOD_CABRIO: 'Cabrio',
            MOD_SEDAN_4X2: 'Sedan 4x2',
            MOD_SEDAN_LONG: 'Sedan Long',
            MOD_SEDAN_LONG_ARMORED: 'Sedan Long armored',
            MOD_CABRIO_SHOW: 'Cabrio show',
            MOD_LIMO_V8_CIVIL: 'Limo armored V8 civil',
            MOD_SUV: 'SUV non armored',
            MOD_SUV_ARMORED: 'SUV armored',
            MOD_MPV_4SEAT: 'MPV, non armored, 4 seats',
            MOD_MPV_8SEAT_ARMORED: 'MPV, armored, 8 seats',
            MOD_MPV_9SEAT: 'MPV, non armored, 9 seats',
            MOD_MPV_9SEAT_ARMORED: 'MPV, armored, 9 seats',
            MOD_MPV_4SEAT_ARMORED: 'MPV, armored, 4 seats',
            MOD_MPV_ORBITA: 'MPV, Orbita',
            MOD_MPV_TABLETKA: 'MPV, Tabletka',
            MOD_PATRIOT: 'УАЗ Патриот (легковой)',
            MOD_SGR_330365: 'Бортовой с однорядной кабиной',
            MOD_SGR_374195: 'Грузовой фургон',
            MOD_SGR_390995: 'Комби, фургон, разделенный перегородкой',
            MOD_SGR_390945: 'Бортовой с двухрядной кабиной',
            MOD_SGR_220695: 'Пассажирский',
            MOD_SGR_396221: 'Для перевозки заключенных',
            MOD_SGR_396222: 'Для дежурной части',
            MOD_SGR_396223: 'Скорая помощь',
            MOD_SGR_396295: 'Санитарный',
            MOD_PICKUP_SPECIAL: 'Специальный',
            MOD_PICKUP_REGULAR: 'Обычный, с двухрядной кабиной',
            MOD_PROFI_236021: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236022: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236031: 'Бортовой или фургон с однорядной кабиной',
            MOD_PROFI_236323: 'Бортовой или фургон, с двухрядной кабиной',
            MOD_PROFI_236324: 'Бортовой или фургон, с двухрядной кабиной',
            MOD_PROFI_CHILD: 'Пассажирский для детей 6-16 лет',
            MOD_PROFI_PASSENGER: 'Пассажирский',
            MOD_PROFI_AMBULANCE: 'Пассажирский, скорая помощь',
            MOD_HUNTER: 'УАЗ Хантер'
        }
    }

    return {
        translates,
        getTranslate
    }
})
